// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,json_types=true"
// @generated from file abacus/v2/abacus.proto (package abacus.v2, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Dimension, DimensionJson, ExportField, ExportFieldJson, Metric, MetricJson } from "./fields_pb";
import { file_abacus_v2_fields } from "./fields_pb";
import type { ConversionType, ConversionTypeJson, EntryPoint, EntryPointJson, Event, EventJson, User, UserJson } from "../../bundles/v1/bundle_pb";
import { file_bundles_v1_bundle } from "../../bundles/v1/bundle_pb";
import type { GeoLocation, GeoLocationJson } from "../../bundles/v1/common_pb";
import { file_bundles_v1_common } from "../../bundles/v1/common_pb";
import type { GeoLocationSource, GeoLocationSourceJson } from "../../bundles/v1/events_pb";
import { file_bundles_v1_events } from "../../bundles/v1/events_pb";
import { file_common_v1_annotations } from "../../common/v1/annotations_pb";
import type { Order, OrderJson, PaginationArguments, PaginationArgumentsJson, PaginationPageInfo, PaginationPageInfoJson } from "../../common/v1/pagination_pb";
import { file_common_v1_pagination } from "../../common/v1/pagination_pb";
import type { Creator, CreatorJson } from "../../common/v1/types_pb";
import { file_common_v1_types } from "../../common/v1/types_pb";
import { file_google_api_annotations } from "../../google/api/annotations_pb";
import type { FieldMask, FieldMaskJson, StructJson, Timestamp, TimestampJson, Value, ValueJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date, DateJson } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { MappedValue, MappedValueJson } from "../../workflows/v1/workflows_pb";
import { file_workflows_v1_workflows } from "../../workflows/v1/workflows_pb";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file abacus/v2/abacus.proto.
 */
export const file_abacus_v2_abacus: GenFile =
	/*@__PURE__*/
	fileDesc(
		"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",
		[file_abacus_v2_fields, file_bundles_v1_bundle, file_bundles_v1_common, file_bundles_v1_events, file_common_v1_annotations, file_common_v1_pagination, file_common_v1_types, file_google_api_annotations, file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_protobuf_timestamp, file_google_type_date, file_workflows_v1_workflows],
	);

/**
 * TimeRange represents a range of time which can be used
 * in custom interval requests.
 *
 * @generated from message abacus.v2.TimeRange
 */
export type TimeRange = Message<"abacus.v2.TimeRange"> & {
	/**
	 * Start time is exclusive.
	 *
	 * @generated from field: google.protobuf.Timestamp start_time = 1;
	 */
	startTime?: Timestamp | undefined;

	/**
	 * End time is inclusive.
	 *
	 * @generated from field: google.protobuf.Timestamp end_time = 2;
	 */
	endTime?: Timestamp | undefined;

	/**
	 * Days are for last "X" days requests
	 *
	 * @generated from field: optional int32 days = 3;
	 */
	days?: number | undefined;
};

/**
 * TimeRange represents a range of time which can be used
 * in custom interval requests.
 *
 * @generated from message abacus.v2.TimeRange
 */
export type TimeRangeJson = {
	/**
	 * Start time is exclusive.
	 *
	 * @generated from field: google.protobuf.Timestamp start_time = 1;
	 */
	startTime?: TimestampJson;

	/**
	 * End time is inclusive.
	 *
	 * @generated from field: google.protobuf.Timestamp end_time = 2;
	 */
	endTime?: TimestampJson;

	/**
	 * Days are for last "X" days requests
	 *
	 * @generated from field: optional int32 days = 3;
	 */
	days?: number;
};

/**
 * Describes the message abacus.v2.TimeRange.
 * Use `create(TimeRangeSchema)` to create a new message.
 */
export const TimeRangeSchema: GenMessage<TimeRange, { jsonType: TimeRangeJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 0);

/**
 * Coordinate represents a location for
 * geo summary requests.
 *
 * @generated from message abacus.v2.Coordinate
 */
export type Coordinate = Message<"abacus.v2.Coordinate"> & {
	/**
	 * @generated from field: float x = 1;
	 */
	x: number;

	/**
	 * @generated from field: float y = 2;
	 */
	y: number;
};

/**
 * Coordinate represents a location for
 * geo summary requests.
 *
 * @generated from message abacus.v2.Coordinate
 */
export type CoordinateJson = {
	/**
	 * @generated from field: float x = 1;
	 */
	x?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float y = 2;
	 */
	y?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message abacus.v2.Coordinate.
 * Use `create(CoordinateSchema)` to create a new message.
 */
export const CoordinateSchema: GenMessage<Coordinate, { jsonType: CoordinateJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 1);

/**
 * Viewport is an area defined by
 * min and max coordinates used for
 * filtering in GeoSummarys.
 *
 * @generated from message abacus.v2.Viewport
 */
export type Viewport = Message<"abacus.v2.Viewport"> & {
	/**
	 * The defined min coordinate.
	 *
	 * @generated from field: abacus.v2.Coordinate min = 1;
	 */
	min?: Coordinate | undefined;

	/**
	 * The defind max coordinate.
	 *
	 * @generated from field: abacus.v2.Coordinate max = 2;
	 */
	max?: Coordinate | undefined;
};

/**
 * Viewport is an area defined by
 * min and max coordinates used for
 * filtering in GeoSummarys.
 *
 * @generated from message abacus.v2.Viewport
 */
export type ViewportJson = {
	/**
	 * The defined min coordinate.
	 *
	 * @generated from field: abacus.v2.Coordinate min = 1;
	 */
	min?: CoordinateJson;

	/**
	 * The defind max coordinate.
	 *
	 * @generated from field: abacus.v2.Coordinate max = 2;
	 */
	max?: CoordinateJson;
};

/**
 * Describes the message abacus.v2.Viewport.
 * Use `create(ViewportSchema)` to create a new message.
 */
export const ViewportSchema: GenMessage<Viewport, { jsonType: ViewportJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 2);

/**
 * Contact source is the suite with which
 * the contact interacted.
 *
 * @generated from message abacus.v2.ContactSource
 */
export type ContactSource = Message<"abacus.v2.ContactSource"> & {
	/**
	 * id of the org.
	 *
	 * @generated from field: string org_id = 7;
	 */
	orgId: string;

	/**
	 * id of the workspace.
	 *
	 * @generated from field: string workspace_id = 4;
	 */
	workspaceId: string;

	/**
	 * id of the suite.
	 *
	 * @generated from field: string suite_id = 1;
	 */
	suiteId: string;

	/**
	 * Name of the suite.
	 *
	 * @generated from field: string suite_name = 2;
	 */
	suiteName: string;

	/**
	 * Total number of suites they interacted with.
	 *
	 * @generated from field: int32 suite_count = 3;
	 */
	suiteCount: number;

	/**
	 * id of the initial integration source.
	 *
	 * @generated from field: string connection_id = 5;
	 */
	connectionId: string;

	/**
	 * name of the initial integration source
	 *
	 * @generated from field: string integration_name = 6;
	 */
	integrationName: string;
};

/**
 * Contact source is the suite with which
 * the contact interacted.
 *
 * @generated from message abacus.v2.ContactSource
 */
export type ContactSourceJson = {
	/**
	 * id of the org.
	 *
	 * @generated from field: string org_id = 7;
	 */
	orgId?: string;

	/**
	 * id of the workspace.
	 *
	 * @generated from field: string workspace_id = 4;
	 */
	workspaceId?: string;

	/**
	 * id of the suite.
	 *
	 * @generated from field: string suite_id = 1;
	 */
	suiteId?: string;

	/**
	 * Name of the suite.
	 *
	 * @generated from field: string suite_name = 2;
	 */
	suiteName?: string;

	/**
	 * Total number of suites they interacted with.
	 *
	 * @generated from field: int32 suite_count = 3;
	 */
	suiteCount?: number;

	/**
	 * id of the initial integration source.
	 *
	 * @generated from field: string connection_id = 5;
	 */
	connectionId?: string;

	/**
	 * name of the initial integration source
	 *
	 * @generated from field: string integration_name = 6;
	 */
	integrationName?: string;
};

/**
 * Describes the message abacus.v2.ContactSource.
 * Use `create(ContactSourceSchema)` to create a new message.
 */
export const ContactSourceSchema: GenMessage<ContactSource, { jsonType: ContactSourceJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 3);

/**
 * Contact is an aggregate of user attributes
 * collected and/or calculated during a conversion event.
 * A single contact can represent multiple interactions by the same
 * Flow ID.
 *
 * @generated from message abacus.v2.Contact
 */
export type Contact = Message<"abacus.v2.Contact"> & {
	/**
	 * The Flowcode user associated with the Contact attributes.
	 *
	 * @generated from field: bundles.v1.User user = 1;
	 */
	user?: User | undefined;

	/**
	 * The number of times this contact has converted.
	 *
	 * @generated from field: int64 conversion_count = 2;
	 */
	conversionCount: bigint;

	/**
	 * The number of distinct conversions with which this User interacted.
	 *
	 * @generated from field: int64 distinct_conversion_count = 5;
	 */
	distinctConversionCount: bigint;

	/**
	 * Lifetime-value of the Contact.
	 *
	 * @generated from field: double ltv = 6;
	 */
	ltv: number;

	/**
	 * The source of the Contact.
	 *
	 * @generated from field: abacus.v2.ContactSource source = 7;
	 */
	source?: ContactSource | undefined;

	/**
	 * Whether or not the Contact has a cookie.
	 *
	 * @generated from field: bool has_cookie = 11;
	 */
	hasCookie: boolean;

	/**
	 * Whether or not the Contact is classified as a bot.
	 *
	 * @generated from field: bool is_bot = 12;
	 */
	isBot: boolean;

	/**
	 * Whether or not the contact is verified.
	 *
	 * @generated from field: bool is_verified = 13;
	 */
	isVerified: boolean;

	/**
	 * Whether or not the contact has any bot traffic.
	 *
	 * @generated from field: bool has_bot_data = 14;
	 */
	hasBotData: boolean;

	/**
	 * Last known location of the contact.
	 *
	 * @generated from field: bundles.v1.GeoLocation last_known_location = 16;
	 */
	lastKnownLocation?: GeoLocation | undefined;

	/**
	 * The timestamp of when the Contact first converted.
	 *
	 * @generated from field: google.protobuf.Timestamp first_converted_at = 3;
	 */
	firstConvertedAt?: Timestamp | undefined;

	/**
	 * The timestamp of when the Contact last converted.
	 *
	 * @generated from field: google.protobuf.Timestamp last_converted_at = 4;
	 */
	lastConvertedAt?: Timestamp | undefined;

	/**
	 * The timestamp of when the Contact last interacted.
	 * Please note that an "interaction" is not the same as a "conversion."
	 *
	 * @generated from field: google.protobuf.Timestamp last_interacted_at = 8;
	 */
	lastInteractedAt?: Timestamp | undefined;

	/**
	 * The timestamp of when the Contact was created/added.
	 *
	 * @generated from field: google.protobuf.Timestamp created_at = 10;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * The timestamp of when the Contact was last updated.
	 *
	 * @generated from field: google.protobuf.Timestamp updated_at = 15;
	 */
	updatedAt?: Timestamp | undefined;

	/**
	 * Properties to which the contact has submitted values in a conversion event.
	 * Properties are workspace-scoped.
	 *
	 * @generated from field: abacus.v2.ContactProperties properties = 9;
	 */
	properties?: ContactProperties | undefined;

	/**
	 * @generated from field: int64 attended_count = 17;
	 */
	attendedCount: bigint;
};

/**
 * Contact is an aggregate of user attributes
 * collected and/or calculated during a conversion event.
 * A single contact can represent multiple interactions by the same
 * Flow ID.
 *
 * @generated from message abacus.v2.Contact
 */
export type ContactJson = {
	/**
	 * The Flowcode user associated with the Contact attributes.
	 *
	 * @generated from field: bundles.v1.User user = 1;
	 */
	user?: UserJson;

	/**
	 * The number of times this contact has converted.
	 *
	 * @generated from field: int64 conversion_count = 2;
	 */
	conversionCount?: string;

	/**
	 * The number of distinct conversions with which this User interacted.
	 *
	 * @generated from field: int64 distinct_conversion_count = 5;
	 */
	distinctConversionCount?: string;

	/**
	 * Lifetime-value of the Contact.
	 *
	 * @generated from field: double ltv = 6;
	 */
	ltv?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * The source of the Contact.
	 *
	 * @generated from field: abacus.v2.ContactSource source = 7;
	 */
	source?: ContactSourceJson;

	/**
	 * Whether or not the Contact has a cookie.
	 *
	 * @generated from field: bool has_cookie = 11;
	 */
	hasCookie?: boolean;

	/**
	 * Whether or not the Contact is classified as a bot.
	 *
	 * @generated from field: bool is_bot = 12;
	 */
	isBot?: boolean;

	/**
	 * Whether or not the contact is verified.
	 *
	 * @generated from field: bool is_verified = 13;
	 */
	isVerified?: boolean;

	/**
	 * Whether or not the contact has any bot traffic.
	 *
	 * @generated from field: bool has_bot_data = 14;
	 */
	hasBotData?: boolean;

	/**
	 * Last known location of the contact.
	 *
	 * @generated from field: bundles.v1.GeoLocation last_known_location = 16;
	 */
	lastKnownLocation?: GeoLocationJson;

	/**
	 * The timestamp of when the Contact first converted.
	 *
	 * @generated from field: google.protobuf.Timestamp first_converted_at = 3;
	 */
	firstConvertedAt?: TimestampJson;

	/**
	 * The timestamp of when the Contact last converted.
	 *
	 * @generated from field: google.protobuf.Timestamp last_converted_at = 4;
	 */
	lastConvertedAt?: TimestampJson;

	/**
	 * The timestamp of when the Contact last interacted.
	 * Please note that an "interaction" is not the same as a "conversion."
	 *
	 * @generated from field: google.protobuf.Timestamp last_interacted_at = 8;
	 */
	lastInteractedAt?: TimestampJson;

	/**
	 * The timestamp of when the Contact was created/added.
	 *
	 * @generated from field: google.protobuf.Timestamp created_at = 10;
	 */
	createdAt?: TimestampJson;

	/**
	 * The timestamp of when the Contact was last updated.
	 *
	 * @generated from field: google.protobuf.Timestamp updated_at = 15;
	 */
	updatedAt?: TimestampJson;

	/**
	 * Properties to which the contact has submitted values in a conversion event.
	 * Properties are workspace-scoped.
	 *
	 * @generated from field: abacus.v2.ContactProperties properties = 9;
	 */
	properties?: ContactPropertiesJson;

	/**
	 * @generated from field: int64 attended_count = 17;
	 */
	attendedCount?: string;
};

/**
 * Describes the message abacus.v2.Contact.
 * Use `create(ContactSchema$)` to create a new message.
 */
export const ContactSchema$: GenMessage<Contact, { jsonType: ContactJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 4);

/**
 * Group is a group in a GroupedConversionRate
 *
 * @generated from message abacus.v2.Group
 */
export type Group = Message<"abacus.v2.Group"> & {
	/**
	 * @generated from field: google.protobuf.Value value = 1;
	 */
	value?: Value | undefined;

	/**
	 * @generated from field: string id = 2;
	 */
	id: string;

	/**
	 * @generated from field: string type = 3;
	 */
	type: string;
};

/**
 * Group is a group in a GroupedConversionRate
 *
 * @generated from message abacus.v2.Group
 */
export type GroupJson = {
	/**
	 * @generated from field: google.protobuf.Value value = 1;
	 */
	value?: ValueJson;

	/**
	 * @generated from field: string id = 2;
	 */
	id?: string;

	/**
	 * @generated from field: string type = 3;
	 */
	type?: string;
};

/**
 * Describes the message abacus.v2.Group.
 * Use `create(GroupSchema)` to create a new message.
 */
export const GroupSchema: GenMessage<Group, { jsonType: GroupJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 5);

/**
 * GroupedConversionRate is a representation of aggregate data
 * for a given group.
 *
 * @generated from message abacus.v2.GroupedConversionRate
 */
export type GroupedConversionRate = Message<"abacus.v2.GroupedConversionRate"> & {
	/**
	 * Group is the type we are grouping by
	 *
	 * @generated from field: google.protobuf.Value group = 1;
	 */
	group?: Value | undefined;

	/**
	 * Group id is the id of the group - only applicable for types with IDs
	 *
	 * @generated from field: string group_id = 8;
	 */
	groupId: string;

	/**
	 * Group type is the type of the group
	 *
	 * @generated from field: string group_type = 17;
	 */
	groupType: string;

	/**
	 * Groups are used for multi grouped requests
	 *
	 * @generated from field: repeated abacus.v2.Group groups = 18;
	 */
	groups: Group[];

	/**
	 * The number of scans.
	 *
	 * @generated from field: int64 scans = 2;
	 */
	scans: bigint;

	/**
	 * The number of clicks.
	 *
	 * @generated from field: int64 clicks = 7;
	 */
	clicks: bigint;

	/**
	 * The number of visits.
	 *
	 * @generated from field: int64 visits = 14;
	 */
	visits: bigint;

	/**
	 * The number of landing page views.
	 *
	 * @generated from field: int64 landing_page_views = 23;
	 */
	landingPageViews: bigint;

	/**
	 * The number of views.
	 *
	 * @generated from field: int64 views = 3;
	 */
	views: bigint;

	/**
	 * The number of conversions.
	 *
	 * @generated from field: int64 conversions = 4;
	 */
	conversions: bigint;

	/**
	 * The number of conversions without an email address.
	 *
	 * @generated from field: int64 anonymous_responses = 15;
	 */
	anonymousResponses: bigint;

	/**
	 * The number of unique visitors.
	 *
	 * @generated from field: int64 unique_visitors = 6;
	 */
	uniqueVisitors: bigint;

	/**
	 * The number of unique viewers.
	 *
	 * @generated from field: int64 unique_viewers = 22;
	 */
	uniqueViewers: bigint;

	/**
	 * The number of unique conversions.
	 *
	 * @generated from field: int64 unique_conversions = 20;
	 */
	uniqueConversions: bigint;

	/**
	 * The ratio of conversions to views.
	 *
	 * @generated from field: float conversion_rate = 5;
	 */
	conversionRate: number;

	/**
	 * The ratio of conversions to visits.
	 *
	 * @generated from field: float total_conversion_rate = 19;
	 */
	totalConversionRate: number;

	/**
	 * The ratio of unique conversions to unique visits.
	 *
	 * @generated from field: float unique_conversion_rate = 21;
	 */
	uniqueConversionRate: number;

	/**
	 * The number of contact conversions.
	 *
	 * @generated from field: int64 contact_conversions = 9;
	 */
	contactConversions: bigint;

	/**
	 * The number of purchase conversions.
	 *
	 * @generated from field: int64 purchase_conversions = 10;
	 */
	purchaseConversions: bigint;

	/**
	 * The number of form conversions.
	 *
	 * @generated from field: int64 form_conversions = 11;
	 */
	formConversions: bigint;

	/**
	 * The number of contacts downloaded conversions.
	 *
	 * @generated from field: int64 contacts_downloaded_conversions = 12;
	 */
	contactsDownloadedConversions: bigint;

	/**
	 * The number of external pixel conversions.
	 *
	 * @generated from field: int64 external_pixel_conversions = 13;
	 */
	externalPixelConversions: bigint;

	/**
	 * The number of file downloaded conversions.
	 *
	 * @generated from field: int64 file_downloaded_conversions = 16;
	 */
	fileDownloadedConversions: bigint;

	/**
	 * The number of poll completed conversions.
	 *
	 * @generated from field: int64 poll_completed_conversions = 24;
	 */
	pollCompletedConversions: bigint;
};

/**
 * GroupedConversionRate is a representation of aggregate data
 * for a given group.
 *
 * @generated from message abacus.v2.GroupedConversionRate
 */
export type GroupedConversionRateJson = {
	/**
	 * Group is the type we are grouping by
	 *
	 * @generated from field: google.protobuf.Value group = 1;
	 */
	group?: ValueJson;

	/**
	 * Group id is the id of the group - only applicable for types with IDs
	 *
	 * @generated from field: string group_id = 8;
	 */
	groupId?: string;

	/**
	 * Group type is the type of the group
	 *
	 * @generated from field: string group_type = 17;
	 */
	groupType?: string;

	/**
	 * Groups are used for multi grouped requests
	 *
	 * @generated from field: repeated abacus.v2.Group groups = 18;
	 */
	groups?: GroupJson[];

	/**
	 * The number of scans.
	 *
	 * @generated from field: int64 scans = 2;
	 */
	scans?: string;

	/**
	 * The number of clicks.
	 *
	 * @generated from field: int64 clicks = 7;
	 */
	clicks?: string;

	/**
	 * The number of visits.
	 *
	 * @generated from field: int64 visits = 14;
	 */
	visits?: string;

	/**
	 * The number of landing page views.
	 *
	 * @generated from field: int64 landing_page_views = 23;
	 */
	landingPageViews?: string;

	/**
	 * The number of views.
	 *
	 * @generated from field: int64 views = 3;
	 */
	views?: string;

	/**
	 * The number of conversions.
	 *
	 * @generated from field: int64 conversions = 4;
	 */
	conversions?: string;

	/**
	 * The number of conversions without an email address.
	 *
	 * @generated from field: int64 anonymous_responses = 15;
	 */
	anonymousResponses?: string;

	/**
	 * The number of unique visitors.
	 *
	 * @generated from field: int64 unique_visitors = 6;
	 */
	uniqueVisitors?: string;

	/**
	 * The number of unique viewers.
	 *
	 * @generated from field: int64 unique_viewers = 22;
	 */
	uniqueViewers?: string;

	/**
	 * The number of unique conversions.
	 *
	 * @generated from field: int64 unique_conversions = 20;
	 */
	uniqueConversions?: string;

	/**
	 * The ratio of conversions to views.
	 *
	 * @generated from field: float conversion_rate = 5;
	 */
	conversionRate?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * The ratio of conversions to visits.
	 *
	 * @generated from field: float total_conversion_rate = 19;
	 */
	totalConversionRate?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * The ratio of unique conversions to unique visits.
	 *
	 * @generated from field: float unique_conversion_rate = 21;
	 */
	uniqueConversionRate?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * The number of contact conversions.
	 *
	 * @generated from field: int64 contact_conversions = 9;
	 */
	contactConversions?: string;

	/**
	 * The number of purchase conversions.
	 *
	 * @generated from field: int64 purchase_conversions = 10;
	 */
	purchaseConversions?: string;

	/**
	 * The number of form conversions.
	 *
	 * @generated from field: int64 form_conversions = 11;
	 */
	formConversions?: string;

	/**
	 * The number of contacts downloaded conversions.
	 *
	 * @generated from field: int64 contacts_downloaded_conversions = 12;
	 */
	contactsDownloadedConversions?: string;

	/**
	 * The number of external pixel conversions.
	 *
	 * @generated from field: int64 external_pixel_conversions = 13;
	 */
	externalPixelConversions?: string;

	/**
	 * The number of file downloaded conversions.
	 *
	 * @generated from field: int64 file_downloaded_conversions = 16;
	 */
	fileDownloadedConversions?: string;

	/**
	 * The number of poll completed conversions.
	 *
	 * @generated from field: int64 poll_completed_conversions = 24;
	 */
	pollCompletedConversions?: string;
};

/**
 * Describes the message abacus.v2.GroupedConversionRate.
 * Use `create(GroupedConversionRateSchema)` to create a new message.
 */
export const GroupedConversionRateSchema: GenMessage<GroupedConversionRate, { jsonType: GroupedConversionRateJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 6);

/**
 * Conversion represents conversions for a time space.
 *
 * @generated from message abacus.v2.Conversion
 */
export type Conversion = Message<"abacus.v2.Conversion"> & {
	/**
	 * The date that the event was recorded.
	 *
	 * @generated from field: google.type.Date date = 1;
	 */
	date?: Date | undefined;

	/**
	 * If an HOUR period is specified, truncates the timestamp
	 * to the start of the hour.
	 *
	 * @generated from field: optional int32 hour = 2;
	 */
	hour?: number | undefined;

	/**
	 * Total number of events.
	 *
	 * @generated from field: int64 total = 3;
	 */
	total: bigint;
};

/**
 * Conversion represents conversions for a time space.
 *
 * @generated from message abacus.v2.Conversion
 */
export type ConversionJson = {
	/**
	 * The date that the event was recorded.
	 *
	 * @generated from field: google.type.Date date = 1;
	 */
	date?: DateJson;

	/**
	 * If an HOUR period is specified, truncates the timestamp
	 * to the start of the hour.
	 *
	 * @generated from field: optional int32 hour = 2;
	 */
	hour?: number;

	/**
	 * Total number of events.
	 *
	 * @generated from field: int64 total = 3;
	 */
	total?: string;
};

/**
 * Describes the message abacus.v2.Conversion.
 * Use `create(ConversionSchema)` to create a new message.
 */
export const ConversionSchema: GenMessage<Conversion, { jsonType: ConversionJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 7);

/**
 * ContactSummary represents a summary of contacts for a given time space.
 *
 * @generated from message abacus.v2.ContactsSummary
 */
export type ContactsSummary = Message<"abacus.v2.ContactsSummary"> & {
	/**
	 * The interval for which the contact summary is applied.
	 *
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval: Interval;

	/**
	 * The period for which the contact summary is applied.
	 *
	 * @generated from field: abacus.v2.Period period = 10;
	 */
	period: Period;

	/**
	 * The timezone.
	 *
	 * @generated from field: string timezone = 2;
	 */
	timezone: string;

	/**
	 * The start date of the time range.
	 *
	 * @generated from field: google.type.Date range_start = 3;
	 */
	rangeStart?: Date | undefined;

	/**
	 * The end date of the time range.
	 *
	 * @generated from field: google.type.Date range_end = 4;
	 */
	rangeEnd?: Date | undefined;

	/**
	 * The number of unique contacts.
	 *
	 * @generated from field: int64 unique_contacts = 5;
	 */
	uniqueContacts: bigint;

	/**
	 * The number of total contacts.
	 *
	 * @generated from field: int64 total_contacts = 6;
	 */
	totalContacts: bigint;

	/**
	 * The percent change of the number of unique contacts.
	 *
	 * @generated from field: float unique_contacts_percent_change = 8;
	 */
	uniqueContactsPercentChange: number;

	/**
	 * The percent change of the number of total contacts.
	 *
	 * @generated from field: float total_contacts_percent_change = 9;
	 */
	totalContactsPercentChange: number;

	/**
	 * The list of results per the specified time space.
	 *
	 * @generated from field: repeated abacus.v2.Conversion totals = 7;
	 */
	totals: Conversion[];
};

/**
 * ContactSummary represents a summary of contacts for a given time space.
 *
 * @generated from message abacus.v2.ContactsSummary
 */
export type ContactsSummaryJson = {
	/**
	 * The interval for which the contact summary is applied.
	 *
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval?: IntervalJson;

	/**
	 * The period for which the contact summary is applied.
	 *
	 * @generated from field: abacus.v2.Period period = 10;
	 */
	period?: PeriodJson;

	/**
	 * The timezone.
	 *
	 * @generated from field: string timezone = 2;
	 */
	timezone?: string;

	/**
	 * The start date of the time range.
	 *
	 * @generated from field: google.type.Date range_start = 3;
	 */
	rangeStart?: DateJson;

	/**
	 * The end date of the time range.
	 *
	 * @generated from field: google.type.Date range_end = 4;
	 */
	rangeEnd?: DateJson;

	/**
	 * The number of unique contacts.
	 *
	 * @generated from field: int64 unique_contacts = 5;
	 */
	uniqueContacts?: string;

	/**
	 * The number of total contacts.
	 *
	 * @generated from field: int64 total_contacts = 6;
	 */
	totalContacts?: string;

	/**
	 * The percent change of the number of unique contacts.
	 *
	 * @generated from field: float unique_contacts_percent_change = 8;
	 */
	uniqueContactsPercentChange?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * The percent change of the number of total contacts.
	 *
	 * @generated from field: float total_contacts_percent_change = 9;
	 */
	totalContactsPercentChange?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * The list of results per the specified time space.
	 *
	 * @generated from field: repeated abacus.v2.Conversion totals = 7;
	 */
	totals?: ConversionJson[];
};

/**
 * Describes the message abacus.v2.ContactsSummary.
 * Use `create(ContactsSummarySchema)` to create a new message.
 */
export const ContactsSummarySchema: GenMessage<ContactsSummary, { jsonType: ContactsSummaryJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 8);

/**
 * @generated from message abacus.v2.ConversionRate
 */
export type ConversionRate = Message<"abacus.v2.ConversionRate"> & {
	/**
	 * @generated from field: google.type.Date date = 1;
	 */
	date?: Date | undefined;

	/**
	 * @generated from field: optional int32 hour = 2;
	 */
	hour?: number | undefined;

	/**
	 * @generated from field: repeated abacus.v2.GroupedConversionRate groups = 17;
	 */
	groups: GroupedConversionRate[];

	/**
	 * @generated from field: int64 scans = 3;
	 */
	scans: bigint;

	/**
	 * @generated from field: int64 clicks = 7;
	 */
	clicks: bigint;

	/**
	 * @generated from field: int64 visits = 18;
	 */
	visits: bigint;

	/**
	 * @generated from field: int64 views = 4;
	 */
	views: bigint;

	/**
	 * @generated from field: int64 conversions = 5;
	 */
	conversions: bigint;

	/**
	 * @generated from field: int64 unique_visitors = 19;
	 */
	uniqueVisitors: bigint;

	/**
	 * @generated from field: int64 unique_viewers = 23;
	 */
	uniqueViewers: bigint;

	/**
	 * @generated from field: int64 unique_conversions = 20;
	 */
	uniqueConversions: bigint;

	/**
	 * @generated from field: float conversion_rate = 6;
	 */
	conversionRate: number;

	/**
	 * @generated from field: float total_conversion_rate = 16;
	 */
	totalConversionRate: number;

	/**
	 * @generated from field: float unique_conversion_rate = 21;
	 */
	uniqueConversionRate: number;

	/**
	 * @generated from field: int64 contact_conversions = 9;
	 */
	contactConversions: bigint;

	/**
	 * @generated from field: int64 purchase_conversions = 10;
	 */
	purchaseConversions: bigint;

	/**
	 * @generated from field: int64 form_conversions = 11;
	 */
	formConversions: bigint;

	/**
	 * @generated from field: int64 contacts_downloaded_conversions = 12;
	 */
	contactsDownloadedConversions: bigint;

	/**
	 * @generated from field: int64 external_pixel_conversions = 13;
	 */
	externalPixelConversions: bigint;

	/**
	 * @generated from field: int64 anonymous_responses = 14;
	 */
	anonymousResponses: bigint;

	/**
	 * @generated from field: int64 file_downloaded_conversions = 15;
	 */
	fileDownloadedConversions: bigint;

	/**
	 * @generated from field: int64 poll_completed_conversions = 22;
	 */
	pollCompletedConversions: bigint;
};

/**
 * @generated from message abacus.v2.ConversionRate
 */
export type ConversionRateJson = {
	/**
	 * @generated from field: google.type.Date date = 1;
	 */
	date?: DateJson;

	/**
	 * @generated from field: optional int32 hour = 2;
	 */
	hour?: number;

	/**
	 * @generated from field: repeated abacus.v2.GroupedConversionRate groups = 17;
	 */
	groups?: GroupedConversionRateJson[];

	/**
	 * @generated from field: int64 scans = 3;
	 */
	scans?: string;

	/**
	 * @generated from field: int64 clicks = 7;
	 */
	clicks?: string;

	/**
	 * @generated from field: int64 visits = 18;
	 */
	visits?: string;

	/**
	 * @generated from field: int64 views = 4;
	 */
	views?: string;

	/**
	 * @generated from field: int64 conversions = 5;
	 */
	conversions?: string;

	/**
	 * @generated from field: int64 unique_visitors = 19;
	 */
	uniqueVisitors?: string;

	/**
	 * @generated from field: int64 unique_viewers = 23;
	 */
	uniqueViewers?: string;

	/**
	 * @generated from field: int64 unique_conversions = 20;
	 */
	uniqueConversions?: string;

	/**
	 * @generated from field: float conversion_rate = 6;
	 */
	conversionRate?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float total_conversion_rate = 16;
	 */
	totalConversionRate?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float unique_conversion_rate = 21;
	 */
	uniqueConversionRate?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: int64 contact_conversions = 9;
	 */
	contactConversions?: string;

	/**
	 * @generated from field: int64 purchase_conversions = 10;
	 */
	purchaseConversions?: string;

	/**
	 * @generated from field: int64 form_conversions = 11;
	 */
	formConversions?: string;

	/**
	 * @generated from field: int64 contacts_downloaded_conversions = 12;
	 */
	contactsDownloadedConversions?: string;

	/**
	 * @generated from field: int64 external_pixel_conversions = 13;
	 */
	externalPixelConversions?: string;

	/**
	 * @generated from field: int64 anonymous_responses = 14;
	 */
	anonymousResponses?: string;

	/**
	 * @generated from field: int64 file_downloaded_conversions = 15;
	 */
	fileDownloadedConversions?: string;

	/**
	 * @generated from field: int64 poll_completed_conversions = 22;
	 */
	pollCompletedConversions?: string;
};

/**
 * Describes the message abacus.v2.ConversionRate.
 * Use `create(ConversionRateSchema)` to create a new message.
 */
export const ConversionRateSchema: GenMessage<ConversionRate, { jsonType: ConversionRateJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 9);

/**
 * @generated from message abacus.v2.ConversionRateSummary
 */
export type ConversionRateSummary = Message<"abacus.v2.ConversionRateSummary"> & {
	/**
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval: Interval;

	/**
	 * @generated from field: abacus.v2.Period period = 14;
	 */
	period: Period;

	/**
	 * @generated from field: string timezone = 2;
	 */
	timezone: string;

	/**
	 * @generated from field: google.type.Date range_start = 3;
	 */
	rangeStart?: Date | undefined;

	/**
	 * @generated from field: google.type.Date range_end = 4;
	 */
	rangeEnd?: Date | undefined;

	/**
	 * @generated from field: repeated abacus.v2.Dimension dimension_group_by = 30;
	 */
	dimensionGroupBy: Dimension[];

	/**
	 * @generated from field: int64 total_scans = 5;
	 */
	totalScans: bigint;

	/**
	 * @generated from field: int64 total_clicks = 17;
	 */
	totalClicks: bigint;

	/**
	 * @generated from field: int64 total_visits = 19;
	 */
	totalVisits: bigint;

	/**
	 * @generated from field: int64 total_views = 6;
	 */
	totalViews: bigint;

	/**
	 * @generated from field: int64 total_conversions = 7;
	 */
	totalConversions: bigint;

	/**
	 * @generated from field: int64 total_unique_visitors = 12;
	 */
	totalUniqueVisitors: bigint;

	/**
	 * @generated from field: int64 total_unique_viewers = 31;
	 */
	totalUniqueViewers: bigint;

	/**
	 * @generated from field: int64 total_unique_conversions = 24;
	 */
	totalUniqueConversions: bigint;

	/**
	 * @generated from field: int64 total_anonymous_responses = 21;
	 */
	totalAnonymousResponses: bigint;

	/**
	 * @generated from field: float total_conversion_rate = 15;
	 */
	totalConversionRate: number;

	/**
	 * @generated from field: float total_total_conversion_rate = 27;
	 */
	totalTotalConversionRate: number;

	/**
	 * @generated from field: float total_unique_conversion_rate = 25;
	 */
	totalUniqueConversionRate: number;

	/**
	 * @generated from field: float total_scans_percent_change = 10;
	 */
	totalScansPercentChange: number;

	/**
	 * @generated from field: float total_clicks_percent_change = 18;
	 */
	totalClicksPercentChange: number;

	/**
	 * @generated from field: float total_visits_percent_change = 20;
	 */
	totalVisitsPercentChange: number;

	/**
	 * @generated from field: float total_views_percent_change = 11;
	 */
	totalViewsPercentChange: number;

	/**
	 * @generated from field: float total_conversions_percent_change = 9;
	 */
	totalConversionsPercentChange: number;

	/**
	 * @generated from field: float total_unique_visitors_percent_change = 13;
	 */
	totalUniqueVisitorsPercentChange: number;

	/**
	 * @generated from field: float total_unique_viewers_percent_change = 32;
	 */
	totalUniqueViewersPercentChange: number;

	/**
	 * @generated from field: float total_unique_conversions_percent_change = 26;
	 */
	totalUniqueConversionsPercentChange: number;

	/**
	 * @generated from field: float total_anonymous_responses_percent_change = 22;
	 */
	totalAnonymousResponsesPercentChange: number;

	/**
	 * @generated from field: float total_conversion_rate_percent_change = 16;
	 */
	totalConversionRatePercentChange: number;

	/**
	 * @generated from field: float total_total_conversion_rate_percent_change = 28;
	 */
	totalTotalConversionRatePercentChange: number;

	/**
	 * @generated from field: float total_unique_conversion_rate_percent_change = 29;
	 */
	totalUniqueConversionRatePercentChange: number;

	/**
	 * @generated from field: bool has_bot_data = 23;
	 */
	hasBotData: boolean;

	/**
	 * @generated from field: repeated abacus.v2.ConversionRate rates = 8;
	 */
	rates: ConversionRate[];
};

/**
 * @generated from message abacus.v2.ConversionRateSummary
 */
export type ConversionRateSummaryJson = {
	/**
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval?: IntervalJson;

	/**
	 * @generated from field: abacus.v2.Period period = 14;
	 */
	period?: PeriodJson;

	/**
	 * @generated from field: string timezone = 2;
	 */
	timezone?: string;

	/**
	 * @generated from field: google.type.Date range_start = 3;
	 */
	rangeStart?: DateJson;

	/**
	 * @generated from field: google.type.Date range_end = 4;
	 */
	rangeEnd?: DateJson;

	/**
	 * @generated from field: repeated abacus.v2.Dimension dimension_group_by = 30;
	 */
	dimensionGroupBy?: DimensionJson[];

	/**
	 * @generated from field: int64 total_scans = 5;
	 */
	totalScans?: string;

	/**
	 * @generated from field: int64 total_clicks = 17;
	 */
	totalClicks?: string;

	/**
	 * @generated from field: int64 total_visits = 19;
	 */
	totalVisits?: string;

	/**
	 * @generated from field: int64 total_views = 6;
	 */
	totalViews?: string;

	/**
	 * @generated from field: int64 total_conversions = 7;
	 */
	totalConversions?: string;

	/**
	 * @generated from field: int64 total_unique_visitors = 12;
	 */
	totalUniqueVisitors?: string;

	/**
	 * @generated from field: int64 total_unique_viewers = 31;
	 */
	totalUniqueViewers?: string;

	/**
	 * @generated from field: int64 total_unique_conversions = 24;
	 */
	totalUniqueConversions?: string;

	/**
	 * @generated from field: int64 total_anonymous_responses = 21;
	 */
	totalAnonymousResponses?: string;

	/**
	 * @generated from field: float total_conversion_rate = 15;
	 */
	totalConversionRate?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float total_total_conversion_rate = 27;
	 */
	totalTotalConversionRate?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float total_unique_conversion_rate = 25;
	 */
	totalUniqueConversionRate?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float total_scans_percent_change = 10;
	 */
	totalScansPercentChange?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float total_clicks_percent_change = 18;
	 */
	totalClicksPercentChange?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float total_visits_percent_change = 20;
	 */
	totalVisitsPercentChange?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float total_views_percent_change = 11;
	 */
	totalViewsPercentChange?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float total_conversions_percent_change = 9;
	 */
	totalConversionsPercentChange?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float total_unique_visitors_percent_change = 13;
	 */
	totalUniqueVisitorsPercentChange?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float total_unique_viewers_percent_change = 32;
	 */
	totalUniqueViewersPercentChange?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float total_unique_conversions_percent_change = 26;
	 */
	totalUniqueConversionsPercentChange?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float total_anonymous_responses_percent_change = 22;
	 */
	totalAnonymousResponsesPercentChange?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float total_conversion_rate_percent_change = 16;
	 */
	totalConversionRatePercentChange?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float total_total_conversion_rate_percent_change = 28;
	 */
	totalTotalConversionRatePercentChange?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float total_unique_conversion_rate_percent_change = 29;
	 */
	totalUniqueConversionRatePercentChange?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: bool has_bot_data = 23;
	 */
	hasBotData?: boolean;

	/**
	 * @generated from field: repeated abacus.v2.ConversionRate rates = 8;
	 */
	rates?: ConversionRateJson[];
};

/**
 * Describes the message abacus.v2.ConversionRateSummary.
 * Use `create(ConversionRateSummarySchema)` to create a new message.
 */
export const ConversionRateSummarySchema: GenMessage<ConversionRateSummary, { jsonType: ConversionRateSummaryJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 10);

/**
 * @generated from message abacus.v2.ConversionTypeSummary
 */
export type ConversionTypeSummary = Message<"abacus.v2.ConversionTypeSummary"> & {
	/**
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval: Interval;

	/**
	 * @generated from field: abacus.v2.Period period = 9;
	 */
	period: Period;

	/**
	 * @generated from field: string timezone = 2;
	 */
	timezone: string;

	/**
	 * @generated from field: google.type.Date range_start = 3;
	 */
	rangeStart?: Date | undefined;

	/**
	 * @generated from field: google.type.Date range_end = 4;
	 */
	rangeEnd?: Date | undefined;

	/**
	 * @generated from field: bundles.v1.ConversionType conversion_type = 5;
	 */
	conversionType: ConversionType;

	/**
	 * @generated from field: int64 total = 6;
	 */
	total: bigint;

	/**
	 * @generated from field: float total_percent_change = 8;
	 */
	totalPercentChange: number;

	/**
	 * @generated from field: repeated abacus.v2.Conversion conversions = 7;
	 */
	conversions: Conversion[];
};

/**
 * @generated from message abacus.v2.ConversionTypeSummary
 */
export type ConversionTypeSummaryJson = {
	/**
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval?: IntervalJson;

	/**
	 * @generated from field: abacus.v2.Period period = 9;
	 */
	period?: PeriodJson;

	/**
	 * @generated from field: string timezone = 2;
	 */
	timezone?: string;

	/**
	 * @generated from field: google.type.Date range_start = 3;
	 */
	rangeStart?: DateJson;

	/**
	 * @generated from field: google.type.Date range_end = 4;
	 */
	rangeEnd?: DateJson;

	/**
	 * @generated from field: bundles.v1.ConversionType conversion_type = 5;
	 */
	conversionType?: ConversionTypeJson;

	/**
	 * @generated from field: int64 total = 6;
	 */
	total?: string;

	/**
	 * @generated from field: float total_percent_change = 8;
	 */
	totalPercentChange?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: repeated abacus.v2.Conversion conversions = 7;
	 */
	conversions?: ConversionJson[];
};

/**
 * Describes the message abacus.v2.ConversionTypeSummary.
 * Use `create(ConversionTypeSummarySchema)` to create a new message.
 */
export const ConversionTypeSummarySchema: GenMessage<ConversionTypeSummary, { jsonType: ConversionTypeSummaryJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 11);

/**
 * @generated from message abacus.v2.Revenue
 */
export type Revenue = Message<"abacus.v2.Revenue"> & {
	/**
	 * @generated from field: google.type.Date date = 1;
	 */
	date?: Date | undefined;

	/**
	 * @generated from field: optional int32 hour = 2;
	 */
	hour?: number | undefined;

	/**
	 * @generated from field: map<string, double> revenue_by_currency = 4;
	 */
	revenueByCurrency: { [key: string]: number };
};

/**
 * @generated from message abacus.v2.Revenue
 */
export type RevenueJson = {
	/**
	 * @generated from field: google.type.Date date = 1;
	 */
	date?: DateJson;

	/**
	 * @generated from field: optional int32 hour = 2;
	 */
	hour?: number;

	/**
	 * @generated from field: map<string, double> revenue_by_currency = 4;
	 */
	revenueByCurrency?: { [key: string]: number | "NaN" | "Infinity" | "-Infinity" };
};

/**
 * Describes the message abacus.v2.Revenue.
 * Use `create(RevenueSchema)` to create a new message.
 */
export const RevenueSchema: GenMessage<Revenue, { jsonType: RevenueJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 12);

/**
 * @generated from message abacus.v2.RevenueSummary
 */
export type RevenueSummary = Message<"abacus.v2.RevenueSummary"> & {
	/**
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval: Interval;

	/**
	 * @generated from field: abacus.v2.Period period = 8;
	 */
	period: Period;

	/**
	 * @generated from field: string timezone = 2;
	 */
	timezone: string;

	/**
	 * @generated from field: google.type.Date range_start = 3;
	 */
	rangeStart?: Date | undefined;

	/**
	 * @generated from field: google.type.Date range_end = 4;
	 */
	rangeEnd?: Date | undefined;

	/**
	 * @generated from field: map<string, double> total_revenue_by_currency = 5;
	 */
	totalRevenueByCurrency: { [key: string]: number };

	/**
	 * @generated from field: map<string, float> total_revenue_by_currency_percent_change = 7;
	 */
	totalRevenueByCurrencyPercentChange: { [key: string]: number };

	/**
	 * @generated from field: repeated abacus.v2.Revenue totals = 6;
	 */
	totals: Revenue[];
};

/**
 * @generated from message abacus.v2.RevenueSummary
 */
export type RevenueSummaryJson = {
	/**
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval?: IntervalJson;

	/**
	 * @generated from field: abacus.v2.Period period = 8;
	 */
	period?: PeriodJson;

	/**
	 * @generated from field: string timezone = 2;
	 */
	timezone?: string;

	/**
	 * @generated from field: google.type.Date range_start = 3;
	 */
	rangeStart?: DateJson;

	/**
	 * @generated from field: google.type.Date range_end = 4;
	 */
	rangeEnd?: DateJson;

	/**
	 * @generated from field: map<string, double> total_revenue_by_currency = 5;
	 */
	totalRevenueByCurrency?: { [key: string]: number | "NaN" | "Infinity" | "-Infinity" };

	/**
	 * @generated from field: map<string, float> total_revenue_by_currency_percent_change = 7;
	 */
	totalRevenueByCurrencyPercentChange?: { [key: string]: number | "NaN" | "Infinity" | "-Infinity" };

	/**
	 * @generated from field: repeated abacus.v2.Revenue totals = 6;
	 */
	totals?: RevenueJson[];
};

/**
 * Describes the message abacus.v2.RevenueSummary.
 * Use `create(RevenueSummarySchema)` to create a new message.
 */
export const RevenueSummarySchema: GenMessage<RevenueSummary, { jsonType: RevenueSummaryJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 13);

/**
 * @generated from message abacus.v2.Segment
 */
export type Segment = Message<"abacus.v2.Segment"> & {
	/**
	 * @generated from field: string name = 1;
	 */
	name: string;

	/**
	 * @generated from field: float value = 2;
	 */
	value: number;
};

/**
 * @generated from message abacus.v2.Segment
 */
export type SegmentJson = {
	/**
	 * @generated from field: string name = 1;
	 */
	name?: string;

	/**
	 * @generated from field: float value = 2;
	 */
	value?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message abacus.v2.Segment.
 * Use `create(SegmentSchema)` to create a new message.
 */
export const SegmentSchema: GenMessage<Segment, { jsonType: SegmentJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 14);

/**
 * @generated from message abacus.v2.UserSegment
 */
export type UserSegment = Message<"abacus.v2.UserSegment"> & {
	/**
	 * @generated from field: abacus.v2.UserSegmentType type = 1;
	 */
	type: UserSegmentType;

	/**
	 * @generated from field: repeated abacus.v2.Segment segments = 2;
	 */
	segments: Segment[];
};

/**
 * @generated from message abacus.v2.UserSegment
 */
export type UserSegmentJson = {
	/**
	 * @generated from field: abacus.v2.UserSegmentType type = 1;
	 */
	type?: UserSegmentTypeJson;

	/**
	 * @generated from field: repeated abacus.v2.Segment segments = 2;
	 */
	segments?: SegmentJson[];
};

/**
 * Describes the message abacus.v2.UserSegment.
 * Use `create(UserSegmentSchema)` to create a new message.
 */
export const UserSegmentSchema: GenMessage<UserSegment, { jsonType: UserSegmentJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 15);

/**
 * @generated from message abacus.v2.UserSegmentRequest
 */
export type UserSegmentRequest = Message<"abacus.v2.UserSegmentRequest"> & {
	/**
	 * @generated from field: abacus.v2.UserSegmentType type = 1;
	 */
	type: UserSegmentType;

	/**
	 * @generated from field: abacus.v2.UserSegmentFormat format = 2;
	 */
	format: UserSegmentFormat;
};

/**
 * @generated from message abacus.v2.UserSegmentRequest
 */
export type UserSegmentRequestJson = {
	/**
	 * @generated from field: abacus.v2.UserSegmentType type = 1;
	 */
	type?: UserSegmentTypeJson;

	/**
	 * @generated from field: abacus.v2.UserSegmentFormat format = 2;
	 */
	format?: UserSegmentFormatJson;
};

/**
 * Describes the message abacus.v2.UserSegmentRequest.
 * Use `create(UserSegmentRequestSchema)` to create a new message.
 */
export const UserSegmentRequestSchema: GenMessage<UserSegmentRequest, { jsonType: UserSegmentRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 16);

/**
 * @generated from message abacus.v2.AudienceSummary
 */
export type AudienceSummary = Message<"abacus.v2.AudienceSummary"> & {
	/**
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval: Interval;

	/**
	 * @generated from field: string timezone = 2;
	 */
	timezone: string;

	/**
	 * @generated from field: optional abacus.v2.TimeRange time_range = 11;
	 */
	timeRange?: TimeRange | undefined;

	/**
	 * @generated from field: int64 contacts = 3;
	 */
	contacts: bigint;

	/**
	 * @generated from field: int64 visitors = 4;
	 */
	visitors: bigint;

	/**
	 * @generated from field: int64 unverified = 13;
	 */
	unverified: bigint;

	/**
	 * @generated from field: int64 imported = 14;
	 */
	imported: bigint;

	/**
	 * @generated from field: float avg_scans = 5;
	 */
	avgScans: number;

	/**
	 * @generated from field: float avg_clicks = 12;
	 */
	avgClicks: number;

	/**
	 * @generated from field: float avg_views = 6;
	 */
	avgViews: number;

	/**
	 * @generated from field: float avg_conversions = 7;
	 */
	avgConversions: number;

	/**
	 * @generated from field: abacus.v2.UserSegment identified_segment = 8;
	 */
	identifiedSegment?: UserSegment | undefined;

	/**
	 * @generated from field: abacus.v2.UserSegment engagement_segment = 9;
	 */
	engagementSegment?: UserSegment | undefined;

	/**
	 * @generated from field: abacus.v2.UserSegment conversion_type_segment = 10;
	 */
	conversionTypeSegment?: UserSegment | undefined;

	/**
	 * @generated from field: abacus.v2.UserSegment flow_id_segment = 15;
	 */
	flowIdSegment?: UserSegment | undefined;
};

/**
 * @generated from message abacus.v2.AudienceSummary
 */
export type AudienceSummaryJson = {
	/**
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval?: IntervalJson;

	/**
	 * @generated from field: string timezone = 2;
	 */
	timezone?: string;

	/**
	 * @generated from field: optional abacus.v2.TimeRange time_range = 11;
	 */
	timeRange?: TimeRangeJson;

	/**
	 * @generated from field: int64 contacts = 3;
	 */
	contacts?: string;

	/**
	 * @generated from field: int64 visitors = 4;
	 */
	visitors?: string;

	/**
	 * @generated from field: int64 unverified = 13;
	 */
	unverified?: string;

	/**
	 * @generated from field: int64 imported = 14;
	 */
	imported?: string;

	/**
	 * @generated from field: float avg_scans = 5;
	 */
	avgScans?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float avg_clicks = 12;
	 */
	avgClicks?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float avg_views = 6;
	 */
	avgViews?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float avg_conversions = 7;
	 */
	avgConversions?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: abacus.v2.UserSegment identified_segment = 8;
	 */
	identifiedSegment?: UserSegmentJson;

	/**
	 * @generated from field: abacus.v2.UserSegment engagement_segment = 9;
	 */
	engagementSegment?: UserSegmentJson;

	/**
	 * @generated from field: abacus.v2.UserSegment conversion_type_segment = 10;
	 */
	conversionTypeSegment?: UserSegmentJson;

	/**
	 * @generated from field: abacus.v2.UserSegment flow_id_segment = 15;
	 */
	flowIdSegment?: UserSegmentJson;
};

/**
 * Describes the message abacus.v2.AudienceSummary.
 * Use `create(AudienceSummarySchema)` to create a new message.
 */
export const AudienceSummarySchema: GenMessage<AudienceSummary, { jsonType: AudienceSummaryJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 17);

/**
 * @generated from message abacus.v2.ExperimentVariant
 */
export type ExperimentVariant = Message<"abacus.v2.ExperimentVariant"> & {
	/**
	 * @generated from field: string label = 1;
	 */
	label: string;

	/**
	 * @generated from field: repeated string asset_keys = 2;
	 */
	assetKeys: string[];

	/**
	 * @generated from field: string version = 3;
	 */
	version: string;
};

/**
 * @generated from message abacus.v2.ExperimentVariant
 */
export type ExperimentVariantJson = {
	/**
	 * @generated from field: string label = 1;
	 */
	label?: string;

	/**
	 * @generated from field: repeated string asset_keys = 2;
	 */
	assetKeys?: string[];

	/**
	 * @generated from field: string version = 3;
	 */
	version?: string;
};

/**
 * Describes the message abacus.v2.ExperimentVariant.
 * Use `create(ExperimentVariantSchema)` to create a new message.
 */
export const ExperimentVariantSchema: GenMessage<ExperimentVariant, { jsonType: ExperimentVariantJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 18);

/**
 * @generated from message abacus.v2.VariantRate
 */
export type VariantRate = Message<"abacus.v2.VariantRate"> & {
	/**
	 * @generated from field: abacus.v2.ExperimentVariant variant = 1;
	 */
	variant?: ExperimentVariant | undefined;

	/**
	 * @generated from field: int64 scans = 2;
	 */
	scans: bigint;

	/**
	 * @generated from field: int64 clicks = 3;
	 */
	clicks: bigint;

	/**
	 * @generated from field: int64 landing_page_views = 4;
	 */
	landingPageViews: bigint;

	/**
	 * @generated from field: int64 views = 5;
	 */
	views: bigint;

	/**
	 * @generated from field: int64 unique_viewers = 10;
	 */
	uniqueViewers: bigint;

	/**
	 * @generated from field: int64 conversions = 6;
	 */
	conversions: bigint;

	/**
	 * @generated from field: int64 unique_conversions = 11;
	 */
	uniqueConversions: bigint;

	/**
	 * @generated from field: float conversion_rate = 7;
	 */
	conversionRate: number;

	/**
	 * @generated from field: float unique_conversion_rate = 12;
	 */
	uniqueConversionRate: number;

	/**
	 * @generated from field: float experiment_conversion_rate = 8;
	 */
	experimentConversionRate: number;

	/**
	 * @generated from field: float baseline_conversion_rate = 9;
	 */
	baselineConversionRate: number;
};

/**
 * @generated from message abacus.v2.VariantRate
 */
export type VariantRateJson = {
	/**
	 * @generated from field: abacus.v2.ExperimentVariant variant = 1;
	 */
	variant?: ExperimentVariantJson;

	/**
	 * @generated from field: int64 scans = 2;
	 */
	scans?: string;

	/**
	 * @generated from field: int64 clicks = 3;
	 */
	clicks?: string;

	/**
	 * @generated from field: int64 landing_page_views = 4;
	 */
	landingPageViews?: string;

	/**
	 * @generated from field: int64 views = 5;
	 */
	views?: string;

	/**
	 * @generated from field: int64 unique_viewers = 10;
	 */
	uniqueViewers?: string;

	/**
	 * @generated from field: int64 conversions = 6;
	 */
	conversions?: string;

	/**
	 * @generated from field: int64 unique_conversions = 11;
	 */
	uniqueConversions?: string;

	/**
	 * @generated from field: float conversion_rate = 7;
	 */
	conversionRate?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float unique_conversion_rate = 12;
	 */
	uniqueConversionRate?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float experiment_conversion_rate = 8;
	 */
	experimentConversionRate?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float baseline_conversion_rate = 9;
	 */
	baselineConversionRate?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message abacus.v2.VariantRate.
 * Use `create(VariantRateSchema)` to create a new message.
 */
export const VariantRateSchema: GenMessage<VariantRate, { jsonType: VariantRateJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 19);

/**
 * @generated from message abacus.v2.ExperimentRate
 */
export type ExperimentRate = Message<"abacus.v2.ExperimentRate"> & {
	/**
	 * @generated from field: google.type.Date date = 1;
	 */
	date?: Date | undefined;

	/**
	 * @generated from field: optional int32 hour = 2;
	 */
	hour?: number | undefined;

	/**
	 * @generated from field: repeated abacus.v2.VariantRate variant_rates = 3;
	 */
	variantRates: VariantRate[];

	/**
	 * @generated from field: repeated abacus.v2.VariantRate cumulative_rates = 5;
	 */
	cumulativeRates: VariantRate[];

	/**
	 * @generated from field: abacus.v2.VariantRate cumulative_aggregate_rate = 4;
	 */
	cumulativeAggregateRate?: VariantRate | undefined;
};

/**
 * @generated from message abacus.v2.ExperimentRate
 */
export type ExperimentRateJson = {
	/**
	 * @generated from field: google.type.Date date = 1;
	 */
	date?: DateJson;

	/**
	 * @generated from field: optional int32 hour = 2;
	 */
	hour?: number;

	/**
	 * @generated from field: repeated abacus.v2.VariantRate variant_rates = 3;
	 */
	variantRates?: VariantRateJson[];

	/**
	 * @generated from field: repeated abacus.v2.VariantRate cumulative_rates = 5;
	 */
	cumulativeRates?: VariantRateJson[];

	/**
	 * @generated from field: abacus.v2.VariantRate cumulative_aggregate_rate = 4;
	 */
	cumulativeAggregateRate?: VariantRateJson;
};

/**
 * Describes the message abacus.v2.ExperimentRate.
 * Use `create(ExperimentRateSchema)` to create a new message.
 */
export const ExperimentRateSchema: GenMessage<ExperimentRate, { jsonType: ExperimentRateJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 20);

/**
 * @generated from message abacus.v2.ExperimentSummary
 */
export type ExperimentSummary = Message<"abacus.v2.ExperimentSummary"> & {
	/**
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval: Interval;

	/**
	 * @generated from field: abacus.v2.Period period = 2;
	 */
	period: Period;

	/**
	 * @generated from field: string timezone = 3;
	 */
	timezone: string;

	/**
	 * @generated from field: google.type.Date range_start = 4;
	 */
	rangeStart?: Date | undefined;

	/**
	 * @generated from field: google.type.Date range_end = 5;
	 */
	rangeEnd?: Date | undefined;

	/**
	 * @generated from field: repeated abacus.v2.ExperimentRate rates = 6;
	 */
	rates: ExperimentRate[];
};

/**
 * @generated from message abacus.v2.ExperimentSummary
 */
export type ExperimentSummaryJson = {
	/**
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval?: IntervalJson;

	/**
	 * @generated from field: abacus.v2.Period period = 2;
	 */
	period?: PeriodJson;

	/**
	 * @generated from field: string timezone = 3;
	 */
	timezone?: string;

	/**
	 * @generated from field: google.type.Date range_start = 4;
	 */
	rangeStart?: DateJson;

	/**
	 * @generated from field: google.type.Date range_end = 5;
	 */
	rangeEnd?: DateJson;

	/**
	 * @generated from field: repeated abacus.v2.ExperimentRate rates = 6;
	 */
	rates?: ExperimentRateJson[];
};

/**
 * Describes the message abacus.v2.ExperimentSummary.
 * Use `create(ExperimentSummarySchema)` to create a new message.
 */
export const ExperimentSummarySchema: GenMessage<ExperimentSummary, { jsonType: ExperimentSummaryJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 21);

/**
 * @generated from message abacus.v2.FormField
 */
export type FormField = Message<"abacus.v2.FormField"> & {
	/**
	 * @generated from field: string form_id = 1;
	 */
	formId: string;

	/**
	 * @generated from field: string field_id = 2;
	 */
	fieldId: string;

	/**
	 * @generated from field: string name = 3;
	 */
	name: string;

	/**
	 * @generated from field: string title = 4;
	 */
	title: string;

	/**
	 * @generated from field: int32 field_type = 5;
	 */
	fieldType: number;
};

/**
 * @generated from message abacus.v2.FormField
 */
export type FormFieldJson = {
	/**
	 * @generated from field: string form_id = 1;
	 */
	formId?: string;

	/**
	 * @generated from field: string field_id = 2;
	 */
	fieldId?: string;

	/**
	 * @generated from field: string name = 3;
	 */
	name?: string;

	/**
	 * @generated from field: string title = 4;
	 */
	title?: string;

	/**
	 * @generated from field: int32 field_type = 5;
	 */
	fieldType?: number;
};

/**
 * Describes the message abacus.v2.FormField.
 * Use `create(FormFieldSchema)` to create a new message.
 */
export const FormFieldSchema: GenMessage<FormField, { jsonType: FormFieldJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 22);

/**
 * @generated from message abacus.v2.FilterOption
 */
export type FilterOption = Message<"abacus.v2.FilterOption"> & {
	/**
	 * @generated from field: string value = 1;
	 */
	value: string;

	/**
	 * @generated from field: string label = 2;
	 */
	label: string;
};

/**
 * @generated from message abacus.v2.FilterOption
 */
export type FilterOptionJson = {
	/**
	 * @generated from field: string value = 1;
	 */
	value?: string;

	/**
	 * @generated from field: string label = 2;
	 */
	label?: string;
};

/**
 * Describes the message abacus.v2.FilterOption.
 * Use `create(FilterOptionSchema)` to create a new message.
 */
export const FilterOptionSchema: GenMessage<FilterOption, { jsonType: FilterOptionJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 23);

/**
 * @generated from message abacus.v2.DateColumn
 */
export type DateColumn = Message<"abacus.v2.DateColumn"> & {
	/**
	 * @generated from field: string timezone = 1;
	 */
	timezone: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name: string;
};

/**
 * @generated from message abacus.v2.DateColumn
 */
export type DateColumnJson = {
	/**
	 * @generated from field: string timezone = 1;
	 */
	timezone?: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name?: string;
};

/**
 * Describes the message abacus.v2.DateColumn.
 * Use `create(DateColumnSchema)` to create a new message.
 */
export const DateColumnSchema: GenMessage<DateColumn, { jsonType: DateColumnJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 24);

/**
 * @generated from message abacus.v2.EqualConstraint
 */
export type EqualConstraint = Message<"abacus.v2.EqualConstraint"> & {
	/**
	 * @generated from oneof abacus.v2.EqualConstraint.column
	 */
	column:
		| {
				/**
				 * @generated from field: string name = 1;
				 */
				value: string;
				case: "name";
		  }
		| {
				/**
				 * @generated from field: string id = 2;
				 */
				value: string;
				case: "id";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.DateColumn date = 3;
				 */
				value: DateColumn;
				case: "date";
		  }
		| { case: undefined; value?: undefined };

	/**
	 * @generated from field: string value = 4;
	 */
	value: string;
};

/**
 * @generated from message abacus.v2.EqualConstraint
 */
export type EqualConstraintJson = {
	/**
	 * @generated from field: string name = 1;
	 */
	name?: string;

	/**
	 * @generated from field: string id = 2;
	 */
	id?: string;

	/**
	 * @generated from field: abacus.v2.DateColumn date = 3;
	 */
	date?: DateColumnJson;

	/**
	 * @generated from field: string value = 4;
	 */
	value?: string;
};

/**
 * Describes the message abacus.v2.EqualConstraint.
 * Use `create(EqualConstraintSchema)` to create a new message.
 */
export const EqualConstraintSchema: GenMessage<EqualConstraint, { jsonType: EqualConstraintJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 25);

/**
 * @generated from message abacus.v2.NotConstraint
 */
export type NotConstraint = Message<"abacus.v2.NotConstraint"> & {
	/**
	 * @generated from field: abacus.v2.Constraint constraint = 1;
	 */
	constraint?: Constraint | undefined;
};

/**
 * @generated from message abacus.v2.NotConstraint
 */
export type NotConstraintJson = {
	/**
	 * @generated from field: abacus.v2.Constraint constraint = 1;
	 */
	constraint?: ConstraintJson;
};

/**
 * Describes the message abacus.v2.NotConstraint.
 * Use `create(NotConstraintSchema)` to create a new message.
 */
export const NotConstraintSchema: GenMessage<NotConstraint, { jsonType: NotConstraintJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 26);

/**
 * @generated from message abacus.v2.InConstraint
 */
export type InConstraint = Message<"abacus.v2.InConstraint"> & {
	/**
	 * @generated from oneof abacus.v2.InConstraint.column
	 */
	column:
		| {
				/**
				 * @generated from field: string name = 1;
				 */
				value: string;
				case: "name";
		  }
		| {
				/**
				 * @generated from field: string id = 2;
				 */
				value: string;
				case: "id";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.DateColumn date = 3;
				 */
				value: DateColumn;
				case: "date";
		  }
		| { case: undefined; value?: undefined };

	/**
	 * @generated from field: repeated string values = 4;
	 */
	values: string[];
};

/**
 * @generated from message abacus.v2.InConstraint
 */
export type InConstraintJson = {
	/**
	 * @generated from field: string name = 1;
	 */
	name?: string;

	/**
	 * @generated from field: string id = 2;
	 */
	id?: string;

	/**
	 * @generated from field: abacus.v2.DateColumn date = 3;
	 */
	date?: DateColumnJson;

	/**
	 * @generated from field: repeated string values = 4;
	 */
	values?: string[];
};

/**
 * Describes the message abacus.v2.InConstraint.
 * Use `create(InConstraintSchema)` to create a new message.
 */
export const InConstraintSchema: GenMessage<InConstraint, { jsonType: InConstraintJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 27);

/**
 * @generated from message abacus.v2.GreaterConstraint
 */
export type GreaterConstraint = Message<"abacus.v2.GreaterConstraint"> & {
	/**
	 * @generated from oneof abacus.v2.GreaterConstraint.column
	 */
	column:
		| {
				/**
				 * @generated from field: string name = 1;
				 */
				value: string;
				case: "name";
		  }
		| {
				/**
				 * @generated from field: string id = 2;
				 */
				value: string;
				case: "id";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.DateColumn date = 3;
				 */
				value: DateColumn;
				case: "date";
		  }
		| { case: undefined; value?: undefined };

	/**
	 * @generated from field: string value = 4;
	 */
	value: string;
};

/**
 * @generated from message abacus.v2.GreaterConstraint
 */
export type GreaterConstraintJson = {
	/**
	 * @generated from field: string name = 1;
	 */
	name?: string;

	/**
	 * @generated from field: string id = 2;
	 */
	id?: string;

	/**
	 * @generated from field: abacus.v2.DateColumn date = 3;
	 */
	date?: DateColumnJson;

	/**
	 * @generated from field: string value = 4;
	 */
	value?: string;
};

/**
 * Describes the message abacus.v2.GreaterConstraint.
 * Use `create(GreaterConstraintSchema)` to create a new message.
 */
export const GreaterConstraintSchema: GenMessage<GreaterConstraint, { jsonType: GreaterConstraintJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 28);

/**
 * @generated from message abacus.v2.GreaterEqualConstraint
 */
export type GreaterEqualConstraint = Message<"abacus.v2.GreaterEqualConstraint"> & {
	/**
	 * @generated from oneof abacus.v2.GreaterEqualConstraint.column
	 */
	column:
		| {
				/**
				 * @generated from field: string name = 1;
				 */
				value: string;
				case: "name";
		  }
		| {
				/**
				 * @generated from field: string id = 2;
				 */
				value: string;
				case: "id";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.DateColumn date = 3;
				 */
				value: DateColumn;
				case: "date";
		  }
		| { case: undefined; value?: undefined };

	/**
	 * @generated from field: string value = 4;
	 */
	value: string;
};

/**
 * @generated from message abacus.v2.GreaterEqualConstraint
 */
export type GreaterEqualConstraintJson = {
	/**
	 * @generated from field: string name = 1;
	 */
	name?: string;

	/**
	 * @generated from field: string id = 2;
	 */
	id?: string;

	/**
	 * @generated from field: abacus.v2.DateColumn date = 3;
	 */
	date?: DateColumnJson;

	/**
	 * @generated from field: string value = 4;
	 */
	value?: string;
};

/**
 * Describes the message abacus.v2.GreaterEqualConstraint.
 * Use `create(GreaterEqualConstraintSchema)` to create a new message.
 */
export const GreaterEqualConstraintSchema: GenMessage<GreaterEqualConstraint, { jsonType: GreaterEqualConstraintJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 29);

/**
 * @generated from message abacus.v2.LikeConstraint
 */
export type LikeConstraint = Message<"abacus.v2.LikeConstraint"> & {
	/**
	 * @generated from oneof abacus.v2.LikeConstraint.column
	 */
	column:
		| {
				/**
				 * @generated from field: string name = 1;
				 */
				value: string;
				case: "name";
		  }
		| {
				/**
				 * @generated from field: string id = 2;
				 */
				value: string;
				case: "id";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.DateColumn date = 3;
				 */
				value: DateColumn;
				case: "date";
		  }
		| { case: undefined; value?: undefined };

	/**
	 * @generated from field: string value = 4;
	 */
	value: string;
};

/**
 * @generated from message abacus.v2.LikeConstraint
 */
export type LikeConstraintJson = {
	/**
	 * @generated from field: string name = 1;
	 */
	name?: string;

	/**
	 * @generated from field: string id = 2;
	 */
	id?: string;

	/**
	 * @generated from field: abacus.v2.DateColumn date = 3;
	 */
	date?: DateColumnJson;

	/**
	 * @generated from field: string value = 4;
	 */
	value?: string;
};

/**
 * Describes the message abacus.v2.LikeConstraint.
 * Use `create(LikeConstraintSchema)` to create a new message.
 */
export const LikeConstraintSchema: GenMessage<LikeConstraint, { jsonType: LikeConstraintJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 30);

/**
 * @generated from message abacus.v2.NullConstraint
 */
export type NullConstraint = Message<"abacus.v2.NullConstraint"> & {
	/**
	 * @generated from oneof abacus.v2.NullConstraint.column
	 */
	column:
		| {
				/**
				 * @generated from field: string name = 1;
				 */
				value: string;
				case: "name";
		  }
		| {
				/**
				 * @generated from field: string id = 2;
				 */
				value: string;
				case: "id";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.DateColumn date = 3;
				 */
				value: DateColumn;
				case: "date";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message abacus.v2.NullConstraint
 */
export type NullConstraintJson = {
	/**
	 * @generated from field: string name = 1;
	 */
	name?: string;

	/**
	 * @generated from field: string id = 2;
	 */
	id?: string;

	/**
	 * @generated from field: abacus.v2.DateColumn date = 3;
	 */
	date?: DateColumnJson;
};

/**
 * Describes the message abacus.v2.NullConstraint.
 * Use `create(NullConstraintSchema)` to create a new message.
 */
export const NullConstraintSchema: GenMessage<NullConstraint, { jsonType: NullConstraintJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 31);

/**
 * @generated from message abacus.v2.ContainsConstraint
 */
export type ContainsConstraint = Message<"abacus.v2.ContainsConstraint"> & {
	/**
	 * @generated from oneof abacus.v2.ContainsConstraint.column
	 */
	column:
		| {
				/**
				 * @generated from field: string name = 1;
				 */
				value: string;
				case: "name";
		  }
		| {
				/**
				 * @generated from field: string id = 2;
				 */
				value: string;
				case: "id";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.DateColumn date = 3;
				 */
				value: DateColumn;
				case: "date";
		  }
		| { case: undefined; value?: undefined };

	/**
	 * @generated from field: string value = 4;
	 */
	value: string;
};

/**
 * @generated from message abacus.v2.ContainsConstraint
 */
export type ContainsConstraintJson = {
	/**
	 * @generated from field: string name = 1;
	 */
	name?: string;

	/**
	 * @generated from field: string id = 2;
	 */
	id?: string;

	/**
	 * @generated from field: abacus.v2.DateColumn date = 3;
	 */
	date?: DateColumnJson;

	/**
	 * @generated from field: string value = 4;
	 */
	value?: string;
};

/**
 * Describes the message abacus.v2.ContainsConstraint.
 * Use `create(ContainsConstraintSchema)` to create a new message.
 */
export const ContainsConstraintSchema: GenMessage<ContainsConstraint, { jsonType: ContainsConstraintJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 32);

/**
 * @generated from message abacus.v2.SimpleConstraint
 */
export type SimpleConstraint = Message<"abacus.v2.SimpleConstraint"> & {
	/**
	 * @generated from oneof abacus.v2.SimpleConstraint.type
	 */
	type:
		| {
				/**
				 * @generated from field: abacus.v2.EqualConstraint equal = 1;
				 */
				value: EqualConstraint;
				case: "equal";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.NotConstraint not = 2;
				 */
				value: NotConstraint;
				case: "not";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.InConstraint in = 3;
				 */
				value: InConstraint;
				case: "in";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.GreaterConstraint greater = 4;
				 */
				value: GreaterConstraint;
				case: "greater";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.GreaterEqualConstraint greater_equal = 5;
				 */
				value: GreaterEqualConstraint;
				case: "greaterEqual";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.LikeConstraint like = 8;
				 */
				value: LikeConstraint;
				case: "like";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.NullConstraint null = 9;
				 */
				value: NullConstraint;
				case: "null";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.ContainsConstraint contains = 10;
				 */
				value: ContainsConstraint;
				case: "contains";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message abacus.v2.SimpleConstraint
 */
export type SimpleConstraintJson = {
	/**
	 * @generated from field: abacus.v2.EqualConstraint equal = 1;
	 */
	equal?: EqualConstraintJson;

	/**
	 * @generated from field: abacus.v2.NotConstraint not = 2;
	 */
	not?: NotConstraintJson;

	/**
	 * @generated from field: abacus.v2.InConstraint in = 3;
	 */
	in?: InConstraintJson;

	/**
	 * @generated from field: abacus.v2.GreaterConstraint greater = 4;
	 */
	greater?: GreaterConstraintJson;

	/**
	 * @generated from field: abacus.v2.GreaterEqualConstraint greater_equal = 5;
	 */
	greaterEqual?: GreaterEqualConstraintJson;

	/**
	 * @generated from field: abacus.v2.LikeConstraint like = 8;
	 */
	like?: LikeConstraintJson;

	/**
	 * @generated from field: abacus.v2.NullConstraint null = 9;
	 */
	null?: NullConstraintJson;

	/**
	 * @generated from field: abacus.v2.ContainsConstraint contains = 10;
	 */
	contains?: ContainsConstraintJson;
};

/**
 * Describes the message abacus.v2.SimpleConstraint.
 * Use `create(SimpleConstraintSchema)` to create a new message.
 */
export const SimpleConstraintSchema: GenMessage<SimpleConstraint, { jsonType: SimpleConstraintJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 33);

/**
 * @generated from message abacus.v2.CompoundConstraint
 */
export type CompoundConstraint = Message<"abacus.v2.CompoundConstraint"> & {
	/**
	 * @generated from field: abacus.v2.Constraint lhs = 1;
	 */
	lhs?: Constraint | undefined;

	/**
	 * @generated from field: abacus.v2.Operator operator = 2;
	 */
	operator: Operator;

	/**
	 * @generated from field: abacus.v2.Constraint rhs = 3;
	 */
	rhs?: Constraint | undefined;
};

/**
 * @generated from message abacus.v2.CompoundConstraint
 */
export type CompoundConstraintJson = {
	/**
	 * @generated from field: abacus.v2.Constraint lhs = 1;
	 */
	lhs?: ConstraintJson;

	/**
	 * @generated from field: abacus.v2.Operator operator = 2;
	 */
	operator?: OperatorJson;

	/**
	 * @generated from field: abacus.v2.Constraint rhs = 3;
	 */
	rhs?: ConstraintJson;
};

/**
 * Describes the message abacus.v2.CompoundConstraint.
 * Use `create(CompoundConstraintSchema)` to create a new message.
 */
export const CompoundConstraintSchema: GenMessage<CompoundConstraint, { jsonType: CompoundConstraintJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 34);

/**
 * @generated from message abacus.v2.InteractionConstraint
 */
export type InteractionConstraint = Message<"abacus.v2.InteractionConstraint"> & {
	/**
	 * @generated from field: abacus.v2.Constraint constraint = 1;
	 */
	constraint?: Constraint | undefined;

	/**
	 * @generated from field: abacus.v2.Constraint having = 2;
	 */
	having?: Constraint | undefined;
};

/**
 * @generated from message abacus.v2.InteractionConstraint
 */
export type InteractionConstraintJson = {
	/**
	 * @generated from field: abacus.v2.Constraint constraint = 1;
	 */
	constraint?: ConstraintJson;

	/**
	 * @generated from field: abacus.v2.Constraint having = 2;
	 */
	having?: ConstraintJson;
};

/**
 * Describes the message abacus.v2.InteractionConstraint.
 * Use `create(InteractionConstraintSchema)` to create a new message.
 */
export const InteractionConstraintSchema: GenMessage<InteractionConstraint, { jsonType: InteractionConstraintJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 35);

/**
 * @generated from message abacus.v2.IntervalConstraint
 */
export type IntervalConstraint = Message<"abacus.v2.IntervalConstraint"> & {
	/**
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval: Interval;

	/**
	 * @generated from field: string timezone = 2;
	 */
	timezone: string;

	/**
	 * @generated from field: optional abacus.v2.TimeRange time_range = 4;
	 */
	timeRange?: TimeRange | undefined;

	/**
	 * @generated from field: string column = 3;
	 */
	column: string;
};

/**
 * @generated from message abacus.v2.IntervalConstraint
 */
export type IntervalConstraintJson = {
	/**
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval?: IntervalJson;

	/**
	 * @generated from field: string timezone = 2;
	 */
	timezone?: string;

	/**
	 * @generated from field: optional abacus.v2.TimeRange time_range = 4;
	 */
	timeRange?: TimeRangeJson;

	/**
	 * @generated from field: string column = 3;
	 */
	column?: string;
};

/**
 * Describes the message abacus.v2.IntervalConstraint.
 * Use `create(IntervalConstraintSchema)` to create a new message.
 */
export const IntervalConstraintSchema: GenMessage<IntervalConstraint, { jsonType: IntervalConstraintJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 36);

/**
 * @generated from message abacus.v2.SegmentConstraint
 */
export type SegmentConstraint = Message<"abacus.v2.SegmentConstraint"> & {
	/**
	 * @generated from field: repeated abacus.v2.SegmentLevel engagement_level = 1;
	 */
	engagementLevel: SegmentLevel[];
};

/**
 * @generated from message abacus.v2.SegmentConstraint
 */
export type SegmentConstraintJson = {
	/**
	 * @generated from field: repeated abacus.v2.SegmentLevel engagement_level = 1;
	 */
	engagementLevel?: SegmentLevelJson[];
};

/**
 * Describes the message abacus.v2.SegmentConstraint.
 * Use `create(SegmentConstraintSchema)` to create a new message.
 */
export const SegmentConstraintSchema: GenMessage<SegmentConstraint, { jsonType: SegmentConstraintJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 37);

/**
 * @generated from message abacus.v2.GroupConstraint
 */
export type GroupConstraint = Message<"abacus.v2.GroupConstraint"> & {
	/**
	 * @generated from field: abacus.v2.Constraint constraint = 1;
	 */
	constraint?: Constraint | undefined;
};

/**
 * @generated from message abacus.v2.GroupConstraint
 */
export type GroupConstraintJson = {
	/**
	 * @generated from field: abacus.v2.Constraint constraint = 1;
	 */
	constraint?: ConstraintJson;
};

/**
 * Describes the message abacus.v2.GroupConstraint.
 * Use `create(GroupConstraintSchema)` to create a new message.
 */
export const GroupConstraintSchema: GenMessage<GroupConstraint, { jsonType: GroupConstraintJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 38);

/**
 * @generated from message abacus.v2.Constraint
 */
export type Constraint = Message<"abacus.v2.Constraint"> & {
	/**
	 * @generated from oneof abacus.v2.Constraint.type
	 */
	type:
		| {
				/**
				 * @generated from field: abacus.v2.SimpleConstraint simple = 1;
				 */
				value: SimpleConstraint;
				case: "simple";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.CompoundConstraint compound = 2;
				 */
				value: CompoundConstraint;
				case: "compound";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.InteractionConstraint interaction = 3;
				 */
				value: InteractionConstraint;
				case: "interaction";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.IntervalConstraint interval = 4;
				 */
				value: IntervalConstraint;
				case: "interval";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.SegmentConstraint segment = 5;
				 */
				value: SegmentConstraint;
				case: "segment";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.GroupConstraint group = 6;
				 */
				value: GroupConstraint;
				case: "group";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message abacus.v2.Constraint
 */
export type ConstraintJson = {
	/**
	 * @generated from field: abacus.v2.SimpleConstraint simple = 1;
	 */
	simple?: SimpleConstraintJson;

	/**
	 * @generated from field: abacus.v2.CompoundConstraint compound = 2;
	 */
	compound?: CompoundConstraintJson;

	/**
	 * @generated from field: abacus.v2.InteractionConstraint interaction = 3;
	 */
	interaction?: InteractionConstraintJson;

	/**
	 * @generated from field: abacus.v2.IntervalConstraint interval = 4;
	 */
	interval?: IntervalConstraintJson;

	/**
	 * @generated from field: abacus.v2.SegmentConstraint segment = 5;
	 */
	segment?: SegmentConstraintJson;

	/**
	 * @generated from field: abacus.v2.GroupConstraint group = 6;
	 */
	group?: GroupConstraintJson;
};

/**
 * Describes the message abacus.v2.Constraint.
 * Use `create(ConstraintSchema)` to create a new message.
 */
export const ConstraintSchema: GenMessage<Constraint, { jsonType: ConstraintJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 39);

/**
 * @generated from message abacus.v2.PredicateSet
 */
export type PredicateSet = Message<"abacus.v2.PredicateSet"> & {
	/**
	 * @generated from field: abacus.v2.Constraint where = 1;
	 */
	where?: Constraint | undefined;

	/**
	 * @generated from field: abacus.v2.Constraint having = 2;
	 */
	having?: Constraint | undefined;
};

/**
 * @generated from message abacus.v2.PredicateSet
 */
export type PredicateSetJson = {
	/**
	 * @generated from field: abacus.v2.Constraint where = 1;
	 */
	where?: ConstraintJson;

	/**
	 * @generated from field: abacus.v2.Constraint having = 2;
	 */
	having?: ConstraintJson;
};

/**
 * Describes the message abacus.v2.PredicateSet.
 * Use `create(PredicateSetSchema)` to create a new message.
 */
export const PredicateSetSchema: GenMessage<PredicateSet, { jsonType: PredicateSetJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 40);

/**
 * @generated from message abacus.v2.AdvancedFilter
 */
export type AdvancedFilter = Message<"abacus.v2.AdvancedFilter"> & {
	/**
	 * @generated from field: repeated abacus.v2.PredicateSet sets = 1;
	 */
	sets: PredicateSet[];

	/**
	 * @generated from field: bool is_current = 2;
	 */
	isCurrent: boolean;

	/**
	 * @generated from field: bool hide_bot_traffic = 3;
	 */
	hideBotTraffic: boolean;

	/**
	 * @generated from field: optional bool is_bot = 4;
	 */
	isBot?: boolean | undefined;

	/**
	 * @generated from field: optional bool is_verified = 5;
	 */
	isVerified?: boolean | undefined;
};

/**
 * @generated from message abacus.v2.AdvancedFilter
 */
export type AdvancedFilterJson = {
	/**
	 * @generated from field: repeated abacus.v2.PredicateSet sets = 1;
	 */
	sets?: PredicateSetJson[];

	/**
	 * @generated from field: bool is_current = 2;
	 */
	isCurrent?: boolean;

	/**
	 * @generated from field: bool hide_bot_traffic = 3;
	 */
	hideBotTraffic?: boolean;

	/**
	 * @generated from field: optional bool is_bot = 4;
	 */
	isBot?: boolean;

	/**
	 * @generated from field: optional bool is_verified = 5;
	 */
	isVerified?: boolean;
};

/**
 * Describes the message abacus.v2.AdvancedFilter.
 * Use `create(AdvancedFilterSchema)` to create a new message.
 */
export const AdvancedFilterSchema: GenMessage<AdvancedFilter, { jsonType: AdvancedFilterJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 41);

/**
 * @generated from message abacus.v2.AudienceConfig
 */
export type AudienceConfig = Message<"abacus.v2.AudienceConfig"> & {
	/**
	 * @generated from field: repeated abacus.v2.PredicateSet sets = 1;
	 */
	sets: PredicateSet[];

	/**
	 * @generated from field: bool is_current = 2;
	 */
	isCurrent: boolean;

	/**
	 * @generated from field: bool hide_bot_traffic = 3;
	 */
	hideBotTraffic: boolean;

	/**
	 * @generated from field: optional bool is_bot = 4;
	 */
	isBot?: boolean | undefined;

	/**
	 * @generated from field: optional bool is_verified = 5;
	 */
	isVerified?: boolean | undefined;
};

/**
 * @generated from message abacus.v2.AudienceConfig
 */
export type AudienceConfigJson = {
	/**
	 * @generated from field: repeated abacus.v2.PredicateSet sets = 1;
	 */
	sets?: PredicateSetJson[];

	/**
	 * @generated from field: bool is_current = 2;
	 */
	isCurrent?: boolean;

	/**
	 * @generated from field: bool hide_bot_traffic = 3;
	 */
	hideBotTraffic?: boolean;

	/**
	 * @generated from field: optional bool is_bot = 4;
	 */
	isBot?: boolean;

	/**
	 * @generated from field: optional bool is_verified = 5;
	 */
	isVerified?: boolean;
};

/**
 * Describes the message abacus.v2.AudienceConfig.
 * Use `create(AudienceConfigSchema)` to create a new message.
 */
export const AudienceConfigSchema: GenMessage<AudienceConfig, { jsonType: AudienceConfigJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 42);

/**
 * @generated from message abacus.v2.AudienceSuiteRef
 */
export type AudienceSuiteRef = Message<"abacus.v2.AudienceSuiteRef"> & {
	/**
	 * @generated from field: string suite_id = 1;
	 */
	suiteId: string;

	/**
	 * @generated from field: string suite_name = 2;
	 */
	suiteName: string;
};

/**
 * @generated from message abacus.v2.AudienceSuiteRef
 */
export type AudienceSuiteRefJson = {
	/**
	 * @generated from field: string suite_id = 1;
	 */
	suiteId?: string;

	/**
	 * @generated from field: string suite_name = 2;
	 */
	suiteName?: string;
};

/**
 * Describes the message abacus.v2.AudienceSuiteRef.
 * Use `create(AudienceSuiteRefSchema)` to create a new message.
 */
export const AudienceSuiteRefSchema: GenMessage<AudienceSuiteRef, { jsonType: AudienceSuiteRefJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 43);

/**
 * @generated from message abacus.v2.Audience
 */
export type Audience = Message<"abacus.v2.Audience"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string name = 4;
	 */
	name: string;

	/**
	 * @generated from field: string description = 5;
	 */
	description: string;

	/**
	 * @generated from field: string creator_id = 6;
	 */
	creatorId: string;

	/**
	 * @generated from field: string creator_email = 7;
	 */
	creatorEmail: string;

	/**
	 * @generated from field: abacus.v2.AudienceConfig config = 8;
	 */
	config?: AudienceConfig | undefined;

	/**
	 * @generated from field: abacus.v2.AudienceType type = 13;
	 */
	type: AudienceType;

	/**
	 * @generated from field: int64 size = 9;
	 */
	size: bigint;

	/**
	 * @generated from field: bool is_static = 14;
	 */
	isStatic: boolean;

	/**
	 * @generated from field: repeated abacus.v2.AudienceSuiteRef suite_refs = 15;
	 */
	suiteRefs: AudienceSuiteRef[];

	/**
	 * @generated from field: google.protobuf.Timestamp calculated_at = 10;
	 */
	calculatedAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 11;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 12;
	 */
	updatedAt?: Timestamp | undefined;
};

/**
 * @generated from message abacus.v2.Audience
 */
export type AudienceJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string name = 4;
	 */
	name?: string;

	/**
	 * @generated from field: string description = 5;
	 */
	description?: string;

	/**
	 * @generated from field: string creator_id = 6;
	 */
	creatorId?: string;

	/**
	 * @generated from field: string creator_email = 7;
	 */
	creatorEmail?: string;

	/**
	 * @generated from field: abacus.v2.AudienceConfig config = 8;
	 */
	config?: AudienceConfigJson;

	/**
	 * @generated from field: abacus.v2.AudienceType type = 13;
	 */
	type?: AudienceTypeJson;

	/**
	 * @generated from field: int64 size = 9;
	 */
	size?: string;

	/**
	 * @generated from field: bool is_static = 14;
	 */
	isStatic?: boolean;

	/**
	 * @generated from field: repeated abacus.v2.AudienceSuiteRef suite_refs = 15;
	 */
	suiteRefs?: AudienceSuiteRefJson[];

	/**
	 * @generated from field: google.protobuf.Timestamp calculated_at = 10;
	 */
	calculatedAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 11;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 12;
	 */
	updatedAt?: TimestampJson;
};

/**
 * Describes the message abacus.v2.Audience.
 * Use `create(AudienceSchema)` to create a new message.
 */
export const AudienceSchema: GenMessage<Audience, { jsonType: AudienceJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 44);

/**
 * @generated from message abacus.v2.Calculable
 */
export type Calculable = Message<"abacus.v2.Calculable"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: abacus.v2.AudienceConfig config = 3;
	 */
	config?: AudienceConfig | undefined;

	/**
	 * @generated from field: abacus.v2.AudienceType type = 4;
	 */
	type: AudienceType;
};

/**
 * @generated from message abacus.v2.Calculable
 */
export type CalculableJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: abacus.v2.AudienceConfig config = 3;
	 */
	config?: AudienceConfigJson;

	/**
	 * @generated from field: abacus.v2.AudienceType type = 4;
	 */
	type?: AudienceTypeJson;
};

/**
 * Describes the message abacus.v2.Calculable.
 * Use `create(CalculableSchema)` to create a new message.
 */
export const CalculableSchema: GenMessage<Calculable, { jsonType: CalculableJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 45);

/**
 * @generated from message abacus.v2.DateFilter
 */
export type DateFilter = Message<"abacus.v2.DateFilter"> & {
	/**
	 * @generated from field: string timezone = 1;
	 */
	timezone: string;

	/**
	 * @generated from field: google.protobuf.Timestamp start_time = 2;
	 */
	startTime?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp end_time = 3;
	 */
	endTime?: Timestamp | undefined;
};

/**
 * @generated from message abacus.v2.DateFilter
 */
export type DateFilterJson = {
	/**
	 * @generated from field: string timezone = 1;
	 */
	timezone?: string;

	/**
	 * @generated from field: google.protobuf.Timestamp start_time = 2;
	 */
	startTime?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp end_time = 3;
	 */
	endTime?: TimestampJson;
};

/**
 * Describes the message abacus.v2.DateFilter.
 * Use `create(DateFilterSchema)` to create a new message.
 */
export const DateFilterSchema: GenMessage<DateFilter, { jsonType: DateFilterJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 46);

/**
 * @generated from message abacus.v2.MetadataFilter
 */
export type MetadataFilter = Message<"abacus.v2.MetadataFilter"> & {
	/**
	 * @generated from field: string metadata_key = 1;
	 */
	metadataKey: string;

	/**
	 * @generated from field: repeated google.protobuf.Value metadata_values = 2;
	 */
	metadataValues: Value[];
};

/**
 * @generated from message abacus.v2.MetadataFilter
 */
export type MetadataFilterJson = {
	/**
	 * @generated from field: string metadata_key = 1;
	 */
	metadataKey?: string;

	/**
	 * @generated from field: repeated google.protobuf.Value metadata_values = 2;
	 */
	metadataValues?: ValueJson[];
};

/**
 * Describes the message abacus.v2.MetadataFilter.
 * Use `create(MetadataFilterSchema)` to create a new message.
 */
export const MetadataFilterSchema: GenMessage<MetadataFilter, { jsonType: MetadataFilterJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 47);

/**
 * @generated from message abacus.v2.FormResponseFilter
 */
export type FormResponseFilter = Message<"abacus.v2.FormResponseFilter"> & {
	/**
	 * @generated from field: string field_id = 1;
	 */
	fieldId: string;

	/**
	 * @generated from field: repeated google.protobuf.Value form_response_values = 2;
	 */
	formResponseValues: Value[];
};

/**
 * @generated from message abacus.v2.FormResponseFilter
 */
export type FormResponseFilterJson = {
	/**
	 * @generated from field: string field_id = 1;
	 */
	fieldId?: string;

	/**
	 * @generated from field: repeated google.protobuf.Value form_response_values = 2;
	 */
	formResponseValues?: ValueJson[];
};

/**
 * Describes the message abacus.v2.FormResponseFilter.
 * Use `create(FormResponseFilterSchema)` to create a new message.
 */
export const FormResponseFilterSchema: GenMessage<FormResponseFilter, { jsonType: FormResponseFilterJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 48);

/**
 * @generated from message abacus.v2.TagFilter
 */
export type TagFilter = Message<"abacus.v2.TagFilter"> & {
	/**
	 * @generated from field: repeated string tags = 1;
	 */
	tags: string[];
};

/**
 * @generated from message abacus.v2.TagFilter
 */
export type TagFilterJson = {
	/**
	 * @generated from field: repeated string tags = 1;
	 */
	tags?: string[];
};

/**
 * Describes the message abacus.v2.TagFilter.
 * Use `create(TagFilterSchema)` to create a new message.
 */
export const TagFilterSchema: GenMessage<TagFilter, { jsonType: TagFilterJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 49);

/**
 * @generated from message abacus.v2.FolderFilter
 */
export type FolderFilter = Message<"abacus.v2.FolderFilter"> & {
	/**
	 * @generated from field: repeated string folder_ids = 1;
	 */
	folderIds: string[];
};

/**
 * @generated from message abacus.v2.FolderFilter
 */
export type FolderFilterJson = {
	/**
	 * @generated from field: repeated string folder_ids = 1;
	 */
	folderIds?: string[];
};

/**
 * Describes the message abacus.v2.FolderFilter.
 * Use `create(FolderFilterSchema)` to create a new message.
 */
export const FolderFilterSchema: GenMessage<FolderFilter, { jsonType: FolderFilterJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 50);

/**
 * @generated from message abacus.v2.CurrentTagFilter
 */
export type CurrentTagFilter = Message<"abacus.v2.CurrentTagFilter"> & {
	/**
	 * @generated from field: repeated string tags = 1;
	 */
	tags: string[];
};

/**
 * @generated from message abacus.v2.CurrentTagFilter
 */
export type CurrentTagFilterJson = {
	/**
	 * @generated from field: repeated string tags = 1;
	 */
	tags?: string[];
};

/**
 * Describes the message abacus.v2.CurrentTagFilter.
 * Use `create(CurrentTagFilterSchema)` to create a new message.
 */
export const CurrentTagFilterSchema: GenMessage<CurrentTagFilter, { jsonType: CurrentTagFilterJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 51);

/**
 * @generated from message abacus.v2.CurrentFolderFilter
 */
export type CurrentFolderFilter = Message<"abacus.v2.CurrentFolderFilter"> & {
	/**
	 * @generated from field: repeated string folder_ids = 1;
	 */
	folderIds: string[];
};

/**
 * @generated from message abacus.v2.CurrentFolderFilter
 */
export type CurrentFolderFilterJson = {
	/**
	 * @generated from field: repeated string folder_ids = 1;
	 */
	folderIds?: string[];
};

/**
 * Describes the message abacus.v2.CurrentFolderFilter.
 * Use `create(CurrentFolderFilterSchema)` to create a new message.
 */
export const CurrentFolderFilterSchema: GenMessage<CurrentFolderFilter, { jsonType: CurrentFolderFilterJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 52);

/**
 * @generated from message abacus.v2.AudienceMemberFilter
 */
export type AudienceMemberFilter = Message<"abacus.v2.AudienceMemberFilter"> & {
	/**
	 * @generated from field: string audience_id = 1;
	 */
	audienceId: string;

	/**
	 * @generated from field: string run_id = 2;
	 */
	runId: string;
};

/**
 * @generated from message abacus.v2.AudienceMemberFilter
 */
export type AudienceMemberFilterJson = {
	/**
	 * @generated from field: string audience_id = 1;
	 */
	audienceId?: string;

	/**
	 * @generated from field: string run_id = 2;
	 */
	runId?: string;
};

/**
 * Describes the message abacus.v2.AudienceMemberFilter.
 * Use `create(AudienceMemberFilterSchema)` to create a new message.
 */
export const AudienceMemberFilterSchema: GenMessage<AudienceMemberFilter, { jsonType: AudienceMemberFilterJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 53);

/**
 * @generated from message abacus.v2.PrimaryIdFilter
 */
export type PrimaryIdFilter = Message<"abacus.v2.PrimaryIdFilter"> & {
	/**
	 * @generated from field: string primary_key = 1;
	 */
	primaryKey: string;

	/**
	 * @generated from field: string primary_id = 2;
	 */
	primaryId: string;
};

/**
 * @generated from message abacus.v2.PrimaryIdFilter
 */
export type PrimaryIdFilterJson = {
	/**
	 * @generated from field: string primary_key = 1;
	 */
	primaryKey?: string;

	/**
	 * @generated from field: string primary_id = 2;
	 */
	primaryId?: string;
};

/**
 * Describes the message abacus.v2.PrimaryIdFilter.
 * Use `create(PrimaryIdFilterSchema)` to create a new message.
 */
export const PrimaryIdFilterSchema: GenMessage<PrimaryIdFilter, { jsonType: PrimaryIdFilterJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 54);

/**
 * @generated from message abacus.v2.ContactsFilter
 */
export type ContactsFilter = Message<"abacus.v2.ContactsFilter"> & {
	/**
	 * @generated from field: optional string primary_id = 17;
	 */
	primaryId?: string | undefined;

	/**
	 * @generated from field: optional string email = 1;
	 */
	email?: string | undefined;

	/**
	 * @generated from field: optional string name = 2;
	 */
	name?: string | undefined;

	/**
	 * @generated from field: abacus.v2.DateFilter date_filter = 3;
	 */
	dateFilter?: DateFilter | undefined;

	/**
	 * @generated from field: repeated string suites = 4;
	 */
	suites: string[];

	/**
	 * @generated from field: repeated string cities = 7;
	 */
	cities: string[];

	/**
	 * @generated from field: repeated string states = 8;
	 */
	states: string[];

	/**
	 * @generated from field: repeated string postal_codes = 9;
	 */
	postalCodes: string[];

	/**
	 * @generated from field: repeated string past_interaction_types = 11;
	 */
	pastInteractionTypes: string[];

	/**
	 * @generated from field: repeated string contact_property_keys = 15;
	 */
	contactPropertyKeys: string[];

	/**
	 * @generated from field: repeated abacus.v2.SchemaPropertyRef property_refs = 24;
	 */
	propertyRefs: SchemaPropertyRef[];

	/**
	 * @generated from field: repeated bundles.v1.ConversionType past_conversion_types = 12;
	 */
	pastConversionTypes: ConversionType[];

	/**
	 * @generated from field: repeated abacus.v2.SegmentLevel engagement_level = 10;
	 */
	engagementLevel: SegmentLevel[];

	/**
	 * @generated from field: repeated bundles.v1.EntryPoint entry_point_filter = 14;
	 */
	entryPointFilter: EntryPoint[];

	/**
	 * @generated from field: repeated string include_flow_ids = 21;
	 */
	includeFlowIds: string[];

	/**
	 * @generated from field: repeated string exclude_flow_ids = 22;
	 */
	excludeFlowIds: string[];

	/**
	 * @generated from field: bool hide_bot_traffic = 16;
	 */
	hideBotTraffic: boolean;

	/**
	 * @generated from field: optional bool is_bot = 19;
	 */
	isBot?: boolean | undefined;

	/**
	 * @generated from field: optional bool is_verified = 20;
	 */
	isVerified?: boolean | undefined;

	/**
	 * @generated from field: string connection_id = 18;
	 */
	connectionId: string;

	/**
	 * @generated from field: abacus.v2.AudienceMemberFilter audience_member_filter = 23;
	 */
	audienceMemberFilter?: AudienceMemberFilter | undefined;

	/**
	 * @generated from field: abacus.v2.AdvancedFilter advanced_filter = 13;
	 */
	advancedFilter?: AdvancedFilter | undefined;

	/**
	 * @generated from field: abacus.v2.AttendanceFilter attendance_filter = 25;
	 */
	attendanceFilter?: AttendanceFilter | undefined;
};

/**
 * @generated from message abacus.v2.ContactsFilter
 */
export type ContactsFilterJson = {
	/**
	 * @generated from field: optional string primary_id = 17;
	 */
	primaryId?: string;

	/**
	 * @generated from field: optional string email = 1;
	 */
	email?: string;

	/**
	 * @generated from field: optional string name = 2;
	 */
	name?: string;

	/**
	 * @generated from field: abacus.v2.DateFilter date_filter = 3;
	 */
	dateFilter?: DateFilterJson;

	/**
	 * @generated from field: repeated string suites = 4;
	 */
	suites?: string[];

	/**
	 * @generated from field: repeated string cities = 7;
	 */
	cities?: string[];

	/**
	 * @generated from field: repeated string states = 8;
	 */
	states?: string[];

	/**
	 * @generated from field: repeated string postal_codes = 9;
	 */
	postalCodes?: string[];

	/**
	 * @generated from field: repeated string past_interaction_types = 11;
	 */
	pastInteractionTypes?: string[];

	/**
	 * @generated from field: repeated string contact_property_keys = 15;
	 */
	contactPropertyKeys?: string[];

	/**
	 * @generated from field: repeated abacus.v2.SchemaPropertyRef property_refs = 24;
	 */
	propertyRefs?: SchemaPropertyRefJson[];

	/**
	 * @generated from field: repeated bundles.v1.ConversionType past_conversion_types = 12;
	 */
	pastConversionTypes?: ConversionTypeJson[];

	/**
	 * @generated from field: repeated abacus.v2.SegmentLevel engagement_level = 10;
	 */
	engagementLevel?: SegmentLevelJson[];

	/**
	 * @generated from field: repeated bundles.v1.EntryPoint entry_point_filter = 14;
	 */
	entryPointFilter?: EntryPointJson[];

	/**
	 * @generated from field: repeated string include_flow_ids = 21;
	 */
	includeFlowIds?: string[];

	/**
	 * @generated from field: repeated string exclude_flow_ids = 22;
	 */
	excludeFlowIds?: string[];

	/**
	 * @generated from field: bool hide_bot_traffic = 16;
	 */
	hideBotTraffic?: boolean;

	/**
	 * @generated from field: optional bool is_bot = 19;
	 */
	isBot?: boolean;

	/**
	 * @generated from field: optional bool is_verified = 20;
	 */
	isVerified?: boolean;

	/**
	 * @generated from field: string connection_id = 18;
	 */
	connectionId?: string;

	/**
	 * @generated from field: abacus.v2.AudienceMemberFilter audience_member_filter = 23;
	 */
	audienceMemberFilter?: AudienceMemberFilterJson;

	/**
	 * @generated from field: abacus.v2.AdvancedFilter advanced_filter = 13;
	 */
	advancedFilter?: AdvancedFilterJson;

	/**
	 * @generated from field: abacus.v2.AttendanceFilter attendance_filter = 25;
	 */
	attendanceFilter?: AttendanceFilterJson;
};

/**
 * Describes the message abacus.v2.ContactsFilter.
 * Use `create(ContactsFilterSchema)` to create a new message.
 */
export const ContactsFilterSchema: GenMessage<ContactsFilter, { jsonType: ContactsFilterJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 55);

/**
 * @generated from message abacus.v2.AttendanceFilter
 */
export type AttendanceFilter = Message<"abacus.v2.AttendanceFilter"> & {
	/**
	 * @generated from field: string calendar_id = 1;
	 */
	calendarId: string;

	/**
	 * @generated from field: string event_id = 2;
	 */
	eventId: string;
};

/**
 * @generated from message abacus.v2.AttendanceFilter
 */
export type AttendanceFilterJson = {
	/**
	 * @generated from field: string calendar_id = 1;
	 */
	calendarId?: string;

	/**
	 * @generated from field: string event_id = 2;
	 */
	eventId?: string;
};

/**
 * Describes the message abacus.v2.AttendanceFilter.
 * Use `create(AttendanceFilterSchema)` to create a new message.
 */
export const AttendanceFilterSchema: GenMessage<AttendanceFilter, { jsonType: AttendanceFilterJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 56);

/**
 * @generated from message abacus.v2.ActivityFilter
 */
export type ActivityFilter = Message<"abacus.v2.ActivityFilter"> & {
	/**
	 * @generated from field: string suite_id = 1;
	 */
	suiteId: string;

	/**
	 * @generated from field: string primary_key = 23;
	 */
	primaryKey: string;

	/**
	 * @generated from field: string primary_id = 16;
	 */
	primaryId: string;

	/**
	 * @generated from field: string email = 2;
	 */
	email: string;

	/**
	 * @generated from field: string primary_id_partial = 22;
	 */
	primaryIdPartial: string;

	/**
	 * @generated from field: string key = 5;
	 */
	key: string;

	/**
	 * @generated from field: string name = 8;
	 */
	name: string;

	/**
	 * @generated from field: string event_name = 19;
	 */
	eventName: string;

	/**
	 * @generated from field: string form_id = 20;
	 */
	formId: string;

	/**
	 * @generated from field: string product_id = 21;
	 */
	productId: string;

	/**
	 * @generated from field: repeated string event_types = 3;
	 */
	eventTypes: string[];

	/**
	 * @generated from field: repeated bundles.v1.ConversionType conversion_types = 4;
	 */
	conversionTypes: ConversionType[];

	/**
	 * @generated from field: repeated abacus.v2.MetadataFilter metadata_filter = 6;
	 */
	metadataFilter: MetadataFilter[];

	/**
	 * @generated from field: repeated abacus.v2.TagFilter tag_filter = 7;
	 */
	tagFilter: TagFilter[];

	/**
	 * @generated from field: repeated abacus.v2.FolderFilter folder_filter = 10;
	 */
	folderFilter: FolderFilter[];

	/**
	 * @generated from field: repeated abacus.v2.CurrentTagFilter current_tag_filter = 11;
	 */
	currentTagFilter: CurrentTagFilter[];

	/**
	 * @generated from field: repeated abacus.v2.CurrentFolderFilter current_folder_filter = 12;
	 */
	currentFolderFilter: CurrentFolderFilter[];

	/**
	 * @generated from field: repeated bundles.v1.EntryPoint entry_point_filter = 9;
	 */
	entryPointFilter: EntryPoint[];

	/**
	 * @generated from field: repeated abacus.v2.FormResponseFilter form_response_filter = 15;
	 */
	formResponseFilter: FormResponseFilter[];

	/**
	 * @generated from field: bool hide_bot_traffic = 14;
	 */
	hideBotTraffic: boolean;

	/**
	 * @generated from field: optional bool is_bot = 17;
	 */
	isBot?: boolean | undefined;

	/**
	 * @generated from field: optional bool is_verified = 18;
	 */
	isVerified?: boolean | undefined;

	/**
	 * @generated from field: abacus.v2.AdvancedFilter advanced_filter = 13;
	 */
	advancedFilter?: AdvancedFilter | undefined;
};

/**
 * @generated from message abacus.v2.ActivityFilter
 */
export type ActivityFilterJson = {
	/**
	 * @generated from field: string suite_id = 1;
	 */
	suiteId?: string;

	/**
	 * @generated from field: string primary_key = 23;
	 */
	primaryKey?: string;

	/**
	 * @generated from field: string primary_id = 16;
	 */
	primaryId?: string;

	/**
	 * @generated from field: string email = 2;
	 */
	email?: string;

	/**
	 * @generated from field: string primary_id_partial = 22;
	 */
	primaryIdPartial?: string;

	/**
	 * @generated from field: string key = 5;
	 */
	key?: string;

	/**
	 * @generated from field: string name = 8;
	 */
	name?: string;

	/**
	 * @generated from field: string event_name = 19;
	 */
	eventName?: string;

	/**
	 * @generated from field: string form_id = 20;
	 */
	formId?: string;

	/**
	 * @generated from field: string product_id = 21;
	 */
	productId?: string;

	/**
	 * @generated from field: repeated string event_types = 3;
	 */
	eventTypes?: string[];

	/**
	 * @generated from field: repeated bundles.v1.ConversionType conversion_types = 4;
	 */
	conversionTypes?: ConversionTypeJson[];

	/**
	 * @generated from field: repeated abacus.v2.MetadataFilter metadata_filter = 6;
	 */
	metadataFilter?: MetadataFilterJson[];

	/**
	 * @generated from field: repeated abacus.v2.TagFilter tag_filter = 7;
	 */
	tagFilter?: TagFilterJson[];

	/**
	 * @generated from field: repeated abacus.v2.FolderFilter folder_filter = 10;
	 */
	folderFilter?: FolderFilterJson[];

	/**
	 * @generated from field: repeated abacus.v2.CurrentTagFilter current_tag_filter = 11;
	 */
	currentTagFilter?: CurrentTagFilterJson[];

	/**
	 * @generated from field: repeated abacus.v2.CurrentFolderFilter current_folder_filter = 12;
	 */
	currentFolderFilter?: CurrentFolderFilterJson[];

	/**
	 * @generated from field: repeated bundles.v1.EntryPoint entry_point_filter = 9;
	 */
	entryPointFilter?: EntryPointJson[];

	/**
	 * @generated from field: repeated abacus.v2.FormResponseFilter form_response_filter = 15;
	 */
	formResponseFilter?: FormResponseFilterJson[];

	/**
	 * @generated from field: bool hide_bot_traffic = 14;
	 */
	hideBotTraffic?: boolean;

	/**
	 * @generated from field: optional bool is_bot = 17;
	 */
	isBot?: boolean;

	/**
	 * @generated from field: optional bool is_verified = 18;
	 */
	isVerified?: boolean;

	/**
	 * @generated from field: abacus.v2.AdvancedFilter advanced_filter = 13;
	 */
	advancedFilter?: AdvancedFilterJson;
};

/**
 * Describes the message abacus.v2.ActivityFilter.
 * Use `create(ActivityFilterSchema)` to create a new message.
 */
export const ActivityFilterSchema: GenMessage<ActivityFilter, { jsonType: ActivityFilterJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 57);

/**
 * @generated from message abacus.v2.ConversionRateFilter
 */
export type ConversionRateFilter = Message<"abacus.v2.ConversionRateFilter"> & {
	/**
	 * @generated from field: bundles.v1.ConversionType conversion_type = 1;
	 */
	conversionType: ConversionType;

	/**
	 * @generated from field: string suite_id = 2;
	 */
	suiteId: string;

	/**
	 * @generated from field: string key = 3;
	 */
	key: string;

	/**
	 * @generated from field: repeated abacus.v2.MetadataFilter metadata_filter = 4;
	 */
	metadataFilter: MetadataFilter[];

	/**
	 * @generated from field: repeated abacus.v2.TagFilter tag_filter = 5;
	 */
	tagFilter: TagFilter[];

	/**
	 * @generated from field: repeated abacus.v2.FolderFilter folder_filter = 7;
	 */
	folderFilter: FolderFilter[];

	/**
	 * @generated from field: repeated abacus.v2.CurrentTagFilter current_tag_filter = 8;
	 */
	currentTagFilter: CurrentTagFilter[];

	/**
	 * @generated from field: repeated abacus.v2.CurrentFolderFilter current_folder_filter = 9;
	 */
	currentFolderFilter: CurrentFolderFilter[];

	/**
	 * @generated from field: repeated bundles.v1.EntryPoint entry_point_filter = 6;
	 */
	entryPointFilter: EntryPoint[];

	/**
	 * @generated from field: repeated string field_id_filter = 12;
	 */
	fieldIdFilter: string[];

	/**
	 * @generated from field: repeated string currency_codes = 14;
	 */
	currencyCodes: string[];

	/**
	 * @generated from field: repeated bundles.v1.ConversionType conversion_types = 17;
	 */
	conversionTypes: ConversionType[];

	/**
	 * @generated from field: repeated string flow_ids = 18;
	 */
	flowIds: string[];

	/**
	 * @generated from field: repeated abacus.v2.PrimaryIdFilter primary_ids = 19;
	 */
	primaryIds: PrimaryIdFilter[];

	/**
	 * @generated from field: bool international_geo_enabled = 11;
	 */
	internationalGeoEnabled: boolean;

	/**
	 * @generated from field: bool hide_bot_traffic = 13;
	 */
	hideBotTraffic: boolean;

	/**
	 * @generated from field: optional bool is_bot = 15;
	 */
	isBot?: boolean | undefined;

	/**
	 * @generated from field: optional bool is_verified = 16;
	 */
	isVerified?: boolean | undefined;

	/**
	 * @generated from field: abacus.v2.AdvancedFilter advanced_filter = 10;
	 */
	advancedFilter?: AdvancedFilter | undefined;
};

/**
 * @generated from message abacus.v2.ConversionRateFilter
 */
export type ConversionRateFilterJson = {
	/**
	 * @generated from field: bundles.v1.ConversionType conversion_type = 1;
	 */
	conversionType?: ConversionTypeJson;

	/**
	 * @generated from field: string suite_id = 2;
	 */
	suiteId?: string;

	/**
	 * @generated from field: string key = 3;
	 */
	key?: string;

	/**
	 * @generated from field: repeated abacus.v2.MetadataFilter metadata_filter = 4;
	 */
	metadataFilter?: MetadataFilterJson[];

	/**
	 * @generated from field: repeated abacus.v2.TagFilter tag_filter = 5;
	 */
	tagFilter?: TagFilterJson[];

	/**
	 * @generated from field: repeated abacus.v2.FolderFilter folder_filter = 7;
	 */
	folderFilter?: FolderFilterJson[];

	/**
	 * @generated from field: repeated abacus.v2.CurrentTagFilter current_tag_filter = 8;
	 */
	currentTagFilter?: CurrentTagFilterJson[];

	/**
	 * @generated from field: repeated abacus.v2.CurrentFolderFilter current_folder_filter = 9;
	 */
	currentFolderFilter?: CurrentFolderFilterJson[];

	/**
	 * @generated from field: repeated bundles.v1.EntryPoint entry_point_filter = 6;
	 */
	entryPointFilter?: EntryPointJson[];

	/**
	 * @generated from field: repeated string field_id_filter = 12;
	 */
	fieldIdFilter?: string[];

	/**
	 * @generated from field: repeated string currency_codes = 14;
	 */
	currencyCodes?: string[];

	/**
	 * @generated from field: repeated bundles.v1.ConversionType conversion_types = 17;
	 */
	conversionTypes?: ConversionTypeJson[];

	/**
	 * @generated from field: repeated string flow_ids = 18;
	 */
	flowIds?: string[];

	/**
	 * @generated from field: repeated abacus.v2.PrimaryIdFilter primary_ids = 19;
	 */
	primaryIds?: PrimaryIdFilterJson[];

	/**
	 * @generated from field: bool international_geo_enabled = 11;
	 */
	internationalGeoEnabled?: boolean;

	/**
	 * @generated from field: bool hide_bot_traffic = 13;
	 */
	hideBotTraffic?: boolean;

	/**
	 * @generated from field: optional bool is_bot = 15;
	 */
	isBot?: boolean;

	/**
	 * @generated from field: optional bool is_verified = 16;
	 */
	isVerified?: boolean;

	/**
	 * @generated from field: abacus.v2.AdvancedFilter advanced_filter = 10;
	 */
	advancedFilter?: AdvancedFilterJson;
};

/**
 * Describes the message abacus.v2.ConversionRateFilter.
 * Use `create(ConversionRateFilterSchema)` to create a new message.
 */
export const ConversionRateFilterSchema: GenMessage<ConversionRateFilter, { jsonType: ConversionRateFilterJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 58);

/**
 * @generated from message abacus.v2.ConversionFilter
 */
export type ConversionFilter = Message<"abacus.v2.ConversionFilter"> & {
	/**
	 * @generated from field: optional string name = 1;
	 */
	name?: string | undefined;

	/**
	 * @generated from field: optional bundles.v1.ConversionType conversion_type = 2;
	 */
	conversionType?: ConversionType | undefined;

	/**
	 * @generated from field: repeated abacus.v2.MetadataFilter metadata_filter = 3;
	 */
	metadataFilter: MetadataFilter[];

	/**
	 * @generated from field: repeated abacus.v2.TagFilter tag_filter = 4;
	 */
	tagFilter: TagFilter[];

	/**
	 * @generated from field: repeated abacus.v2.FolderFilter folder_filter = 6;
	 */
	folderFilter: FolderFilter[];

	/**
	 * @generated from field: repeated abacus.v2.CurrentTagFilter current_tag_filter = 7;
	 */
	currentTagFilter: CurrentTagFilter[];

	/**
	 * @generated from field: repeated abacus.v2.CurrentFolderFilter current_folder_filter = 8;
	 */
	currentFolderFilter: CurrentFolderFilter[];

	/**
	 * @generated from field: repeated bundles.v1.EntryPoint entry_point_filter = 5;
	 */
	entryPointFilter: EntryPoint[];

	/**
	 * @generated from field: bool hide_bot_traffic = 10;
	 */
	hideBotTraffic: boolean;

	/**
	 * @generated from field: optional bool is_bot = 11;
	 */
	isBot?: boolean | undefined;

	/**
	 * @generated from field: optional bool is_verified = 12;
	 */
	isVerified?: boolean | undefined;

	/**
	 * @generated from field: abacus.v2.AdvancedFilter advanced_filter = 9;
	 */
	advancedFilter?: AdvancedFilter | undefined;
};

/**
 * @generated from message abacus.v2.ConversionFilter
 */
export type ConversionFilterJson = {
	/**
	 * @generated from field: optional string name = 1;
	 */
	name?: string;

	/**
	 * @generated from field: optional bundles.v1.ConversionType conversion_type = 2;
	 */
	conversionType?: ConversionTypeJson;

	/**
	 * @generated from field: repeated abacus.v2.MetadataFilter metadata_filter = 3;
	 */
	metadataFilter?: MetadataFilterJson[];

	/**
	 * @generated from field: repeated abacus.v2.TagFilter tag_filter = 4;
	 */
	tagFilter?: TagFilterJson[];

	/**
	 * @generated from field: repeated abacus.v2.FolderFilter folder_filter = 6;
	 */
	folderFilter?: FolderFilterJson[];

	/**
	 * @generated from field: repeated abacus.v2.CurrentTagFilter current_tag_filter = 7;
	 */
	currentTagFilter?: CurrentTagFilterJson[];

	/**
	 * @generated from field: repeated abacus.v2.CurrentFolderFilter current_folder_filter = 8;
	 */
	currentFolderFilter?: CurrentFolderFilterJson[];

	/**
	 * @generated from field: repeated bundles.v1.EntryPoint entry_point_filter = 5;
	 */
	entryPointFilter?: EntryPointJson[];

	/**
	 * @generated from field: bool hide_bot_traffic = 10;
	 */
	hideBotTraffic?: boolean;

	/**
	 * @generated from field: optional bool is_bot = 11;
	 */
	isBot?: boolean;

	/**
	 * @generated from field: optional bool is_verified = 12;
	 */
	isVerified?: boolean;

	/**
	 * @generated from field: abacus.v2.AdvancedFilter advanced_filter = 9;
	 */
	advancedFilter?: AdvancedFilterJson;
};

/**
 * Describes the message abacus.v2.ConversionFilter.
 * Use `create(ConversionFilterSchema)` to create a new message.
 */
export const ConversionFilterSchema: GenMessage<ConversionFilter, { jsonType: ConversionFilterJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 59);

/**
 * @generated from message abacus.v2.ConversionTypeFilter
 */
export type ConversionTypeFilter = Message<"abacus.v2.ConversionTypeFilter"> & {
	/**
	 * @generated from field: string suite_id = 1;
	 */
	suiteId: string;

	/**
	 * @generated from field: string key = 2;
	 */
	key: string;

	/**
	 * @generated from field: repeated abacus.v2.MetadataFilter metadata_filter = 3;
	 */
	metadataFilter: MetadataFilter[];

	/**
	 * @generated from field: repeated abacus.v2.TagFilter tag_filter = 4;
	 */
	tagFilter: TagFilter[];

	/**
	 * @generated from field: repeated abacus.v2.FolderFilter folder_filter = 6;
	 */
	folderFilter: FolderFilter[];

	/**
	 * @generated from field: repeated abacus.v2.CurrentTagFilter current_tag_filter = 7;
	 */
	currentTagFilter: CurrentTagFilter[];

	/**
	 * @generated from field: repeated abacus.v2.CurrentFolderFilter current_folder_filter = 8;
	 */
	currentFolderFilter: CurrentFolderFilter[];

	/**
	 * @generated from field: repeated bundles.v1.EntryPoint entry_point_filter = 5;
	 */
	entryPointFilter: EntryPoint[];

	/**
	 * @generated from field: repeated string experiment_key_filter = 11;
	 */
	experimentKeyFilter: string[];

	/**
	 * @generated from field: repeated string currency_codes = 13;
	 */
	currencyCodes: string[];

	/**
	 * @generated from field: repeated bundles.v1.ConversionType conversion_types = 16;
	 */
	conversionTypes: ConversionType[];

	/**
	 * @generated from field: bool international_geo_enabled = 10;
	 */
	internationalGeoEnabled: boolean;

	/**
	 * @generated from field: bool hide_bot_traffic = 12;
	 */
	hideBotTraffic: boolean;

	/**
	 * @generated from field: optional bool is_bot = 14;
	 */
	isBot?: boolean | undefined;

	/**
	 * @generated from field: optional bool is_verified = 15;
	 */
	isVerified?: boolean | undefined;

	/**
	 * @generated from field: abacus.v2.AdvancedFilter advanced_filter = 9;
	 */
	advancedFilter?: AdvancedFilter | undefined;
};

/**
 * @generated from message abacus.v2.ConversionTypeFilter
 */
export type ConversionTypeFilterJson = {
	/**
	 * @generated from field: string suite_id = 1;
	 */
	suiteId?: string;

	/**
	 * @generated from field: string key = 2;
	 */
	key?: string;

	/**
	 * @generated from field: repeated abacus.v2.MetadataFilter metadata_filter = 3;
	 */
	metadataFilter?: MetadataFilterJson[];

	/**
	 * @generated from field: repeated abacus.v2.TagFilter tag_filter = 4;
	 */
	tagFilter?: TagFilterJson[];

	/**
	 * @generated from field: repeated abacus.v2.FolderFilter folder_filter = 6;
	 */
	folderFilter?: FolderFilterJson[];

	/**
	 * @generated from field: repeated abacus.v2.CurrentTagFilter current_tag_filter = 7;
	 */
	currentTagFilter?: CurrentTagFilterJson[];

	/**
	 * @generated from field: repeated abacus.v2.CurrentFolderFilter current_folder_filter = 8;
	 */
	currentFolderFilter?: CurrentFolderFilterJson[];

	/**
	 * @generated from field: repeated bundles.v1.EntryPoint entry_point_filter = 5;
	 */
	entryPointFilter?: EntryPointJson[];

	/**
	 * @generated from field: repeated string experiment_key_filter = 11;
	 */
	experimentKeyFilter?: string[];

	/**
	 * @generated from field: repeated string currency_codes = 13;
	 */
	currencyCodes?: string[];

	/**
	 * @generated from field: repeated bundles.v1.ConversionType conversion_types = 16;
	 */
	conversionTypes?: ConversionTypeJson[];

	/**
	 * @generated from field: bool international_geo_enabled = 10;
	 */
	internationalGeoEnabled?: boolean;

	/**
	 * @generated from field: bool hide_bot_traffic = 12;
	 */
	hideBotTraffic?: boolean;

	/**
	 * @generated from field: optional bool is_bot = 14;
	 */
	isBot?: boolean;

	/**
	 * @generated from field: optional bool is_verified = 15;
	 */
	isVerified?: boolean;

	/**
	 * @generated from field: abacus.v2.AdvancedFilter advanced_filter = 9;
	 */
	advancedFilter?: AdvancedFilterJson;
};

/**
 * Describes the message abacus.v2.ConversionTypeFilter.
 * Use `create(ConversionTypeFilterSchema)` to create a new message.
 */
export const ConversionTypeFilterSchema: GenMessage<ConversionTypeFilter, { jsonType: ConversionTypeFilterJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 60);

/**
 * @generated from message abacus.v2.DashboardFilter
 */
export type DashboardFilter = Message<"abacus.v2.DashboardFilter"> & {
	/**
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval: Interval;

	/**
	 * @generated from field: string timezone = 2;
	 */
	timezone: string;

	/**
	 * @generated from field: optional abacus.v2.TimeRange time_range = 3;
	 */
	timeRange?: TimeRange | undefined;

	/**
	 * @generated from field: abacus.v2.ContactsFilter contacts_filter = 4;
	 */
	contactsFilter?: ContactsFilter | undefined;

	/**
	 * @generated from field: abacus.v2.ActivityFilter activity_filter = 5;
	 */
	activityFilter?: ActivityFilter | undefined;

	/**
	 * @generated from field: abacus.v2.ConversionRateFilter conversion_rate_filter = 6;
	 */
	conversionRateFilter?: ConversionRateFilter | undefined;

	/**
	 * @generated from field: abacus.v2.ConversionFilter conversion_filter = 7;
	 */
	conversionFilter?: ConversionFilter | undefined;

	/**
	 * @generated from field: abacus.v2.ConversionTypeFilter conversion_type_filter = 8;
	 */
	conversionTypeFilter?: ConversionTypeFilter | undefined;
};

/**
 * @generated from message abacus.v2.DashboardFilter
 */
export type DashboardFilterJson = {
	/**
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval?: IntervalJson;

	/**
	 * @generated from field: string timezone = 2;
	 */
	timezone?: string;

	/**
	 * @generated from field: optional abacus.v2.TimeRange time_range = 3;
	 */
	timeRange?: TimeRangeJson;

	/**
	 * @generated from field: abacus.v2.ContactsFilter contacts_filter = 4;
	 */
	contactsFilter?: ContactsFilterJson;

	/**
	 * @generated from field: abacus.v2.ActivityFilter activity_filter = 5;
	 */
	activityFilter?: ActivityFilterJson;

	/**
	 * @generated from field: abacus.v2.ConversionRateFilter conversion_rate_filter = 6;
	 */
	conversionRateFilter?: ConversionRateFilterJson;

	/**
	 * @generated from field: abacus.v2.ConversionFilter conversion_filter = 7;
	 */
	conversionFilter?: ConversionFilterJson;

	/**
	 * @generated from field: abacus.v2.ConversionTypeFilter conversion_type_filter = 8;
	 */
	conversionTypeFilter?: ConversionTypeFilterJson;
};

/**
 * Describes the message abacus.v2.DashboardFilter.
 * Use `create(DashboardFilterSchema)` to create a new message.
 */
export const DashboardFilterSchema: GenMessage<DashboardFilter, { jsonType: DashboardFilterJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 61);

/**
 * @generated from message abacus.v2.ContactsFilterOptions
 */
export type ContactsFilterOptions = Message<"abacus.v2.ContactsFilterOptions"> & {
	/**
	 * @generated from field: abacus.v2.ContactsFilterType contacts_filter_type = 1;
	 */
	contactsFilterType: ContactsFilterType;

	/**
	 * @generated from field: repeated abacus.v2.FilterOption filter_options = 2;
	 */
	filterOptions: FilterOption[];

	/**
	 * @generated from field: repeated abacus.v2.FilterOption selected_filters = 4;
	 */
	selectedFilters: FilterOption[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 3;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message abacus.v2.ContactsFilterOptions
 */
export type ContactsFilterOptionsJson = {
	/**
	 * @generated from field: abacus.v2.ContactsFilterType contacts_filter_type = 1;
	 */
	contactsFilterType?: ContactsFilterTypeJson;

	/**
	 * @generated from field: repeated abacus.v2.FilterOption filter_options = 2;
	 */
	filterOptions?: FilterOptionJson[];

	/**
	 * @generated from field: repeated abacus.v2.FilterOption selected_filters = 4;
	 */
	selectedFilters?: FilterOptionJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 3;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message abacus.v2.ContactsFilterOptions.
 * Use `create(ContactsFilterOptionsSchema)` to create a new message.
 */
export const ContactsFilterOptionsSchema: GenMessage<ContactsFilterOptions, { jsonType: ContactsFilterOptionsJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 62);

/**
 * @generated from message abacus.v2.PaginatedContactsFilterType
 */
export type PaginatedContactsFilterType = Message<"abacus.v2.PaginatedContactsFilterType"> & {
	/**
	 * @generated from field: abacus.v2.ContactsFilterType contacts_filter_type = 1;
	 */
	contactsFilterType: ContactsFilterType;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArguments | undefined;

	/**
	 * @generated from field: string search_term = 5;
	 */
	searchTerm: string;

	/**
	 * @generated from field: repeated string selected = 6;
	 */
	selected: string[];
};

/**
 * @generated from message abacus.v2.PaginatedContactsFilterType
 */
export type PaginatedContactsFilterTypeJson = {
	/**
	 * @generated from field: abacus.v2.ContactsFilterType contacts_filter_type = 1;
	 */
	contactsFilterType?: ContactsFilterTypeJson;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArgumentsJson;

	/**
	 * @generated from field: string search_term = 5;
	 */
	searchTerm?: string;

	/**
	 * @generated from field: repeated string selected = 6;
	 */
	selected?: string[];
};

/**
 * Describes the message abacus.v2.PaginatedContactsFilterType.
 * Use `create(PaginatedContactsFilterTypeSchema)` to create a new message.
 */
export const PaginatedContactsFilterTypeSchema: GenMessage<PaginatedContactsFilterType, { jsonType: PaginatedContactsFilterTypeJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 63);

/**
 * ListContactsRequest request for listing contacts for a workspace.
 *
 * @generated from message abacus.v2.ListContactsRequest
 */
export type ListContactsRequest = Message<"abacus.v2.ListContactsRequest"> & {
	/**
	 * Interval for which we're querying for contacts.
	 *
	 * @generated from field: abacus.v2.Interval interval = 5;
	 */
	interval: Interval;

	/**
	 * The timezeone for the request.
	 *
	 * @generated from field: string timezone = 6;
	 */
	timezone: string;

	/**
	 * Optionally provide a time range.
	 *
	 * @generated from field: optional abacus.v2.TimeRange time_range = 7;
	 */
	timeRange?: TimeRange | undefined;

	/**
	 * The org from which contacts are being queried.
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * The workspace from which contacts are being queried.
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * Flag to include shared workspaces
	 *
	 * @generated from field: bool include_shared_workspaces = 11;
	 */
	includeSharedWorkspaces: boolean;

	/**
	 * Optional filters to retrieve a more specific view of contacts.
	 *
	 * @generated from field: abacus.v2.ContactsFilter filter = 3;
	 */
	filter?: ContactsFilter | undefined;

	/**
	 * Optional enrichment field mask to specify field(s) to include in the response object
	 * that are not returned by default.
	 * Currently only supports "properties".
	 *
	 * @generated from field: google.protobuf.FieldMask enrich_mask = 8;
	 */
	enrichMask?: FieldMask | undefined;

	/**
	 * Optional list of contact model property keys. Normalizes the
	 * contact properties returned such that all contacts will contain
	 * entries for each key. If the contact has no information for a requested
	 * key, the submission value will be nil.
	 * Only applied if the Properties field is specified in the read mask.
	 *
	 * @generated from field: repeated string workspace_property_keys = 9;
	 */
	workspacePropertyKeys: string[];

	/**
	 * Optional list of contact model property refs
	 *
	 * @generated from field: repeated abacus.v2.SchemaPropertyRef property_refs = 10;
	 */
	propertyRefs: SchemaPropertyRef[];

	/**
	 * Any pagination arguments if necessary.
	 *
	 * @generated from field: common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArguments | undefined;
};

/**
 * ListContactsRequest request for listing contacts for a workspace.
 *
 * @generated from message abacus.v2.ListContactsRequest
 */
export type ListContactsRequestJson = {
	/**
	 * Interval for which we're querying for contacts.
	 *
	 * @generated from field: abacus.v2.Interval interval = 5;
	 */
	interval?: IntervalJson;

	/**
	 * The timezeone for the request.
	 *
	 * @generated from field: string timezone = 6;
	 */
	timezone?: string;

	/**
	 * Optionally provide a time range.
	 *
	 * @generated from field: optional abacus.v2.TimeRange time_range = 7;
	 */
	timeRange?: TimeRangeJson;

	/**
	 * The org from which contacts are being queried.
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * The workspace from which contacts are being queried.
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * Flag to include shared workspaces
	 *
	 * @generated from field: bool include_shared_workspaces = 11;
	 */
	includeSharedWorkspaces?: boolean;

	/**
	 * Optional filters to retrieve a more specific view of contacts.
	 *
	 * @generated from field: abacus.v2.ContactsFilter filter = 3;
	 */
	filter?: ContactsFilterJson;

	/**
	 * Optional enrichment field mask to specify field(s) to include in the response object
	 * that are not returned by default.
	 * Currently only supports "properties".
	 *
	 * @generated from field: google.protobuf.FieldMask enrich_mask = 8;
	 */
	enrichMask?: FieldMaskJson;

	/**
	 * Optional list of contact model property keys. Normalizes the
	 * contact properties returned such that all contacts will contain
	 * entries for each key. If the contact has no information for a requested
	 * key, the submission value will be nil.
	 * Only applied if the Properties field is specified in the read mask.
	 *
	 * @generated from field: repeated string workspace_property_keys = 9;
	 */
	workspacePropertyKeys?: string[];

	/**
	 * Optional list of contact model property refs
	 *
	 * @generated from field: repeated abacus.v2.SchemaPropertyRef property_refs = 10;
	 */
	propertyRefs?: SchemaPropertyRefJson[];

	/**
	 * Any pagination arguments if necessary.
	 *
	 * @generated from field: common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message abacus.v2.ListContactsRequest.
 * Use `create(ListContactsRequestSchema)` to create a new message.
 */
export const ListContactsRequestSchema: GenMessage<ListContactsRequest, { jsonType: ListContactsRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 64);

/**
 * ListContactsResponse returns the list of contacts
 * based on the filters provided.
 *
 * @generated from message abacus.v2.ListContactsResponse
 */
export type ListContactsResponse = Message<"abacus.v2.ListContactsResponse"> & {
	/**
	 * The list of contacts
	 *
	 * @generated from field: repeated abacus.v2.Contact contacts = 1;
	 */
	contacts: Contact[];

	/**
	 * PaginationInfo for navigating between pages of results.
	 *
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * ListContactsResponse returns the list of contacts
 * based on the filters provided.
 *
 * @generated from message abacus.v2.ListContactsResponse
 */
export type ListContactsResponseJson = {
	/**
	 * The list of contacts
	 *
	 * @generated from field: repeated abacus.v2.Contact contacts = 1;
	 */
	contacts?: ContactJson[];

	/**
	 * PaginationInfo for navigating between pages of results.
	 *
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message abacus.v2.ListContactsResponse.
 * Use `create(ListContactsResponseSchema)` to create a new message.
 */
export const ListContactsResponseSchema: GenMessage<ListContactsResponse, { jsonType: ListContactsResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 65);

/**
 * ListActivityRequest request for listing activity for a workspace.
 *
 * @generated from message abacus.v2.ListActivityRequest
 */
export type ListActivityRequest = Message<"abacus.v2.ListActivityRequest"> & {
	/**
	 * The interval for which we're querying for activity.
	 *
	 * @generated from field: abacus.v2.Interval interval = 5;
	 */
	interval: Interval;

	/**
	 * The timezone for the request.
	 *
	 * @generated from field: string timezone = 6;
	 */
	timezone: string;

	/**
	 * Optionally provide a time range.
	 *
	 * @generated from field: optional abacus.v2.TimeRange time_range = 7;
	 */
	timeRange?: TimeRange | undefined;

	/**
	 * The org from which activity is being queried.
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * The workspace from which activity is being queried.
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * Flag to include shared workspaces
	 *
	 * @generated from field: bool include_shared_workspaces = 8;
	 */
	includeSharedWorkspaces: boolean;

	/**
	 * Optional filters to retrieve a more specific view of activity.
	 *
	 * @generated from field: abacus.v2.ActivityFilter filter = 3;
	 */
	filter?: ActivityFilter | undefined;

	/**
	 * Any pagination arguments if necessary.
	 *
	 * @generated from field: common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArguments | undefined;
};

/**
 * ListActivityRequest request for listing activity for a workspace.
 *
 * @generated from message abacus.v2.ListActivityRequest
 */
export type ListActivityRequestJson = {
	/**
	 * The interval for which we're querying for activity.
	 *
	 * @generated from field: abacus.v2.Interval interval = 5;
	 */
	interval?: IntervalJson;

	/**
	 * The timezone for the request.
	 *
	 * @generated from field: string timezone = 6;
	 */
	timezone?: string;

	/**
	 * Optionally provide a time range.
	 *
	 * @generated from field: optional abacus.v2.TimeRange time_range = 7;
	 */
	timeRange?: TimeRangeJson;

	/**
	 * The org from which activity is being queried.
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * The workspace from which activity is being queried.
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * Flag to include shared workspaces
	 *
	 * @generated from field: bool include_shared_workspaces = 8;
	 */
	includeSharedWorkspaces?: boolean;

	/**
	 * Optional filters to retrieve a more specific view of activity.
	 *
	 * @generated from field: abacus.v2.ActivityFilter filter = 3;
	 */
	filter?: ActivityFilterJson;

	/**
	 * Any pagination arguments if necessary.
	 *
	 * @generated from field: common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message abacus.v2.ListActivityRequest.
 * Use `create(ListActivityRequestSchema)` to create a new message.
 */
export const ListActivityRequestSchema: GenMessage<ListActivityRequest, { jsonType: ListActivityRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 66);

/**
 * ListActivityResponse returns the list of activity
 * based on the filters provided.
 *
 * @generated from message abacus.v2.ListActivityResponse
 */
export type ListActivityResponse = Message<"abacus.v2.ListActivityResponse"> & {
	/**
	 * @generated from field: repeated bundles.v1.Event events = 1;
	 */
	events: Event[];

	/**
	 * PaginationInfo for navigating between pages of results.
	 *
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * ListActivityResponse returns the list of activity
 * based on the filters provided.
 *
 * @generated from message abacus.v2.ListActivityResponse
 */
export type ListActivityResponseJson = {
	/**
	 * @generated from field: repeated bundles.v1.Event events = 1;
	 */
	events?: EventJson[];

	/**
	 * PaginationInfo for navigating between pages of results.
	 *
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message abacus.v2.ListActivityResponse.
 * Use `create(ListActivityResponseSchema)` to create a new message.
 */
export const ListActivityResponseSchema: GenMessage<ListActivityResponse, { jsonType: ListActivityResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 67);

/**
 * ListConversionRatesRequest lists metrics by a specified group.
 * See the response details for what metrics are returned for this request.
 *
 * @generated from message abacus.v2.ListConversionRatesRequest
 */
export type ListConversionRatesRequest = Message<"abacus.v2.ListConversionRatesRequest"> & {
	/**
	 * Interval for which we're querying for conversion rates.
	 *
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval: Interval;

	/**
	 * The period for which a date group will be applied.
	 *
	 * @generated from field: abacus.v2.Period period = 11;
	 */
	period: Period;

	/**
	 * The timezone for the request.
	 *
	 * @generated from field: string timezone = 2;
	 */
	timezone: string;

	/**
	 * Optionally provide a time range.
	 *
	 * @generated from field: optional abacus.v2.TimeRange time_range = 8;
	 */
	timeRange?: TimeRange | undefined;

	/**
	 * The org from which conversion rates are being queried.
	 *
	 * @generated from field: string org_id = 3;
	 */
	orgId: string;

	/**
	 * The workspace from which conversion rates are being queried.
	 *
	 * @generated from field: string workspace_id = 4;
	 */
	workspaceId: string;

	/**
	 * Flag to include shared workspaces
	 *
	 * @generated from field: bool include_shared_workspaces = 13;
	 */
	includeSharedWorkspaces: boolean;

	/**
	 * The group by parameter for the conversion rates.
	 *
	 * @generated from field: string group_by = 5;
	 */
	groupBy: string;

	/**
	 * The group by parameter for the conversion rates.
	 *
	 * @generated from field: repeated abacus.v2.Dimension dimension_group_by = 12;
	 */
	dimensionGroupBy: Dimension[];

	/**
	 * The maximum number of series to return in the response.
	 *
	 * @generated from field: int32 max_series = 9;
	 */
	maxSeries: number;

	/**
	 * Variants to use when grouping by experiment.
	 *
	 * @generated from field: repeated abacus.v2.ExperimentVariant variants = 10;
	 */
	variants: ExperimentVariant[];

	/**
	 * Metrics for requesting specific metrics
	 *
	 * @generated from field: repeated abacus.v2.Metric metrics = 14;
	 */
	metrics: Metric[];

	/**
	 * Optional flag to omit total counts from response
	 *
	 * @generated from field: optional bool omit_totals = 15;
	 */
	omitTotals?: boolean | undefined;

	/**
	 * Optional filters to retrieve a more specific view of conversion rates.
	 *
	 * @generated from field: abacus.v2.ConversionRateFilter filter = 6;
	 */
	filter?: ConversionRateFilter | undefined;

	/**
	 * Any pagination arguments if necessary.
	 *
	 * @generated from field: common.v1.PaginationArguments pagination = 7;
	 */
	pagination?: PaginationArguments | undefined;
};

/**
 * ListConversionRatesRequest lists metrics by a specified group.
 * See the response details for what metrics are returned for this request.
 *
 * @generated from message abacus.v2.ListConversionRatesRequest
 */
export type ListConversionRatesRequestJson = {
	/**
	 * Interval for which we're querying for conversion rates.
	 *
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval?: IntervalJson;

	/**
	 * The period for which a date group will be applied.
	 *
	 * @generated from field: abacus.v2.Period period = 11;
	 */
	period?: PeriodJson;

	/**
	 * The timezone for the request.
	 *
	 * @generated from field: string timezone = 2;
	 */
	timezone?: string;

	/**
	 * Optionally provide a time range.
	 *
	 * @generated from field: optional abacus.v2.TimeRange time_range = 8;
	 */
	timeRange?: TimeRangeJson;

	/**
	 * The org from which conversion rates are being queried.
	 *
	 * @generated from field: string org_id = 3;
	 */
	orgId?: string;

	/**
	 * The workspace from which conversion rates are being queried.
	 *
	 * @generated from field: string workspace_id = 4;
	 */
	workspaceId?: string;

	/**
	 * Flag to include shared workspaces
	 *
	 * @generated from field: bool include_shared_workspaces = 13;
	 */
	includeSharedWorkspaces?: boolean;

	/**
	 * The group by parameter for the conversion rates.
	 *
	 * @generated from field: string group_by = 5;
	 */
	groupBy?: string;

	/**
	 * The group by parameter for the conversion rates.
	 *
	 * @generated from field: repeated abacus.v2.Dimension dimension_group_by = 12;
	 */
	dimensionGroupBy?: DimensionJson[];

	/**
	 * The maximum number of series to return in the response.
	 *
	 * @generated from field: int32 max_series = 9;
	 */
	maxSeries?: number;

	/**
	 * Variants to use when grouping by experiment.
	 *
	 * @generated from field: repeated abacus.v2.ExperimentVariant variants = 10;
	 */
	variants?: ExperimentVariantJson[];

	/**
	 * Metrics for requesting specific metrics
	 *
	 * @generated from field: repeated abacus.v2.Metric metrics = 14;
	 */
	metrics?: MetricJson[];

	/**
	 * Optional flag to omit total counts from response
	 *
	 * @generated from field: optional bool omit_totals = 15;
	 */
	omitTotals?: boolean;

	/**
	 * Optional filters to retrieve a more specific view of conversion rates.
	 *
	 * @generated from field: abacus.v2.ConversionRateFilter filter = 6;
	 */
	filter?: ConversionRateFilterJson;

	/**
	 * Any pagination arguments if necessary.
	 *
	 * @generated from field: common.v1.PaginationArguments pagination = 7;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message abacus.v2.ListConversionRatesRequest.
 * Use `create(ListConversionRatesRequestSchema)` to create a new message.
 */
export const ListConversionRatesRequestSchema: GenMessage<ListConversionRatesRequest, { jsonType: ListConversionRatesRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 68);

/**
 * ListConversionRatesResponse returns the conversion rate data including request parameters.
 *
 * @generated from message abacus.v2.ListConversionRatesResponse
 */
export type ListConversionRatesResponse = Message<"abacus.v2.ListConversionRatesResponse"> & {
	/**
	 * Interval for which we're querying for conversion rates.
	 *
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval: Interval;

	/**
	 * The period for which a date group will be applied.
	 *
	 * @generated from field: abacus.v2.Period period = 14;
	 */
	period: Period;

	/**
	 * The timezone.
	 *
	 * @generated from field: string timezone = 2;
	 */
	timezone: string;

	/**
	 * Optional time range.
	 *
	 * @generated from field: optional abacus.v2.TimeRange time_range = 10;
	 */
	timeRange?: TimeRange | undefined;

	/**
	 * The group by parameter for the conversion rates.
	 *
	 * @generated from field: string group_by = 3;
	 */
	groupBy: string;

	/**
	 * The group by parameter for the conversion rates.
	 *
	 * @generated from field: repeated abacus.v2.Dimension dimension_group_by = 15;
	 */
	dimensionGroupBy: Dimension[];

	/**
	 * Total number of scans.
	 *
	 * @generated from field: int64 total_scans = 6;
	 */
	totalScans: bigint;

	/**
	 * Total number of clicks.
	 *
	 * @generated from field: int64 total_clicks = 11;
	 */
	totalClicks: bigint;

	/**
	 * Total number of visits.
	 *
	 * @generated from field: int64 total_visits = 12;
	 */
	totalVisits: bigint;

	/**
	 * Total number of views.
	 *
	 * @generated from field: int64 total_views = 7;
	 */
	totalViews: bigint;

	/**
	 * Total number of conversions.
	 *
	 * @generated from field: int64 total_conversions = 8;
	 */
	totalConversions: bigint;

	/**
	 * Total number of unique visitors.
	 *
	 * @generated from field: int64 total_unique_visitors = 9;
	 */
	totalUniqueVisitors: bigint;

	/**
	 * Total number of unique viewers.
	 *
	 * @generated from field: int64 total_unique_viewers = 33;
	 */
	totalUniqueViewers: bigint;

	/**
	 * Total number of unique conversions.
	 *
	 * @generated from field: int64 total_unique_conversions = 16;
	 */
	totalUniqueConversions: bigint;

	/**
	 * Total number of anonymous responses.
	 *
	 * @generated from field: int64 total_anonymous_responses = 13;
	 */
	totalAnonymousResponses: bigint;

	/**
	 * Total conversion rate.
	 *
	 * @generated from field: float total_conversion_rate = 17;
	 */
	totalConversionRate: number;

	/**
	 * Total total conversion rate.
	 *
	 * @generated from field: float total_total_conversion_rate = 18;
	 */
	totalTotalConversionRate: number;

	/**
	 * Total unique conversion rate.
	 *
	 * @generated from field: float total_unique_conversion_rate = 19;
	 */
	totalUniqueConversionRate: number;

	/**
	 * Total scans percent change vs previous period.
	 *
	 * @generated from field: float total_scans_percent_change = 20;
	 */
	totalScansPercentChange: number;

	/**
	 * Total clicks percent change vs previous period.
	 *
	 * @generated from field: float total_clicks_percent_change = 21;
	 */
	totalClicksPercentChange: number;

	/**
	 * Total visits percent change vs previous period.
	 *
	 * @generated from field: float total_visits_percent_change = 22;
	 */
	totalVisitsPercentChange: number;

	/**
	 * Total views percent change vs previous period.
	 *
	 * @generated from field: float total_views_percent_change = 23;
	 */
	totalViewsPercentChange: number;

	/**
	 * Total conversions percent change vs previous period.
	 *
	 * @generated from field: float total_conversions_percent_change = 24;
	 */
	totalConversionsPercentChange: number;

	/**
	 * Total unique visitors percent change vs previous period.
	 *
	 * @generated from field: float total_unique_visitors_percent_change = 25;
	 */
	totalUniqueVisitorsPercentChange: number;

	/**
	 * Total unique viewers percent change vs previous period.
	 *
	 * @generated from field: float total_unique_viewers_percent_change = 34;
	 */
	totalUniqueViewersPercentChange: number;

	/**
	 * Total unique conversions percent change vs previous period.
	 *
	 * @generated from field: float total_unique_conversions_percent_change = 26;
	 */
	totalUniqueConversionsPercentChange: number;

	/**
	 * Total anonymous responses percent change vs previous period.
	 *
	 * @generated from field: float total_anonymous_responses_percent_change = 27;
	 */
	totalAnonymousResponsesPercentChange: number;

	/**
	 * Total conversion rate percent change vs previous period.
	 *
	 * @generated from field: float total_conversion_rate_percent_change = 28;
	 */
	totalConversionRatePercentChange: number;

	/**
	 * Total total conversion rate percent change vs previous period.
	 *
	 * @generated from field: float total_total_conversion_rate_percent_change = 29;
	 */
	totalTotalConversionRatePercentChange: number;

	/**
	 * Total unique conversion rate percent change vs previous period.
	 *
	 * @generated from field: float total_unique_conversion_rate_percent_change = 30;
	 */
	totalUniqueConversionRatePercentChange: number;

	/**
	 * Total revenue by currency
	 *
	 * @generated from field: map<string, double> total_revenue_by_currency = 31;
	 */
	totalRevenueByCurrency: { [key: string]: number };

	/**
	 * Total revenue by currency percent change
	 *
	 * @generated from field: map<string, float> total_revenue_by_currency_percent_change = 32;
	 */
	totalRevenueByCurrencyPercentChange: { [key: string]: number };

	/**
	 * Aggregate data for the conversion rates.
	 *
	 * @generated from field: repeated abacus.v2.GroupedConversionRate conversion_rates = 4;
	 */
	conversionRates: GroupedConversionRate[];

	/**
	 * PaginationInfo for navigating between pages of results.
	 *
	 * @generated from field: common.v1.PaginationPageInfo page_info = 5;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * ListConversionRatesResponse returns the conversion rate data including request parameters.
 *
 * @generated from message abacus.v2.ListConversionRatesResponse
 */
export type ListConversionRatesResponseJson = {
	/**
	 * Interval for which we're querying for conversion rates.
	 *
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval?: IntervalJson;

	/**
	 * The period for which a date group will be applied.
	 *
	 * @generated from field: abacus.v2.Period period = 14;
	 */
	period?: PeriodJson;

	/**
	 * The timezone.
	 *
	 * @generated from field: string timezone = 2;
	 */
	timezone?: string;

	/**
	 * Optional time range.
	 *
	 * @generated from field: optional abacus.v2.TimeRange time_range = 10;
	 */
	timeRange?: TimeRangeJson;

	/**
	 * The group by parameter for the conversion rates.
	 *
	 * @generated from field: string group_by = 3;
	 */
	groupBy?: string;

	/**
	 * The group by parameter for the conversion rates.
	 *
	 * @generated from field: repeated abacus.v2.Dimension dimension_group_by = 15;
	 */
	dimensionGroupBy?: DimensionJson[];

	/**
	 * Total number of scans.
	 *
	 * @generated from field: int64 total_scans = 6;
	 */
	totalScans?: string;

	/**
	 * Total number of clicks.
	 *
	 * @generated from field: int64 total_clicks = 11;
	 */
	totalClicks?: string;

	/**
	 * Total number of visits.
	 *
	 * @generated from field: int64 total_visits = 12;
	 */
	totalVisits?: string;

	/**
	 * Total number of views.
	 *
	 * @generated from field: int64 total_views = 7;
	 */
	totalViews?: string;

	/**
	 * Total number of conversions.
	 *
	 * @generated from field: int64 total_conversions = 8;
	 */
	totalConversions?: string;

	/**
	 * Total number of unique visitors.
	 *
	 * @generated from field: int64 total_unique_visitors = 9;
	 */
	totalUniqueVisitors?: string;

	/**
	 * Total number of unique viewers.
	 *
	 * @generated from field: int64 total_unique_viewers = 33;
	 */
	totalUniqueViewers?: string;

	/**
	 * Total number of unique conversions.
	 *
	 * @generated from field: int64 total_unique_conversions = 16;
	 */
	totalUniqueConversions?: string;

	/**
	 * Total number of anonymous responses.
	 *
	 * @generated from field: int64 total_anonymous_responses = 13;
	 */
	totalAnonymousResponses?: string;

	/**
	 * Total conversion rate.
	 *
	 * @generated from field: float total_conversion_rate = 17;
	 */
	totalConversionRate?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * Total total conversion rate.
	 *
	 * @generated from field: float total_total_conversion_rate = 18;
	 */
	totalTotalConversionRate?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * Total unique conversion rate.
	 *
	 * @generated from field: float total_unique_conversion_rate = 19;
	 */
	totalUniqueConversionRate?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * Total scans percent change vs previous period.
	 *
	 * @generated from field: float total_scans_percent_change = 20;
	 */
	totalScansPercentChange?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * Total clicks percent change vs previous period.
	 *
	 * @generated from field: float total_clicks_percent_change = 21;
	 */
	totalClicksPercentChange?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * Total visits percent change vs previous period.
	 *
	 * @generated from field: float total_visits_percent_change = 22;
	 */
	totalVisitsPercentChange?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * Total views percent change vs previous period.
	 *
	 * @generated from field: float total_views_percent_change = 23;
	 */
	totalViewsPercentChange?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * Total conversions percent change vs previous period.
	 *
	 * @generated from field: float total_conversions_percent_change = 24;
	 */
	totalConversionsPercentChange?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * Total unique visitors percent change vs previous period.
	 *
	 * @generated from field: float total_unique_visitors_percent_change = 25;
	 */
	totalUniqueVisitorsPercentChange?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * Total unique viewers percent change vs previous period.
	 *
	 * @generated from field: float total_unique_viewers_percent_change = 34;
	 */
	totalUniqueViewersPercentChange?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * Total unique conversions percent change vs previous period.
	 *
	 * @generated from field: float total_unique_conversions_percent_change = 26;
	 */
	totalUniqueConversionsPercentChange?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * Total anonymous responses percent change vs previous period.
	 *
	 * @generated from field: float total_anonymous_responses_percent_change = 27;
	 */
	totalAnonymousResponsesPercentChange?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * Total conversion rate percent change vs previous period.
	 *
	 * @generated from field: float total_conversion_rate_percent_change = 28;
	 */
	totalConversionRatePercentChange?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * Total total conversion rate percent change vs previous period.
	 *
	 * @generated from field: float total_total_conversion_rate_percent_change = 29;
	 */
	totalTotalConversionRatePercentChange?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * Total unique conversion rate percent change vs previous period.
	 *
	 * @generated from field: float total_unique_conversion_rate_percent_change = 30;
	 */
	totalUniqueConversionRatePercentChange?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * Total revenue by currency
	 *
	 * @generated from field: map<string, double> total_revenue_by_currency = 31;
	 */
	totalRevenueByCurrency?: { [key: string]: number | "NaN" | "Infinity" | "-Infinity" };

	/**
	 * Total revenue by currency percent change
	 *
	 * @generated from field: map<string, float> total_revenue_by_currency_percent_change = 32;
	 */
	totalRevenueByCurrencyPercentChange?: { [key: string]: number | "NaN" | "Infinity" | "-Infinity" };

	/**
	 * Aggregate data for the conversion rates.
	 *
	 * @generated from field: repeated abacus.v2.GroupedConversionRate conversion_rates = 4;
	 */
	conversionRates?: GroupedConversionRateJson[];

	/**
	 * PaginationInfo for navigating between pages of results.
	 *
	 * @generated from field: common.v1.PaginationPageInfo page_info = 5;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message abacus.v2.ListConversionRatesResponse.
 * Use `create(ListConversionRatesResponseSchema)` to create a new message.
 */
export const ListConversionRatesResponseSchema: GenMessage<ListConversionRatesResponse, { jsonType: ListConversionRatesResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 69);

/**
 * ListConversionsByConsumerRequest is a request
 * for a list of conversion events for a particular
 * consumer.
 *
 * @generated from message abacus.v2.ListConversionsByConsumerRequest
 */
export type ListConversionsByConsumerRequest = Message<"abacus.v2.ListConversionsByConsumerRequest"> & {
	/**
	 * Email of the consumer for which you are querying.
	 *
	 * @generated from field: string email = 1;
	 */
	email: string;

	/**
	 * Primary ID of the consumer for which you are querying.
	 *
	 * @generated from field: string primary_id = 4;
	 */
	primaryId: string;

	/**
	 * For applying any filters to the user's event data that
	 * is returned from this request.
	 *
	 * @generated from field: abacus.v2.ConversionFilter filter = 2;
	 */
	filter?: ConversionFilter | undefined;

	/**
	 * PaginationInfo for navigating between pages of results.
	 *
	 * @generated from field: common.v1.PaginationArguments pagination = 3;
	 */
	pagination?: PaginationArguments | undefined;
};

/**
 * ListConversionsByConsumerRequest is a request
 * for a list of conversion events for a particular
 * consumer.
 *
 * @generated from message abacus.v2.ListConversionsByConsumerRequest
 */
export type ListConversionsByConsumerRequestJson = {
	/**
	 * Email of the consumer for which you are querying.
	 *
	 * @generated from field: string email = 1;
	 */
	email?: string;

	/**
	 * Primary ID of the consumer for which you are querying.
	 *
	 * @generated from field: string primary_id = 4;
	 */
	primaryId?: string;

	/**
	 * For applying any filters to the user's event data that
	 * is returned from this request.
	 *
	 * @generated from field: abacus.v2.ConversionFilter filter = 2;
	 */
	filter?: ConversionFilterJson;

	/**
	 * PaginationInfo for navigating between pages of results.
	 *
	 * @generated from field: common.v1.PaginationArguments pagination = 3;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message abacus.v2.ListConversionsByConsumerRequest.
 * Use `create(ListConversionsByConsumerRequestSchema)` to create a new message.
 */
export const ListConversionsByConsumerRequestSchema: GenMessage<ListConversionsByConsumerRequest, { jsonType: ListConversionsByConsumerRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 70);

/**
 * ListConversionsByConsumerResponse contains event data
 * in response to a ListConversionsByConsumerRequest
 *
 * @generated from message abacus.v2.ListConversionsByConsumerResponse
 */
export type ListConversionsByConsumerResponse = Message<"abacus.v2.ListConversionsByConsumerResponse"> & {
	/**
	 * Events linked to the user specified in the request.
	 *
	 * @generated from field: repeated bundles.v1.Event conversions = 1;
	 */
	conversions: Event[];

	/**
	 * PaginationInfo for navigating between pages of results.
	 *
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * ListConversionsByConsumerResponse contains event data
 * in response to a ListConversionsByConsumerRequest
 *
 * @generated from message abacus.v2.ListConversionsByConsumerResponse
 */
export type ListConversionsByConsumerResponseJson = {
	/**
	 * Events linked to the user specified in the request.
	 *
	 * @generated from field: repeated bundles.v1.Event conversions = 1;
	 */
	conversions?: EventJson[];

	/**
	 * PaginationInfo for navigating between pages of results.
	 *
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message abacus.v2.ListConversionsByConsumerResponse.
 * Use `create(ListConversionsByConsumerResponseSchema)` to create a new message.
 */
export const ListConversionsByConsumerResponseSchema: GenMessage<ListConversionsByConsumerResponse, { jsonType: ListConversionsByConsumerResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 71);

/**
 * GetContactRequest request for retrieving contact information
 * for a particular org id, workspace id, email combination.
 *
 * @generated from message abacus.v2.GetContactRequest
 */
export type GetContactRequest = Message<"abacus.v2.GetContactRequest"> & {
	/**
	 * Org id to which the contact is linked.
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * Workspace id to which the contact is linked.
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * Flag to include shared workspaces
	 *
	 * @generated from field: bool include_shared_workspaces = 9;
	 */
	includeSharedWorkspaces: boolean;

	/**
	 * Email of the contact.
	 *
	 * @generated from field: string email = 3;
	 */
	email: string;

	/**
	 * Primary key of the contact.
	 *
	 * @generated from field: string primary_key = 7;
	 */
	primaryKey: string;

	/**
	 * Primary ID of the contact.
	 *
	 * @generated from field: string primary_id = 6;
	 */
	primaryId: string;

	/**
	 * Optional enrichment field mask to specify field(s) to include in the response object
	 * that are not returned by default.
	 * Currently only supports "properties".
	 *
	 * @generated from field: google.protobuf.FieldMask enrich_mask = 4;
	 */
	enrichMask?: FieldMask | undefined;

	/**
	 * Optional list of contact model property keys. Normalizes the
	 * contact properties returned such that all contacts will contain
	 * entries for each key. If the contact has no information for a requested
	 * key, the submission value will be nil.
	 * Only applied if the Properties field is specified in the read mask.
	 *
	 * @generated from field: repeated string workspace_property_keys = 5;
	 */
	workspacePropertyKeys: string[];

	/**
	 * Optional list of contact model property refs
	 *
	 * @generated from field: repeated abacus.v2.SchemaPropertyRef property_refs = 8;
	 */
	propertyRefs: SchemaPropertyRef[];
};

/**
 * GetContactRequest request for retrieving contact information
 * for a particular org id, workspace id, email combination.
 *
 * @generated from message abacus.v2.GetContactRequest
 */
export type GetContactRequestJson = {
	/**
	 * Org id to which the contact is linked.
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * Workspace id to which the contact is linked.
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * Flag to include shared workspaces
	 *
	 * @generated from field: bool include_shared_workspaces = 9;
	 */
	includeSharedWorkspaces?: boolean;

	/**
	 * Email of the contact.
	 *
	 * @generated from field: string email = 3;
	 */
	email?: string;

	/**
	 * Primary key of the contact.
	 *
	 * @generated from field: string primary_key = 7;
	 */
	primaryKey?: string;

	/**
	 * Primary ID of the contact.
	 *
	 * @generated from field: string primary_id = 6;
	 */
	primaryId?: string;

	/**
	 * Optional enrichment field mask to specify field(s) to include in the response object
	 * that are not returned by default.
	 * Currently only supports "properties".
	 *
	 * @generated from field: google.protobuf.FieldMask enrich_mask = 4;
	 */
	enrichMask?: FieldMaskJson;

	/**
	 * Optional list of contact model property keys. Normalizes the
	 * contact properties returned such that all contacts will contain
	 * entries for each key. If the contact has no information for a requested
	 * key, the submission value will be nil.
	 * Only applied if the Properties field is specified in the read mask.
	 *
	 * @generated from field: repeated string workspace_property_keys = 5;
	 */
	workspacePropertyKeys?: string[];

	/**
	 * Optional list of contact model property refs
	 *
	 * @generated from field: repeated abacus.v2.SchemaPropertyRef property_refs = 8;
	 */
	propertyRefs?: SchemaPropertyRefJson[];
};

/**
 * Describes the message abacus.v2.GetContactRequest.
 * Use `create(GetContactRequestSchema)` to create a new message.
 */
export const GetContactRequestSchema: GenMessage<GetContactRequest, { jsonType: GetContactRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 72);

/**
 * GetContactResponse returns the contact in response
 * to a GetContactRequest.
 *
 * @generated from message abacus.v2.GetContactResponse
 */
export type GetContactResponse = Message<"abacus.v2.GetContactResponse"> & {
	/**
	 * The contact returned from the query.
	 *
	 * @generated from field: abacus.v2.Contact contact = 1;
	 */
	contact?: Contact | undefined;
};

/**
 * GetContactResponse returns the contact in response
 * to a GetContactRequest.
 *
 * @generated from message abacus.v2.GetContactResponse
 */
export type GetContactResponseJson = {
	/**
	 * The contact returned from the query.
	 *
	 * @generated from field: abacus.v2.Contact contact = 1;
	 */
	contact?: ContactJson;
};

/**
 * Describes the message abacus.v2.GetContactResponse.
 * Use `create(GetContactResponseSchema)` to create a new message.
 */
export const GetContactResponseSchema: GenMessage<GetContactResponse, { jsonType: GetContactResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 73);

/**
 * @generated from message abacus.v2.GetConversionRateTotalsRequest
 */
export type GetConversionRateTotalsRequest = Message<"abacus.v2.GetConversionRateTotalsRequest"> & {
	/**
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval: Interval;

	/**
	 * @generated from field: abacus.v2.Period period = 2;
	 */
	period: Period;

	/**
	 * @generated from field: string timezone = 3;
	 */
	timezone: string;

	/**
	 * @generated from field: optional abacus.v2.TimeRange time_range = 4;
	 */
	timeRange?: TimeRange | undefined;

	/**
	 * @generated from field: string org_id = 5;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 6;
	 */
	workspaceId: string;

	/**
	 * @generated from field: bool include_shared_workspaces = 7;
	 */
	includeSharedWorkspaces: boolean;

	/**
	 * @generated from field: repeated abacus.v2.Dimension dimension_group_by = 8;
	 */
	dimensionGroupBy: Dimension[];

	/**
	 * @generated from field: repeated abacus.v2.Metric metrics = 9;
	 */
	metrics: Metric[];

	/**
	 * @generated from field: abacus.v2.ConversionRateFilter filter = 10;
	 */
	filter?: ConversionRateFilter | undefined;
};

/**
 * @generated from message abacus.v2.GetConversionRateTotalsRequest
 */
export type GetConversionRateTotalsRequestJson = {
	/**
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval?: IntervalJson;

	/**
	 * @generated from field: abacus.v2.Period period = 2;
	 */
	period?: PeriodJson;

	/**
	 * @generated from field: string timezone = 3;
	 */
	timezone?: string;

	/**
	 * @generated from field: optional abacus.v2.TimeRange time_range = 4;
	 */
	timeRange?: TimeRangeJson;

	/**
	 * @generated from field: string org_id = 5;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 6;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: bool include_shared_workspaces = 7;
	 */
	includeSharedWorkspaces?: boolean;

	/**
	 * @generated from field: repeated abacus.v2.Dimension dimension_group_by = 8;
	 */
	dimensionGroupBy?: DimensionJson[];

	/**
	 * @generated from field: repeated abacus.v2.Metric metrics = 9;
	 */
	metrics?: MetricJson[];

	/**
	 * @generated from field: abacus.v2.ConversionRateFilter filter = 10;
	 */
	filter?: ConversionRateFilterJson;
};

/**
 * Describes the message abacus.v2.GetConversionRateTotalsRequest.
 * Use `create(GetConversionRateTotalsRequestSchema)` to create a new message.
 */
export const GetConversionRateTotalsRequestSchema: GenMessage<GetConversionRateTotalsRequest, { jsonType: GetConversionRateTotalsRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 74);

/**
 * @generated from message abacus.v2.GetConversionRateTotalsResponse
 */
export type GetConversionRateTotalsResponse = Message<"abacus.v2.GetConversionRateTotalsResponse"> & {
	/**
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval: Interval;

	/**
	 * @generated from field: abacus.v2.Period period = 2;
	 */
	period: Period;

	/**
	 * @generated from field: string timezone = 3;
	 */
	timezone: string;

	/**
	 * @generated from field: optional abacus.v2.TimeRange time_range = 4;
	 */
	timeRange?: TimeRange | undefined;

	/**
	 * @generated from field: repeated abacus.v2.Dimension dimension_group_by = 5;
	 */
	dimensionGroupBy: Dimension[];

	/**
	 * @generated from field: int64 total_scans = 6;
	 */
	totalScans: bigint;

	/**
	 * @generated from field: int64 total_clicks = 7;
	 */
	totalClicks: bigint;

	/**
	 * @generated from field: int64 total_visits = 8;
	 */
	totalVisits: bigint;

	/**
	 * @generated from field: int64 total_views = 9;
	 */
	totalViews: bigint;

	/**
	 * @generated from field: int64 total_conversions = 10;
	 */
	totalConversions: bigint;

	/**
	 * @generated from field: int64 total_unique_visitors = 11;
	 */
	totalUniqueVisitors: bigint;

	/**
	 * @generated from field: int64 total_unique_viewers = 12;
	 */
	totalUniqueViewers: bigint;

	/**
	 * @generated from field: int64 total_unique_conversions = 13;
	 */
	totalUniqueConversions: bigint;

	/**
	 * @generated from field: int64 total_anonymous_responses = 14;
	 */
	totalAnonymousResponses: bigint;

	/**
	 * @generated from field: float total_conversion_rate = 15;
	 */
	totalConversionRate: number;

	/**
	 * @generated from field: float total_total_conversion_rate = 16;
	 */
	totalTotalConversionRate: number;

	/**
	 * @generated from field: float total_unique_conversion_rate = 17;
	 */
	totalUniqueConversionRate: number;

	/**
	 * @generated from field: float total_scans_percent_change = 18;
	 */
	totalScansPercentChange: number;

	/**
	 * @generated from field: float total_clicks_percent_change = 19;
	 */
	totalClicksPercentChange: number;

	/**
	 * @generated from field: float total_visits_percent_change = 20;
	 */
	totalVisitsPercentChange: number;

	/**
	 * @generated from field: float total_views_percent_change = 21;
	 */
	totalViewsPercentChange: number;

	/**
	 * @generated from field: float total_conversions_percent_change = 22;
	 */
	totalConversionsPercentChange: number;

	/**
	 * @generated from field: float total_unique_visitors_percent_change = 23;
	 */
	totalUniqueVisitorsPercentChange: number;

	/**
	 * @generated from field: float total_unique_viewers_percent_change = 24;
	 */
	totalUniqueViewersPercentChange: number;

	/**
	 * @generated from field: float total_unique_conversions_percent_change = 25;
	 */
	totalUniqueConversionsPercentChange: number;

	/**
	 * @generated from field: float total_anonymous_responses_percent_change = 26;
	 */
	totalAnonymousResponsesPercentChange: number;

	/**
	 * @generated from field: float total_conversion_rate_percent_change = 27;
	 */
	totalConversionRatePercentChange: number;

	/**
	 * @generated from field: float total_total_conversion_rate_percent_change = 28;
	 */
	totalTotalConversionRatePercentChange: number;

	/**
	 * @generated from field: float total_unique_conversion_rate_percent_change = 29;
	 */
	totalUniqueConversionRatePercentChange: number;

	/**
	 * @generated from field: map<string, double> total_revenue_by_currency = 30;
	 */
	totalRevenueByCurrency: { [key: string]: number };

	/**
	 * @generated from field: map<string, float> total_revenue_by_currency_percent_change = 31;
	 */
	totalRevenueByCurrencyPercentChange: { [key: string]: number };

	/**
	 * @generated from field: bool has_bot_data = 32;
	 */
	hasBotData: boolean;
};

/**
 * @generated from message abacus.v2.GetConversionRateTotalsResponse
 */
export type GetConversionRateTotalsResponseJson = {
	/**
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval?: IntervalJson;

	/**
	 * @generated from field: abacus.v2.Period period = 2;
	 */
	period?: PeriodJson;

	/**
	 * @generated from field: string timezone = 3;
	 */
	timezone?: string;

	/**
	 * @generated from field: optional abacus.v2.TimeRange time_range = 4;
	 */
	timeRange?: TimeRangeJson;

	/**
	 * @generated from field: repeated abacus.v2.Dimension dimension_group_by = 5;
	 */
	dimensionGroupBy?: DimensionJson[];

	/**
	 * @generated from field: int64 total_scans = 6;
	 */
	totalScans?: string;

	/**
	 * @generated from field: int64 total_clicks = 7;
	 */
	totalClicks?: string;

	/**
	 * @generated from field: int64 total_visits = 8;
	 */
	totalVisits?: string;

	/**
	 * @generated from field: int64 total_views = 9;
	 */
	totalViews?: string;

	/**
	 * @generated from field: int64 total_conversions = 10;
	 */
	totalConversions?: string;

	/**
	 * @generated from field: int64 total_unique_visitors = 11;
	 */
	totalUniqueVisitors?: string;

	/**
	 * @generated from field: int64 total_unique_viewers = 12;
	 */
	totalUniqueViewers?: string;

	/**
	 * @generated from field: int64 total_unique_conversions = 13;
	 */
	totalUniqueConversions?: string;

	/**
	 * @generated from field: int64 total_anonymous_responses = 14;
	 */
	totalAnonymousResponses?: string;

	/**
	 * @generated from field: float total_conversion_rate = 15;
	 */
	totalConversionRate?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float total_total_conversion_rate = 16;
	 */
	totalTotalConversionRate?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float total_unique_conversion_rate = 17;
	 */
	totalUniqueConversionRate?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float total_scans_percent_change = 18;
	 */
	totalScansPercentChange?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float total_clicks_percent_change = 19;
	 */
	totalClicksPercentChange?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float total_visits_percent_change = 20;
	 */
	totalVisitsPercentChange?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float total_views_percent_change = 21;
	 */
	totalViewsPercentChange?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float total_conversions_percent_change = 22;
	 */
	totalConversionsPercentChange?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float total_unique_visitors_percent_change = 23;
	 */
	totalUniqueVisitorsPercentChange?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float total_unique_viewers_percent_change = 24;
	 */
	totalUniqueViewersPercentChange?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float total_unique_conversions_percent_change = 25;
	 */
	totalUniqueConversionsPercentChange?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float total_anonymous_responses_percent_change = 26;
	 */
	totalAnonymousResponsesPercentChange?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float total_conversion_rate_percent_change = 27;
	 */
	totalConversionRatePercentChange?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float total_total_conversion_rate_percent_change = 28;
	 */
	totalTotalConversionRatePercentChange?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: float total_unique_conversion_rate_percent_change = 29;
	 */
	totalUniqueConversionRatePercentChange?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: map<string, double> total_revenue_by_currency = 30;
	 */
	totalRevenueByCurrency?: { [key: string]: number | "NaN" | "Infinity" | "-Infinity" };

	/**
	 * @generated from field: map<string, float> total_revenue_by_currency_percent_change = 31;
	 */
	totalRevenueByCurrencyPercentChange?: { [key: string]: number | "NaN" | "Infinity" | "-Infinity" };

	/**
	 * @generated from field: bool has_bot_data = 32;
	 */
	hasBotData?: boolean;
};

/**
 * Describes the message abacus.v2.GetConversionRateTotalsResponse.
 * Use `create(GetConversionRateTotalsResponseSchema)` to create a new message.
 */
export const GetConversionRateTotalsResponseSchema: GenMessage<GetConversionRateTotalsResponse, { jsonType: GetConversionRateTotalsResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 75);

/**
 * GetContactsSummaryRequest request to return a contacts summary
 * for given time-based parameters.
 *
 * @generated from message abacus.v2.GetContactsSummaryRequest
 */
export type GetContactsSummaryRequest = Message<"abacus.v2.GetContactsSummaryRequest"> & {
	/**
	 * The interval for which the contact summary will be applied.
	 *
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval: Interval;

	/**
	 * The period for which the contact summary will be applied.
	 *
	 * @generated from field: abacus.v2.Period period = 6;
	 */
	period: Period;

	/**
	 * The timezone for which the contact summary will be applied.
	 *
	 * @generated from field: string timezone = 2;
	 */
	timezone: string;

	/**
	 * The timerange for which the contact summary will be applied.
	 *
	 * @generated from field: optional abacus.v2.TimeRange time_range = 7;
	 */
	timeRange?: TimeRange | undefined;

	/**
	 * The id of the org to which the contacts in the summary belong.
	 *
	 * @generated from field: string org_id = 3;
	 */
	orgId: string;

	/**
	 * The id of the workspace to which the contacts in the summary belong.
	 *
	 * @generated from field: string workspace_id = 4;
	 */
	workspaceId: string;

	/**
	 * Flag to include shared workspaces
	 *
	 * @generated from field: bool include_shared_workspaces = 8;
	 */
	includeSharedWorkspaces: boolean;

	/**
	 * The filter for the conversion type for which the contact summary will be applied.
	 *
	 * @generated from field: abacus.v2.ConversionTypeFilter filter = 5;
	 */
	filter?: ConversionTypeFilter | undefined;
};

/**
 * GetContactsSummaryRequest request to return a contacts summary
 * for given time-based parameters.
 *
 * @generated from message abacus.v2.GetContactsSummaryRequest
 */
export type GetContactsSummaryRequestJson = {
	/**
	 * The interval for which the contact summary will be applied.
	 *
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval?: IntervalJson;

	/**
	 * The period for which the contact summary will be applied.
	 *
	 * @generated from field: abacus.v2.Period period = 6;
	 */
	period?: PeriodJson;

	/**
	 * The timezone for which the contact summary will be applied.
	 *
	 * @generated from field: string timezone = 2;
	 */
	timezone?: string;

	/**
	 * The timerange for which the contact summary will be applied.
	 *
	 * @generated from field: optional abacus.v2.TimeRange time_range = 7;
	 */
	timeRange?: TimeRangeJson;

	/**
	 * The id of the org to which the contacts in the summary belong.
	 *
	 * @generated from field: string org_id = 3;
	 */
	orgId?: string;

	/**
	 * The id of the workspace to which the contacts in the summary belong.
	 *
	 * @generated from field: string workspace_id = 4;
	 */
	workspaceId?: string;

	/**
	 * Flag to include shared workspaces
	 *
	 * @generated from field: bool include_shared_workspaces = 8;
	 */
	includeSharedWorkspaces?: boolean;

	/**
	 * The filter for the conversion type for which the contact summary will be applied.
	 *
	 * @generated from field: abacus.v2.ConversionTypeFilter filter = 5;
	 */
	filter?: ConversionTypeFilterJson;
};

/**
 * Describes the message abacus.v2.GetContactsSummaryRequest.
 * Use `create(GetContactsSummaryRequestSchema)` to create a new message.
 */
export const GetContactsSummaryRequestSchema: GenMessage<GetContactsSummaryRequest, { jsonType: GetContactsSummaryRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 76);

/**
 * GetContactsSummaryResponse is returned in response to a
 * GetContactsSummaryRequest and contains the summary for the given request parameters.
 *
 * @generated from message abacus.v2.GetContactsSummaryResponse
 */
export type GetContactsSummaryResponse = Message<"abacus.v2.GetContactsSummaryResponse"> & {
	/**
	 * The contact summary.
	 *
	 * @generated from field: abacus.v2.ContactsSummary summary = 1;
	 */
	summary?: ContactsSummary | undefined;
};

/**
 * GetContactsSummaryResponse is returned in response to a
 * GetContactsSummaryRequest and contains the summary for the given request parameters.
 *
 * @generated from message abacus.v2.GetContactsSummaryResponse
 */
export type GetContactsSummaryResponseJson = {
	/**
	 * The contact summary.
	 *
	 * @generated from field: abacus.v2.ContactsSummary summary = 1;
	 */
	summary?: ContactsSummaryJson;
};

/**
 * Describes the message abacus.v2.GetContactsSummaryResponse.
 * Use `create(GetContactsSummaryResponseSchema)` to create a new message.
 */
export const GetContactsSummaryResponseSchema: GenMessage<GetContactsSummaryResponse, { jsonType: GetContactsSummaryResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 77);

/**
 * GetConversionRateSummaryRequest contains request parameters for
 * retreiving a conversion rate summary for a given org and
 * workspace.
 *
 * @generated from message abacus.v2.GetConversionRateSummaryRequest
 */
export type GetConversionRateSummaryRequest = Message<"abacus.v2.GetConversionRateSummaryRequest"> & {
	/**
	 * The interval for which the conversion rate summary will be applied.
	 *
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval: Interval;

	/**
	 * The period for which the conversion rate summary will be applied.
	 *
	 * @generated from field: abacus.v2.Period period = 6;
	 */
	period: Period;

	/**
	 * The timezone for which the conversion rate summary will be applied.
	 *
	 * @generated from field: string timezone = 2;
	 */
	timezone: string;

	/**
	 * The timerange for which the conversion rate summary will be applied.
	 *
	 * @generated from field: optional abacus.v2.TimeRange time_range = 7;
	 */
	timeRange?: TimeRange | undefined;

	/**
	 * The id of the org in which the conversions took place.
	 *
	 * @generated from field: string org_id = 3;
	 */
	orgId: string;

	/**
	 * The id of the workspace in which the conversions took place.
	 *
	 * @generated from field: string workspace_id = 4;
	 */
	workspaceId: string;

	/**
	 * Flag to include shared workspaces
	 *
	 * @generated from field: bool include_shared_workspaces = 13;
	 */
	includeSharedWorkspaces: boolean;

	/**
	 * The group by parameter for the conversion rates.
	 *
	 * @generated from field: repeated abacus.v2.Dimension dimension_group_by = 8;
	 */
	dimensionGroupBy: Dimension[];

	/**
	 * The maximum number of series to return in the response.
	 *
	 * @generated from field: int32 max_series = 9;
	 */
	maxSeries: number;

	/**
	 * The order by for grouped requests
	 *
	 * @generated from field: string order_by = 11;
	 */
	orderBy: string;

	/**
	 * The order for grouped requests
	 *
	 * @generated from field: common.v1.Order order = 12;
	 */
	order: Order;

	/**
	 * Variants to use when grouping by experiment.
	 *
	 * @generated from field: repeated abacus.v2.ExperimentVariant variants = 10;
	 */
	variants: ExperimentVariant[];

	/**
	 * Metrics for requesting specific metrics
	 *
	 * @generated from field: repeated abacus.v2.Metric metrics = 14;
	 */
	metrics: Metric[];

	/**
	 * Optional flag to omit total counts from response
	 *
	 * @generated from field: optional bool omit_totals = 15;
	 */
	omitTotals?: boolean | undefined;

	/**
	 * Filter paramaters for the conversion rate summary.
	 *
	 * @generated from field: abacus.v2.ConversionRateFilter filter = 5;
	 */
	filter?: ConversionRateFilter | undefined;
};

/**
 * GetConversionRateSummaryRequest contains request parameters for
 * retreiving a conversion rate summary for a given org and
 * workspace.
 *
 * @generated from message abacus.v2.GetConversionRateSummaryRequest
 */
export type GetConversionRateSummaryRequestJson = {
	/**
	 * The interval for which the conversion rate summary will be applied.
	 *
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval?: IntervalJson;

	/**
	 * The period for which the conversion rate summary will be applied.
	 *
	 * @generated from field: abacus.v2.Period period = 6;
	 */
	period?: PeriodJson;

	/**
	 * The timezone for which the conversion rate summary will be applied.
	 *
	 * @generated from field: string timezone = 2;
	 */
	timezone?: string;

	/**
	 * The timerange for which the conversion rate summary will be applied.
	 *
	 * @generated from field: optional abacus.v2.TimeRange time_range = 7;
	 */
	timeRange?: TimeRangeJson;

	/**
	 * The id of the org in which the conversions took place.
	 *
	 * @generated from field: string org_id = 3;
	 */
	orgId?: string;

	/**
	 * The id of the workspace in which the conversions took place.
	 *
	 * @generated from field: string workspace_id = 4;
	 */
	workspaceId?: string;

	/**
	 * Flag to include shared workspaces
	 *
	 * @generated from field: bool include_shared_workspaces = 13;
	 */
	includeSharedWorkspaces?: boolean;

	/**
	 * The group by parameter for the conversion rates.
	 *
	 * @generated from field: repeated abacus.v2.Dimension dimension_group_by = 8;
	 */
	dimensionGroupBy?: DimensionJson[];

	/**
	 * The maximum number of series to return in the response.
	 *
	 * @generated from field: int32 max_series = 9;
	 */
	maxSeries?: number;

	/**
	 * The order by for grouped requests
	 *
	 * @generated from field: string order_by = 11;
	 */
	orderBy?: string;

	/**
	 * The order for grouped requests
	 *
	 * @generated from field: common.v1.Order order = 12;
	 */
	order?: OrderJson;

	/**
	 * Variants to use when grouping by experiment.
	 *
	 * @generated from field: repeated abacus.v2.ExperimentVariant variants = 10;
	 */
	variants?: ExperimentVariantJson[];

	/**
	 * Metrics for requesting specific metrics
	 *
	 * @generated from field: repeated abacus.v2.Metric metrics = 14;
	 */
	metrics?: MetricJson[];

	/**
	 * Optional flag to omit total counts from response
	 *
	 * @generated from field: optional bool omit_totals = 15;
	 */
	omitTotals?: boolean;

	/**
	 * Filter paramaters for the conversion rate summary.
	 *
	 * @generated from field: abacus.v2.ConversionRateFilter filter = 5;
	 */
	filter?: ConversionRateFilterJson;
};

/**
 * Describes the message abacus.v2.GetConversionRateSummaryRequest.
 * Use `create(GetConversionRateSummaryRequestSchema)` to create a new message.
 */
export const GetConversionRateSummaryRequestSchema: GenMessage<GetConversionRateSummaryRequest, { jsonType: GetConversionRateSummaryRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 78);

/**
 * GetConversionRateSummaryResponse is returned in response to a
 * GetConversionRateSummaryRequest and contains the summary for the given request parameters.
 *
 * @generated from message abacus.v2.GetConversionRateSummaryResponse
 */
export type GetConversionRateSummaryResponse = Message<"abacus.v2.GetConversionRateSummaryResponse"> & {
	/**
	 * The conversion rate summary.
	 *
	 * @generated from field: abacus.v2.ConversionRateSummary summary = 1;
	 */
	summary?: ConversionRateSummary | undefined;
};

/**
 * GetConversionRateSummaryResponse is returned in response to a
 * GetConversionRateSummaryRequest and contains the summary for the given request parameters.
 *
 * @generated from message abacus.v2.GetConversionRateSummaryResponse
 */
export type GetConversionRateSummaryResponseJson = {
	/**
	 * The conversion rate summary.
	 *
	 * @generated from field: abacus.v2.ConversionRateSummary summary = 1;
	 */
	summary?: ConversionRateSummaryJson;
};

/**
 * Describes the message abacus.v2.GetConversionRateSummaryResponse.
 * Use `create(GetConversionRateSummaryResponseSchema)` to create a new message.
 */
export const GetConversionRateSummaryResponseSchema: GenMessage<GetConversionRateSummaryResponse, { jsonType: GetConversionRateSummaryResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 79);

/**
 * GetConversionTypeSummaryRequest contains request parameters for
 * retrieving a conversion type summary.
 *
 * @generated from message abacus.v2.GetConversionTypeSummaryRequest
 */
export type GetConversionTypeSummaryRequest = Message<"abacus.v2.GetConversionTypeSummaryRequest"> & {
	/**
	 * The interval for which the conversion type summary will be applied.
	 *
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval: Interval;

	/**
	 * The period for which the conversion type summary will be applied.
	 *
	 * @generated from field: abacus.v2.Period period = 7;
	 */
	period: Period;

	/**
	 * The timezone for which the conversion type summary will be applied.
	 *
	 * @generated from field: string timezone = 2;
	 */
	timezone: string;

	/**
	 * The timerange for which the conversion type summary will be applied.
	 *
	 * @generated from field: optional abacus.v2.TimeRange time_range = 8;
	 */
	timeRange?: TimeRange | undefined;

	/**
	 * The id of the org in which the conversions took place.
	 *
	 * @generated from field: string org_id = 3;
	 */
	orgId: string;

	/**
	 * The id of the workspace in which the conversions took place.
	 *
	 * @generated from field: string workspace_id = 4;
	 */
	workspaceId: string;

	/**
	 * Flag to include shared workspaces
	 *
	 * @generated from field: bool include_shared_workspaces = 9;
	 */
	includeSharedWorkspaces: boolean;

	/**
	 * The conversion type on which we are analyzing.
	 *
	 * @generated from field: bundles.v1.ConversionType conversion_type = 5;
	 */
	conversionType: ConversionType;

	/**
	 * Additional filters if more specificity is necessary.
	 *
	 * @generated from field: abacus.v2.ConversionTypeFilter filter = 6;
	 */
	filter?: ConversionTypeFilter | undefined;
};

/**
 * GetConversionTypeSummaryRequest contains request parameters for
 * retrieving a conversion type summary.
 *
 * @generated from message abacus.v2.GetConversionTypeSummaryRequest
 */
export type GetConversionTypeSummaryRequestJson = {
	/**
	 * The interval for which the conversion type summary will be applied.
	 *
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval?: IntervalJson;

	/**
	 * The period for which the conversion type summary will be applied.
	 *
	 * @generated from field: abacus.v2.Period period = 7;
	 */
	period?: PeriodJson;

	/**
	 * The timezone for which the conversion type summary will be applied.
	 *
	 * @generated from field: string timezone = 2;
	 */
	timezone?: string;

	/**
	 * The timerange for which the conversion type summary will be applied.
	 *
	 * @generated from field: optional abacus.v2.TimeRange time_range = 8;
	 */
	timeRange?: TimeRangeJson;

	/**
	 * The id of the org in which the conversions took place.
	 *
	 * @generated from field: string org_id = 3;
	 */
	orgId?: string;

	/**
	 * The id of the workspace in which the conversions took place.
	 *
	 * @generated from field: string workspace_id = 4;
	 */
	workspaceId?: string;

	/**
	 * Flag to include shared workspaces
	 *
	 * @generated from field: bool include_shared_workspaces = 9;
	 */
	includeSharedWorkspaces?: boolean;

	/**
	 * The conversion type on which we are analyzing.
	 *
	 * @generated from field: bundles.v1.ConversionType conversion_type = 5;
	 */
	conversionType?: ConversionTypeJson;

	/**
	 * Additional filters if more specificity is necessary.
	 *
	 * @generated from field: abacus.v2.ConversionTypeFilter filter = 6;
	 */
	filter?: ConversionTypeFilterJson;
};

/**
 * Describes the message abacus.v2.GetConversionTypeSummaryRequest.
 * Use `create(GetConversionTypeSummaryRequestSchema)` to create a new message.
 */
export const GetConversionTypeSummaryRequestSchema: GenMessage<GetConversionTypeSummaryRequest, { jsonType: GetConversionTypeSummaryRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 80);

/**
 * GetConversionTypeSummaryResponse is returned in response to a
 * GetConversionTypeSummaryRequest and contains the summary for the given request parameters.
 *
 * @generated from message abacus.v2.GetConversionTypeSummaryResponse
 */
export type GetConversionTypeSummaryResponse = Message<"abacus.v2.GetConversionTypeSummaryResponse"> & {
	/**
	 * The conversion type summary.
	 *
	 * @generated from field: abacus.v2.ConversionTypeSummary summary = 1;
	 */
	summary?: ConversionTypeSummary | undefined;
};

/**
 * GetConversionTypeSummaryResponse is returned in response to a
 * GetConversionTypeSummaryRequest and contains the summary for the given request parameters.
 *
 * @generated from message abacus.v2.GetConversionTypeSummaryResponse
 */
export type GetConversionTypeSummaryResponseJson = {
	/**
	 * The conversion type summary.
	 *
	 * @generated from field: abacus.v2.ConversionTypeSummary summary = 1;
	 */
	summary?: ConversionTypeSummaryJson;
};

/**
 * Describes the message abacus.v2.GetConversionTypeSummaryResponse.
 * Use `create(GetConversionTypeSummaryResponseSchema)` to create a new message.
 */
export const GetConversionTypeSummaryResponseSchema: GenMessage<GetConversionTypeSummaryResponse, { jsonType: GetConversionTypeSummaryResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 81);

/**
 * GetRevenueSummaryRequest contains request parameters for retreiving
 * a revenue summary.
 *
 * @generated from message abacus.v2.GetRevenueSummaryRequest
 */
export type GetRevenueSummaryRequest = Message<"abacus.v2.GetRevenueSummaryRequest"> & {
	/**
	 * The interval for which the revenue summary will be applied.
	 *
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval: Interval;

	/**
	 * The period for which the revenue summary will be applied.
	 *
	 * @generated from field: abacus.v2.Period period = 6;
	 */
	period: Period;

	/**
	 * The timezone for which the revenue summary will be applied.
	 *
	 * @generated from field: string timezone = 2;
	 */
	timezone: string;

	/**
	 * The timerange for which the revenue summary will be applied.
	 *
	 * @generated from field: optional abacus.v2.TimeRange time_range = 7;
	 */
	timeRange?: TimeRange | undefined;

	/**
	 * The id of the org in which the revenue summary results were recorded.
	 *
	 * @generated from field: string org_id = 3;
	 */
	orgId: string;

	/**
	 * The id of the workspace in which the revenue summary results were recorded.
	 *
	 * @generated from field: string workspace_id = 4;
	 */
	workspaceId: string;

	/**
	 * Flag to include shared workspaces
	 *
	 * @generated from field: bool include_shared_workspaces = 8;
	 */
	includeSharedWorkspaces: boolean;

	/**
	 * Additional filters if more specificity is necessary.
	 *
	 * @generated from field: abacus.v2.ConversionTypeFilter filter = 5;
	 */
	filter?: ConversionTypeFilter | undefined;
};

/**
 * GetRevenueSummaryRequest contains request parameters for retreiving
 * a revenue summary.
 *
 * @generated from message abacus.v2.GetRevenueSummaryRequest
 */
export type GetRevenueSummaryRequestJson = {
	/**
	 * The interval for which the revenue summary will be applied.
	 *
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval?: IntervalJson;

	/**
	 * The period for which the revenue summary will be applied.
	 *
	 * @generated from field: abacus.v2.Period period = 6;
	 */
	period?: PeriodJson;

	/**
	 * The timezone for which the revenue summary will be applied.
	 *
	 * @generated from field: string timezone = 2;
	 */
	timezone?: string;

	/**
	 * The timerange for which the revenue summary will be applied.
	 *
	 * @generated from field: optional abacus.v2.TimeRange time_range = 7;
	 */
	timeRange?: TimeRangeJson;

	/**
	 * The id of the org in which the revenue summary results were recorded.
	 *
	 * @generated from field: string org_id = 3;
	 */
	orgId?: string;

	/**
	 * The id of the workspace in which the revenue summary results were recorded.
	 *
	 * @generated from field: string workspace_id = 4;
	 */
	workspaceId?: string;

	/**
	 * Flag to include shared workspaces
	 *
	 * @generated from field: bool include_shared_workspaces = 8;
	 */
	includeSharedWorkspaces?: boolean;

	/**
	 * Additional filters if more specificity is necessary.
	 *
	 * @generated from field: abacus.v2.ConversionTypeFilter filter = 5;
	 */
	filter?: ConversionTypeFilterJson;
};

/**
 * Describes the message abacus.v2.GetRevenueSummaryRequest.
 * Use `create(GetRevenueSummaryRequestSchema)` to create a new message.
 */
export const GetRevenueSummaryRequestSchema: GenMessage<GetRevenueSummaryRequest, { jsonType: GetRevenueSummaryRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 82);

/**
 * GetRevenueSummaryResponse is returned in response to a
 * GetRevenueSummaryRequest and contains the summary for the given request parameters.
 *
 * @generated from message abacus.v2.GetRevenueSummaryResponse
 */
export type GetRevenueSummaryResponse = Message<"abacus.v2.GetRevenueSummaryResponse"> & {
	/**
	 * The revenue summary.
	 *
	 * @generated from field: abacus.v2.RevenueSummary summary = 1;
	 */
	summary?: RevenueSummary | undefined;
};

/**
 * GetRevenueSummaryResponse is returned in response to a
 * GetRevenueSummaryRequest and contains the summary for the given request parameters.
 *
 * @generated from message abacus.v2.GetRevenueSummaryResponse
 */
export type GetRevenueSummaryResponseJson = {
	/**
	 * The revenue summary.
	 *
	 * @generated from field: abacus.v2.RevenueSummary summary = 1;
	 */
	summary?: RevenueSummaryJson;
};

/**
 * Describes the message abacus.v2.GetRevenueSummaryResponse.
 * Use `create(GetRevenueSummaryResponseSchema)` to create a new message.
 */
export const GetRevenueSummaryResponseSchema: GenMessage<GetRevenueSummaryResponse, { jsonType: GetRevenueSummaryResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 83);

/**
 * GetGeoSummaryRequest contains request parameters for retrieving
 * a geo summary report.
 *
 * @generated from message abacus.v2.GetGeoSummaryRequest
 */
export type GetGeoSummaryRequest = Message<"abacus.v2.GetGeoSummaryRequest"> & {
	/**
	 * The interval for which the geo summary will be applied.
	 *
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval: Interval;

	/**
	 * The timerange for which the geo summary will be applied.
	 *
	 * @generated from field: optional abacus.v2.TimeRange time_range = 8;
	 */
	timeRange?: TimeRange | undefined;

	/**
	 * The admin-level for which the geo summary results are being fetched.
	 *
	 * @generated from field: abacus.v2.GeoAdminLevel geo_admin_level = 2;
	 */
	geoAdminLevel: GeoAdminLevel;

	/**
	 * The viewport of the geo summary.
	 *
	 * @generated from field: abacus.v2.Viewport viewport = 3;
	 */
	viewport?: Viewport | undefined;

	/**
	 * The timezone for which we are making the request.
	 *
	 * @generated from field: string timezone = 4;
	 */
	timezone: string;

	/**
	 * The id of the org in which the geo summary results were recorded.
	 *
	 * @generated from field: string org_id = 5;
	 */
	orgId: string;

	/**
	 * The id of the workspace in which the geo summary results were recorded.
	 *
	 * @generated from field: string workspace_id = 6;
	 */
	workspaceId: string;

	/**
	 * Flag to include shared workspaces
	 *
	 * @generated from field: bool include_shared_workspaces = 9;
	 */
	includeSharedWorkspaces: boolean;

	/**
	 * Additional filters if more specificity is necessary.
	 *
	 * @generated from field: abacus.v2.ConversionTypeFilter filter = 7;
	 */
	filter?: ConversionTypeFilter | undefined;
};

/**
 * GetGeoSummaryRequest contains request parameters for retrieving
 * a geo summary report.
 *
 * @generated from message abacus.v2.GetGeoSummaryRequest
 */
export type GetGeoSummaryRequestJson = {
	/**
	 * The interval for which the geo summary will be applied.
	 *
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval?: IntervalJson;

	/**
	 * The timerange for which the geo summary will be applied.
	 *
	 * @generated from field: optional abacus.v2.TimeRange time_range = 8;
	 */
	timeRange?: TimeRangeJson;

	/**
	 * The admin-level for which the geo summary results are being fetched.
	 *
	 * @generated from field: abacus.v2.GeoAdminLevel geo_admin_level = 2;
	 */
	geoAdminLevel?: GeoAdminLevelJson;

	/**
	 * The viewport of the geo summary.
	 *
	 * @generated from field: abacus.v2.Viewport viewport = 3;
	 */
	viewport?: ViewportJson;

	/**
	 * The timezone for which we are making the request.
	 *
	 * @generated from field: string timezone = 4;
	 */
	timezone?: string;

	/**
	 * The id of the org in which the geo summary results were recorded.
	 *
	 * @generated from field: string org_id = 5;
	 */
	orgId?: string;

	/**
	 * The id of the workspace in which the geo summary results were recorded.
	 *
	 * @generated from field: string workspace_id = 6;
	 */
	workspaceId?: string;

	/**
	 * Flag to include shared workspaces
	 *
	 * @generated from field: bool include_shared_workspaces = 9;
	 */
	includeSharedWorkspaces?: boolean;

	/**
	 * Additional filters if more specificity is necessary.
	 *
	 * @generated from field: abacus.v2.ConversionTypeFilter filter = 7;
	 */
	filter?: ConversionTypeFilterJson;
};

/**
 * Describes the message abacus.v2.GetGeoSummaryRequest.
 * Use `create(GetGeoSummaryRequestSchema)` to create a new message.
 */
export const GetGeoSummaryRequestSchema: GenMessage<GetGeoSummaryRequest, { jsonType: GetGeoSummaryRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 84);

/**
 * GetGeoSummaryResponse is returned in response to a
 * GetGeoSummaryRequest and contains the JSON summary for
 * the given request parameters.
 *
 * @generated from message abacus.v2.GetGeoSummaryResponse
 */
export type GetGeoSummaryResponse = Message<"abacus.v2.GetGeoSummaryResponse"> & {
	/**
	 * The geo summary in JSON
	 *
	 * @generated from field: bytes geojson = 1;
	 */
	geojson: Uint8Array;
};

/**
 * GetGeoSummaryResponse is returned in response to a
 * GetGeoSummaryRequest and contains the JSON summary for
 * the given request parameters.
 *
 * @generated from message abacus.v2.GetGeoSummaryResponse
 */
export type GetGeoSummaryResponseJson = {
	/**
	 * The geo summary in JSON
	 *
	 * @generated from field: bytes geojson = 1;
	 */
	geojson?: string;
};

/**
 * Describes the message abacus.v2.GetGeoSummaryResponse.
 * Use `create(GetGeoSummaryResponseSchema)` to create a new message.
 */
export const GetGeoSummaryResponseSchema: GenMessage<GetGeoSummaryResponse, { jsonType: GetGeoSummaryResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 85);

/**
 * GetAudienceSummaryRequest contains request parameters for
 * retrieving an audience summary.
 *
 * @generated from message abacus.v2.GetAudienceSummaryRequest
 */
export type GetAudienceSummaryRequest = Message<"abacus.v2.GetAudienceSummaryRequest"> & {
	/**
	 * The interval for which the audience summary will be applied.
	 *
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval: Interval;

	/**
	 * The timezone for which we are making the request.
	 *
	 * @generated from field: string timezone = 2;
	 */
	timezone: string;

	/**
	 * The timerange for which the audience summary will be applied.
	 *
	 * @generated from field: optional abacus.v2.TimeRange time_range = 6;
	 */
	timeRange?: TimeRange | undefined;

	/**
	 * The id of the org in which the audience summary results were recorded.
	 *
	 * @generated from field: string org_id = 3;
	 */
	orgId: string;

	/**
	 * The id of the workspace in which the audience summary results were recorded.
	 *
	 * @generated from field: string workspace_id = 4;
	 */
	workspaceId: string;

	/**
	 * Flag to include shared workspaces
	 *
	 * @generated from field: bool include_shared_workspaces = 7;
	 */
	includeSharedWorkspaces: boolean;

	/**
	 * The contacts filter for the audience summary.
	 *
	 * @generated from field: abacus.v2.ContactsFilter contacts_filter = 5;
	 */
	contactsFilter?: ContactsFilter | undefined;
};

/**
 * GetAudienceSummaryRequest contains request parameters for
 * retrieving an audience summary.
 *
 * @generated from message abacus.v2.GetAudienceSummaryRequest
 */
export type GetAudienceSummaryRequestJson = {
	/**
	 * The interval for which the audience summary will be applied.
	 *
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval?: IntervalJson;

	/**
	 * The timezone for which we are making the request.
	 *
	 * @generated from field: string timezone = 2;
	 */
	timezone?: string;

	/**
	 * The timerange for which the audience summary will be applied.
	 *
	 * @generated from field: optional abacus.v2.TimeRange time_range = 6;
	 */
	timeRange?: TimeRangeJson;

	/**
	 * The id of the org in which the audience summary results were recorded.
	 *
	 * @generated from field: string org_id = 3;
	 */
	orgId?: string;

	/**
	 * The id of the workspace in which the audience summary results were recorded.
	 *
	 * @generated from field: string workspace_id = 4;
	 */
	workspaceId?: string;

	/**
	 * Flag to include shared workspaces
	 *
	 * @generated from field: bool include_shared_workspaces = 7;
	 */
	includeSharedWorkspaces?: boolean;

	/**
	 * The contacts filter for the audience summary.
	 *
	 * @generated from field: abacus.v2.ContactsFilter contacts_filter = 5;
	 */
	contactsFilter?: ContactsFilterJson;
};

/**
 * Describes the message abacus.v2.GetAudienceSummaryRequest.
 * Use `create(GetAudienceSummaryRequestSchema)` to create a new message.
 */
export const GetAudienceSummaryRequestSchema: GenMessage<GetAudienceSummaryRequest, { jsonType: GetAudienceSummaryRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 86);

/**
 * GetAudienceSummaryResponse is returned in response to a
 * GetAudienceSummaryRequest and contains the summary for
 * the given request parameters.
 *
 * @generated from message abacus.v2.GetAudienceSummaryResponse
 */
export type GetAudienceSummaryResponse = Message<"abacus.v2.GetAudienceSummaryResponse"> & {
	/**
	 * The audience summary.
	 *
	 * @generated from field: abacus.v2.AudienceSummary summary = 1;
	 */
	summary?: AudienceSummary | undefined;
};

/**
 * GetAudienceSummaryResponse is returned in response to a
 * GetAudienceSummaryRequest and contains the summary for
 * the given request parameters.
 *
 * @generated from message abacus.v2.GetAudienceSummaryResponse
 */
export type GetAudienceSummaryResponseJson = {
	/**
	 * The audience summary.
	 *
	 * @generated from field: abacus.v2.AudienceSummary summary = 1;
	 */
	summary?: AudienceSummaryJson;
};

/**
 * Describes the message abacus.v2.GetAudienceSummaryResponse.
 * Use `create(GetAudienceSummaryResponseSchema)` to create a new message.
 */
export const GetAudienceSummaryResponseSchema: GenMessage<GetAudienceSummaryResponse, { jsonType: GetAudienceSummaryResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 87);

/**
 * @generated from message abacus.v2.GetExperimentSummaryRequest
 */
export type GetExperimentSummaryRequest = Message<"abacus.v2.GetExperimentSummaryRequest"> & {
	/**
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval: Interval;

	/**
	 * @generated from field: abacus.v2.Period period = 2;
	 */
	period: Period;

	/**
	 * @generated from field: string timezone = 3;
	 */
	timezone: string;

	/**
	 * @generated from field: optional abacus.v2.TimeRange time_range = 4;
	 */
	timeRange?: TimeRange | undefined;

	/**
	 * @generated from field: string org_id = 5;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 6;
	 */
	workspaceId: string;

	/**
	 * @generated from field: bool include_shared_workspaces = 9;
	 */
	includeSharedWorkspaces: boolean;

	/**
	 * @generated from field: repeated abacus.v2.ExperimentVariant variants = 7;
	 */
	variants: ExperimentVariant[];

	/**
	 * @generated from field: abacus.v2.ConversionTypeFilter filter = 8;
	 */
	filter?: ConversionTypeFilter | undefined;
};

/**
 * @generated from message abacus.v2.GetExperimentSummaryRequest
 */
export type GetExperimentSummaryRequestJson = {
	/**
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval?: IntervalJson;

	/**
	 * @generated from field: abacus.v2.Period period = 2;
	 */
	period?: PeriodJson;

	/**
	 * @generated from field: string timezone = 3;
	 */
	timezone?: string;

	/**
	 * @generated from field: optional abacus.v2.TimeRange time_range = 4;
	 */
	timeRange?: TimeRangeJson;

	/**
	 * @generated from field: string org_id = 5;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 6;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: bool include_shared_workspaces = 9;
	 */
	includeSharedWorkspaces?: boolean;

	/**
	 * @generated from field: repeated abacus.v2.ExperimentVariant variants = 7;
	 */
	variants?: ExperimentVariantJson[];

	/**
	 * @generated from field: abacus.v2.ConversionTypeFilter filter = 8;
	 */
	filter?: ConversionTypeFilterJson;
};

/**
 * Describes the message abacus.v2.GetExperimentSummaryRequest.
 * Use `create(GetExperimentSummaryRequestSchema)` to create a new message.
 */
export const GetExperimentSummaryRequestSchema: GenMessage<GetExperimentSummaryRequest, { jsonType: GetExperimentSummaryRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 88);

/**
 * @generated from message abacus.v2.GetExperimentSummaryResponse
 */
export type GetExperimentSummaryResponse = Message<"abacus.v2.GetExperimentSummaryResponse"> & {
	/**
	 * @generated from field: abacus.v2.ExperimentSummary experiment_summary = 1;
	 */
	experimentSummary?: ExperimentSummary | undefined;
};

/**
 * @generated from message abacus.v2.GetExperimentSummaryResponse
 */
export type GetExperimentSummaryResponseJson = {
	/**
	 * @generated from field: abacus.v2.ExperimentSummary experiment_summary = 1;
	 */
	experimentSummary?: ExperimentSummaryJson;
};

/**
 * Describes the message abacus.v2.GetExperimentSummaryResponse.
 * Use `create(GetExperimentSummaryResponseSchema)` to create a new message.
 */
export const GetExperimentSummaryResponseSchema: GenMessage<GetExperimentSummaryResponse, { jsonType: GetExperimentSummaryResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 89);

/**
 * @generated from message abacus.v2.ListFormFieldsRequest
 */
export type ListFormFieldsRequest = Message<"abacus.v2.ListFormFieldsRequest"> & {
	/**
	 * @generated from field: string suite_id = 1;
	 */
	suiteId: string;

	/**
	 * @generated from field: string form_id = 2;
	 */
	formId: string;
};

/**
 * @generated from message abacus.v2.ListFormFieldsRequest
 */
export type ListFormFieldsRequestJson = {
	/**
	 * @generated from field: string suite_id = 1;
	 */
	suiteId?: string;

	/**
	 * @generated from field: string form_id = 2;
	 */
	formId?: string;
};

/**
 * Describes the message abacus.v2.ListFormFieldsRequest.
 * Use `create(ListFormFieldsRequestSchema)` to create a new message.
 */
export const ListFormFieldsRequestSchema: GenMessage<ListFormFieldsRequest, { jsonType: ListFormFieldsRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 90);

/**
 * @generated from message abacus.v2.ListFormFieldsResponse
 */
export type ListFormFieldsResponse = Message<"abacus.v2.ListFormFieldsResponse"> & {
	/**
	 * @generated from field: repeated abacus.v2.FormField fields = 1;
	 */
	fields: FormField[];
};

/**
 * @generated from message abacus.v2.ListFormFieldsResponse
 */
export type ListFormFieldsResponseJson = {
	/**
	 * @generated from field: repeated abacus.v2.FormField fields = 1;
	 */
	fields?: FormFieldJson[];
};

/**
 * Describes the message abacus.v2.ListFormFieldsResponse.
 * Use `create(ListFormFieldsResponseSchema)` to create a new message.
 */
export const ListFormFieldsResponseSchema: GenMessage<ListFormFieldsResponse, { jsonType: ListFormFieldsResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 91);

/**
 * @generated from message abacus.v2.Form
 */
export type Form = Message<"abacus.v2.Form"> & {
	/**
	 * @generated from field: string form_id = 1;
	 */
	formId: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name: string;

	/**
	 * @generated from field: int64 submission_count = 3;
	 */
	submissionCount: bigint;

	/**
	 * @generated from field: google.protobuf.Timestamp last_submitted_at = 4;
	 */
	lastSubmittedAt?: Timestamp | undefined;

	/**
	 * @generated from field: repeated abacus.v2.FormField fields = 5;
	 */
	fields: FormField[];
};

/**
 * @generated from message abacus.v2.Form
 */
export type FormJson = {
	/**
	 * @generated from field: string form_id = 1;
	 */
	formId?: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name?: string;

	/**
	 * @generated from field: int64 submission_count = 3;
	 */
	submissionCount?: string;

	/**
	 * @generated from field: google.protobuf.Timestamp last_submitted_at = 4;
	 */
	lastSubmittedAt?: TimestampJson;

	/**
	 * @generated from field: repeated abacus.v2.FormField fields = 5;
	 */
	fields?: FormFieldJson[];
};

/**
 * Describes the message abacus.v2.Form.
 * Use `create(FormSchema)` to create a new message.
 */
export const FormSchema: GenMessage<Form, { jsonType: FormJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 92);

/**
 * @generated from message abacus.v2.ListFormsRequest
 */
export type ListFormsRequest = Message<"abacus.v2.ListFormsRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: bool include_shared_workspaces = 8;
	 */
	includeSharedWorkspaces: boolean;

	/**
	 * @generated from field: string suite_id = 3;
	 */
	suiteId: string;

	/**
	 * @generated from field: abacus.v2.Interval interval = 4;
	 */
	interval: Interval;

	/**
	 * @generated from field: string timezone = 5;
	 */
	timezone: string;

	/**
	 * @generated from field: optional abacus.v2.TimeRange time_range = 6;
	 */
	timeRange?: TimeRange | undefined;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 7;
	 */
	pagination?: PaginationArguments | undefined;
};

/**
 * @generated from message abacus.v2.ListFormsRequest
 */
export type ListFormsRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: bool include_shared_workspaces = 8;
	 */
	includeSharedWorkspaces?: boolean;

	/**
	 * @generated from field: string suite_id = 3;
	 */
	suiteId?: string;

	/**
	 * @generated from field: abacus.v2.Interval interval = 4;
	 */
	interval?: IntervalJson;

	/**
	 * @generated from field: string timezone = 5;
	 */
	timezone?: string;

	/**
	 * @generated from field: optional abacus.v2.TimeRange time_range = 6;
	 */
	timeRange?: TimeRangeJson;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 7;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message abacus.v2.ListFormsRequest.
 * Use `create(ListFormsRequestSchema)` to create a new message.
 */
export const ListFormsRequestSchema: GenMessage<ListFormsRequest, { jsonType: ListFormsRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 93);

/**
 * @generated from message abacus.v2.ListFormsResponse
 */
export type ListFormsResponse = Message<"abacus.v2.ListFormsResponse"> & {
	/**
	 * @generated from field: repeated abacus.v2.Form forms = 1;
	 */
	forms: Form[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message abacus.v2.ListFormsResponse
 */
export type ListFormsResponseJson = {
	/**
	 * @generated from field: repeated abacus.v2.Form forms = 1;
	 */
	forms?: FormJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message abacus.v2.ListFormsResponse.
 * Use `create(ListFormsResponseSchema)` to create a new message.
 */
export const ListFormsResponseSchema: GenMessage<ListFormsResponse, { jsonType: ListFormsResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 94);

/**
 * @generated from message abacus.v2.Product
 */
export type Product = Message<"abacus.v2.Product"> & {
	/**
	 * @generated from field: string product_id = 1;
	 */
	productId: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name: string;

	/**
	 * @generated from field: int64 purchase_count = 3;
	 */
	purchaseCount: bigint;

	/**
	 * @generated from field: google.protobuf.Timestamp last_purchased_at = 4;
	 */
	lastPurchasedAt?: Timestamp | undefined;

	/**
	 * @generated from field: repeated abacus.v2.FormField fields = 5;
	 */
	fields: FormField[];
};

/**
 * @generated from message abacus.v2.Product
 */
export type ProductJson = {
	/**
	 * @generated from field: string product_id = 1;
	 */
	productId?: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name?: string;

	/**
	 * @generated from field: int64 purchase_count = 3;
	 */
	purchaseCount?: string;

	/**
	 * @generated from field: google.protobuf.Timestamp last_purchased_at = 4;
	 */
	lastPurchasedAt?: TimestampJson;

	/**
	 * @generated from field: repeated abacus.v2.FormField fields = 5;
	 */
	fields?: FormFieldJson[];
};

/**
 * Describes the message abacus.v2.Product.
 * Use `create(ProductSchema)` to create a new message.
 */
export const ProductSchema: GenMessage<Product, { jsonType: ProductJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 95);

/**
 * @generated from message abacus.v2.ListProductsRequest
 */
export type ListProductsRequest = Message<"abacus.v2.ListProductsRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: bool include_shared_workspaces = 8;
	 */
	includeSharedWorkspaces: boolean;

	/**
	 * @generated from field: string suite_id = 3;
	 */
	suiteId: string;

	/**
	 * @generated from field: abacus.v2.Interval interval = 4;
	 */
	interval: Interval;

	/**
	 * @generated from field: string timezone = 5;
	 */
	timezone: string;

	/**
	 * @generated from field: optional abacus.v2.TimeRange time_range = 6;
	 */
	timeRange?: TimeRange | undefined;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 7;
	 */
	pagination?: PaginationArguments | undefined;
};

/**
 * @generated from message abacus.v2.ListProductsRequest
 */
export type ListProductsRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: bool include_shared_workspaces = 8;
	 */
	includeSharedWorkspaces?: boolean;

	/**
	 * @generated from field: string suite_id = 3;
	 */
	suiteId?: string;

	/**
	 * @generated from field: abacus.v2.Interval interval = 4;
	 */
	interval?: IntervalJson;

	/**
	 * @generated from field: string timezone = 5;
	 */
	timezone?: string;

	/**
	 * @generated from field: optional abacus.v2.TimeRange time_range = 6;
	 */
	timeRange?: TimeRangeJson;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 7;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message abacus.v2.ListProductsRequest.
 * Use `create(ListProductsRequestSchema)` to create a new message.
 */
export const ListProductsRequestSchema: GenMessage<ListProductsRequest, { jsonType: ListProductsRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 96);

/**
 * @generated from message abacus.v2.ListProductsResponse
 */
export type ListProductsResponse = Message<"abacus.v2.ListProductsResponse"> & {
	/**
	 * @generated from field: repeated abacus.v2.Product products = 1;
	 */
	products: Product[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message abacus.v2.ListProductsResponse
 */
export type ListProductsResponseJson = {
	/**
	 * @generated from field: repeated abacus.v2.Product products = 1;
	 */
	products?: ProductJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message abacus.v2.ListProductsResponse.
 * Use `create(ListProductsResponseSchema)` to create a new message.
 */
export const ListProductsResponseSchema: GenMessage<ListProductsResponse, { jsonType: ListProductsResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 97);

/**
 * @generated from message abacus.v2.ListMetadataKeysRequest
 */
export type ListMetadataKeysRequest = Message<"abacus.v2.ListMetadataKeysRequest"> & {
	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId: string;

	/**
	 * @generated from field: bool include_shared_workspaces = 6;
	 */
	includeSharedWorkspaces: boolean;

	/**
	 * @generated from field: string suite_id = 1;
	 */
	suiteId: string;

	/**
	 * @generated from field: string key = 4;
	 */
	key: string;

	/**
	 * @generated from field: optional common.v1.PaginationArguments pagination = 5;
	 */
	pagination?: PaginationArguments | undefined;
};

/**
 * @generated from message abacus.v2.ListMetadataKeysRequest
 */
export type ListMetadataKeysRequestJson = {
	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: bool include_shared_workspaces = 6;
	 */
	includeSharedWorkspaces?: boolean;

	/**
	 * @generated from field: string suite_id = 1;
	 */
	suiteId?: string;

	/**
	 * @generated from field: string key = 4;
	 */
	key?: string;

	/**
	 * @generated from field: optional common.v1.PaginationArguments pagination = 5;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message abacus.v2.ListMetadataKeysRequest.
 * Use `create(ListMetadataKeysRequestSchema)` to create a new message.
 */
export const ListMetadataKeysRequestSchema: GenMessage<ListMetadataKeysRequest, { jsonType: ListMetadataKeysRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 98);

/**
 * @generated from message abacus.v2.ListMetadataKeysResponse
 */
export type ListMetadataKeysResponse = Message<"abacus.v2.ListMetadataKeysResponse"> & {
	/**
	 * @generated from field: repeated string keys = 1;
	 */
	keys: string[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message abacus.v2.ListMetadataKeysResponse
 */
export type ListMetadataKeysResponseJson = {
	/**
	 * @generated from field: repeated string keys = 1;
	 */
	keys?: string[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message abacus.v2.ListMetadataKeysResponse.
 * Use `create(ListMetadataKeysResponseSchema)` to create a new message.
 */
export const ListMetadataKeysResponseSchema: GenMessage<ListMetadataKeysResponse, { jsonType: ListMetadataKeysResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 99);

/**
 * @generated from message abacus.v2.ListUserSegmentsRequest
 */
export type ListUserSegmentsRequest = Message<"abacus.v2.ListUserSegmentsRequest"> & {
	/**
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval: Interval;

	/**
	 * @generated from field: string timezone = 2;
	 */
	timezone: string;

	/**
	 * @generated from field: optional abacus.v2.TimeRange time_range = 3;
	 */
	timeRange?: TimeRange | undefined;

	/**
	 * @generated from field: string org_id = 4;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 5;
	 */
	workspaceId: string;

	/**
	 * @generated from field: bool include_shared_workspaces = 8;
	 */
	includeSharedWorkspaces: boolean;

	/**
	 * @generated from field: abacus.v2.ContactsFilter contacts_filter = 6;
	 */
	contactsFilter?: ContactsFilter | undefined;

	/**
	 * @generated from field: repeated abacus.v2.UserSegmentRequest requests = 7;
	 */
	requests: UserSegmentRequest[];
};

/**
 * @generated from message abacus.v2.ListUserSegmentsRequest
 */
export type ListUserSegmentsRequestJson = {
	/**
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval?: IntervalJson;

	/**
	 * @generated from field: string timezone = 2;
	 */
	timezone?: string;

	/**
	 * @generated from field: optional abacus.v2.TimeRange time_range = 3;
	 */
	timeRange?: TimeRangeJson;

	/**
	 * @generated from field: string org_id = 4;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 5;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: bool include_shared_workspaces = 8;
	 */
	includeSharedWorkspaces?: boolean;

	/**
	 * @generated from field: abacus.v2.ContactsFilter contacts_filter = 6;
	 */
	contactsFilter?: ContactsFilterJson;

	/**
	 * @generated from field: repeated abacus.v2.UserSegmentRequest requests = 7;
	 */
	requests?: UserSegmentRequestJson[];
};

/**
 * Describes the message abacus.v2.ListUserSegmentsRequest.
 * Use `create(ListUserSegmentsRequestSchema)` to create a new message.
 */
export const ListUserSegmentsRequestSchema: GenMessage<ListUserSegmentsRequest, { jsonType: ListUserSegmentsRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 100);

/**
 * @generated from message abacus.v2.ListUserSegmentsResponse
 */
export type ListUserSegmentsResponse = Message<"abacus.v2.ListUserSegmentsResponse"> & {
	/**
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval: Interval;

	/**
	 * @generated from field: string timezone = 2;
	 */
	timezone: string;

	/**
	 * @generated from field: optional abacus.v2.TimeRange time_range = 3;
	 */
	timeRange?: TimeRange | undefined;

	/**
	 * @generated from field: int64 visitors = 4;
	 */
	visitors: bigint;

	/**
	 * @generated from field: int64 matched_households_count = 7;
	 */
	matchedHouseholdsCount: bigint;

	/**
	 * @generated from field: int64 matched_individuals_count = 8;
	 */
	matchedIndividualsCount: bigint;

	/**
	 * @generated from field: float matched = 5;
	 */
	matched: number;

	/**
	 * @generated from field: repeated abacus.v2.UserSegment segments = 6;
	 */
	segments: UserSegment[];
};

/**
 * @generated from message abacus.v2.ListUserSegmentsResponse
 */
export type ListUserSegmentsResponseJson = {
	/**
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval?: IntervalJson;

	/**
	 * @generated from field: string timezone = 2;
	 */
	timezone?: string;

	/**
	 * @generated from field: optional abacus.v2.TimeRange time_range = 3;
	 */
	timeRange?: TimeRangeJson;

	/**
	 * @generated from field: int64 visitors = 4;
	 */
	visitors?: string;

	/**
	 * @generated from field: int64 matched_households_count = 7;
	 */
	matchedHouseholdsCount?: string;

	/**
	 * @generated from field: int64 matched_individuals_count = 8;
	 */
	matchedIndividualsCount?: string;

	/**
	 * @generated from field: float matched = 5;
	 */
	matched?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: repeated abacus.v2.UserSegment segments = 6;
	 */
	segments?: UserSegmentJson[];
};

/**
 * Describes the message abacus.v2.ListUserSegmentsResponse.
 * Use `create(ListUserSegmentsResponseSchema)` to create a new message.
 */
export const ListUserSegmentsResponseSchema: GenMessage<ListUserSegmentsResponse, { jsonType: ListUserSegmentsResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 101);

/**
 * @generated from message abacus.v2.GetContactsFilterOptionsRequest
 */
export type GetContactsFilterOptionsRequest = Message<"abacus.v2.GetContactsFilterOptionsRequest"> & {
	/**
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval: Interval;

	/**
	 * @generated from field: string timezone = 2;
	 */
	timezone: string;

	/**
	 * @generated from field: optional abacus.v2.TimeRange time_range = 7;
	 */
	timeRange?: TimeRange | undefined;

	/**
	 * @generated from field: string org_id = 3;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 4;
	 */
	workspaceId: string;

	/**
	 * @generated from field: bool include_shared_workspaces = 8;
	 */
	includeSharedWorkspaces: boolean;

	/**
	 * @generated from field: repeated abacus.v2.PaginatedContactsFilterType paginated_contacts_filter_types = 5;
	 */
	paginatedContactsFilterTypes: PaginatedContactsFilterType[];

	/**
	 * @generated from field: abacus.v2.ContactsFilter filter = 6;
	 */
	filter?: ContactsFilter | undefined;
};

/**
 * @generated from message abacus.v2.GetContactsFilterOptionsRequest
 */
export type GetContactsFilterOptionsRequestJson = {
	/**
	 * @generated from field: abacus.v2.Interval interval = 1;
	 */
	interval?: IntervalJson;

	/**
	 * @generated from field: string timezone = 2;
	 */
	timezone?: string;

	/**
	 * @generated from field: optional abacus.v2.TimeRange time_range = 7;
	 */
	timeRange?: TimeRangeJson;

	/**
	 * @generated from field: string org_id = 3;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 4;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: bool include_shared_workspaces = 8;
	 */
	includeSharedWorkspaces?: boolean;

	/**
	 * @generated from field: repeated abacus.v2.PaginatedContactsFilterType paginated_contacts_filter_types = 5;
	 */
	paginatedContactsFilterTypes?: PaginatedContactsFilterTypeJson[];

	/**
	 * @generated from field: abacus.v2.ContactsFilter filter = 6;
	 */
	filter?: ContactsFilterJson;
};

/**
 * Describes the message abacus.v2.GetContactsFilterOptionsRequest.
 * Use `create(GetContactsFilterOptionsRequestSchema)` to create a new message.
 */
export const GetContactsFilterOptionsRequestSchema: GenMessage<GetContactsFilterOptionsRequest, { jsonType: GetContactsFilterOptionsRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 102);

/**
 * @generated from message abacus.v2.GetContactsFilterOptionsResponse
 */
export type GetContactsFilterOptionsResponse = Message<"abacus.v2.GetContactsFilterOptionsResponse"> & {
	/**
	 * @generated from field: repeated abacus.v2.ContactsFilterOptions contacts_filter_options = 1;
	 */
	contactsFilterOptions: ContactsFilterOptions[];
};

/**
 * @generated from message abacus.v2.GetContactsFilterOptionsResponse
 */
export type GetContactsFilterOptionsResponseJson = {
	/**
	 * @generated from field: repeated abacus.v2.ContactsFilterOptions contacts_filter_options = 1;
	 */
	contactsFilterOptions?: ContactsFilterOptionsJson[];
};

/**
 * Describes the message abacus.v2.GetContactsFilterOptionsResponse.
 * Use `create(GetContactsFilterOptionsResponseSchema)` to create a new message.
 */
export const GetContactsFilterOptionsResponseSchema: GenMessage<GetContactsFilterOptionsResponse, { jsonType: GetContactsFilterOptionsResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 103);

/**
 * @generated from message abacus.v2.GetRowCountRequest
 */
export type GetRowCountRequest = Message<"abacus.v2.GetRowCountRequest"> & {
	/**
	 * @generated from oneof abacus.v2.GetRowCountRequest.request
	 */
	request:
		| {
				/**
				 * @generated from field: abacus.v2.ListConversionRatesRequest list_conversion_rates_request = 1;
				 */
				value: ListConversionRatesRequest;
				case: "listConversionRatesRequest";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.ListContactsRequest list_contacts_request = 2;
				 */
				value: ListContactsRequest;
				case: "listContactsRequest";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.ListActivityRequest list_activity_request = 3;
				 */
				value: ListActivityRequest;
				case: "listActivityRequest";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message abacus.v2.GetRowCountRequest
 */
export type GetRowCountRequestJson = {
	/**
	 * @generated from field: abacus.v2.ListConversionRatesRequest list_conversion_rates_request = 1;
	 */
	listConversionRatesRequest?: ListConversionRatesRequestJson;

	/**
	 * @generated from field: abacus.v2.ListContactsRequest list_contacts_request = 2;
	 */
	listContactsRequest?: ListContactsRequestJson;

	/**
	 * @generated from field: abacus.v2.ListActivityRequest list_activity_request = 3;
	 */
	listActivityRequest?: ListActivityRequestJson;
};

/**
 * Describes the message abacus.v2.GetRowCountRequest.
 * Use `create(GetRowCountRequestSchema)` to create a new message.
 */
export const GetRowCountRequestSchema: GenMessage<GetRowCountRequest, { jsonType: GetRowCountRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 104);

/**
 * @generated from message abacus.v2.GetRowCountResponse
 */
export type GetRowCountResponse = Message<"abacus.v2.GetRowCountResponse"> & {
	/**
	 * @generated from field: int64 row_count = 1;
	 */
	rowCount: bigint;
};

/**
 * @generated from message abacus.v2.GetRowCountResponse
 */
export type GetRowCountResponseJson = {
	/**
	 * @generated from field: int64 row_count = 1;
	 */
	rowCount?: string;
};

/**
 * Describes the message abacus.v2.GetRowCountResponse.
 * Use `create(GetRowCountResponseSchema)` to create a new message.
 */
export const GetRowCountResponseSchema: GenMessage<GetRowCountResponse, { jsonType: GetRowCountResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 105);

/**
 * @generated from message abacus.v2.StreamCsvFileRequest
 */
export type StreamCsvFileRequest = Message<"abacus.v2.StreamCsvFileRequest"> & {
	/**
	 * @generated from field: repeated abacus.v2.FormField form_fields = 3;
	 */
	formFields: FormField[];

	/**
	 * @generated from oneof abacus.v2.StreamCsvFileRequest.request
	 */
	request:
		| {
				/**
				 * @generated from field: abacus.v2.ListContactsRequest list_contacts_request = 1;
				 */
				value: ListContactsRequest;
				case: "listContactsRequest";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.ListActivityRequest list_activity_request = 2;
				 */
				value: ListActivityRequest;
				case: "listActivityRequest";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message abacus.v2.StreamCsvFileRequest
 */
export type StreamCsvFileRequestJson = {
	/**
	 * @generated from field: repeated abacus.v2.FormField form_fields = 3;
	 */
	formFields?: FormFieldJson[];

	/**
	 * @generated from field: abacus.v2.ListContactsRequest list_contacts_request = 1;
	 */
	listContactsRequest?: ListContactsRequestJson;

	/**
	 * @generated from field: abacus.v2.ListActivityRequest list_activity_request = 2;
	 */
	listActivityRequest?: ListActivityRequestJson;
};

/**
 * Describes the message abacus.v2.StreamCsvFileRequest.
 * Use `create(StreamCsvFileRequestSchema)` to create a new message.
 */
export const StreamCsvFileRequestSchema: GenMessage<StreamCsvFileRequest, { jsonType: StreamCsvFileRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 106);

/**
 * @generated from message abacus.v2.StreamCsvFileResponse
 */
export type StreamCsvFileResponse = Message<"abacus.v2.StreamCsvFileResponse"> & {
	/**
	 * @generated from field: bytes row = 1;
	 */
	row: Uint8Array;
};

/**
 * @generated from message abacus.v2.StreamCsvFileResponse
 */
export type StreamCsvFileResponseJson = {
	/**
	 * @generated from field: bytes row = 1;
	 */
	row?: string;
};

/**
 * Describes the message abacus.v2.StreamCsvFileResponse.
 * Use `create(StreamCsvFileResponseSchema)` to create a new message.
 */
export const StreamCsvFileResponseSchema: GenMessage<StreamCsvFileResponse, { jsonType: StreamCsvFileResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 107);

/**
 * @generated from message abacus.v2.NamedCsvRequest
 */
export type NamedCsvRequest = Message<"abacus.v2.NamedCsvRequest"> & {
	/**
	 * @generated from field: string name = 1;
	 */
	name: string;

	/**
	 * @generated from field: repeated abacus.v2.FormField form_fields = 8;
	 */
	formFields: FormField[];

	/**
	 * @generated from field: repeated string metrics = 11;
	 */
	metrics: string[];

	/**
	 * @generated from oneof abacus.v2.NamedCsvRequest.request
	 */
	request:
		| {
				/**
				 * @generated from field: abacus.v2.GetConversionRateSummaryRequest get_conversion_rate_summary_request = 2;
				 */
				value: GetConversionRateSummaryRequest;
				case: "getConversionRateSummaryRequest";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.GetConversionTypeSummaryRequest get_conversion_type_summary_request = 9;
				 */
				value: GetConversionTypeSummaryRequest;
				case: "getConversionTypeSummaryRequest";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.GetContactsSummaryRequest get_contacts_summary_request = 3;
				 */
				value: GetContactsSummaryRequest;
				case: "getContactsSummaryRequest";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.GetRevenueSummaryRequest get_revenue_summary_request = 4;
				 */
				value: GetRevenueSummaryRequest;
				case: "getRevenueSummaryRequest";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.GetExperimentSummaryRequest get_experiment_summary_request = 10;
				 */
				value: GetExperimentSummaryRequest;
				case: "getExperimentSummaryRequest";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.ListConversionRatesRequest list_conversion_rates_request = 5;
				 */
				value: ListConversionRatesRequest;
				case: "listConversionRatesRequest";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.ListActivityRequest list_activity_request = 6;
				 */
				value: ListActivityRequest;
				case: "listActivityRequest";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.ListContactsRequest list_contacts_request = 7;
				 */
				value: ListContactsRequest;
				case: "listContactsRequest";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message abacus.v2.NamedCsvRequest
 */
export type NamedCsvRequestJson = {
	/**
	 * @generated from field: string name = 1;
	 */
	name?: string;

	/**
	 * @generated from field: repeated abacus.v2.FormField form_fields = 8;
	 */
	formFields?: FormFieldJson[];

	/**
	 * @generated from field: repeated string metrics = 11;
	 */
	metrics?: string[];

	/**
	 * @generated from field: abacus.v2.GetConversionRateSummaryRequest get_conversion_rate_summary_request = 2;
	 */
	getConversionRateSummaryRequest?: GetConversionRateSummaryRequestJson;

	/**
	 * @generated from field: abacus.v2.GetConversionTypeSummaryRequest get_conversion_type_summary_request = 9;
	 */
	getConversionTypeSummaryRequest?: GetConversionTypeSummaryRequestJson;

	/**
	 * @generated from field: abacus.v2.GetContactsSummaryRequest get_contacts_summary_request = 3;
	 */
	getContactsSummaryRequest?: GetContactsSummaryRequestJson;

	/**
	 * @generated from field: abacus.v2.GetRevenueSummaryRequest get_revenue_summary_request = 4;
	 */
	getRevenueSummaryRequest?: GetRevenueSummaryRequestJson;

	/**
	 * @generated from field: abacus.v2.GetExperimentSummaryRequest get_experiment_summary_request = 10;
	 */
	getExperimentSummaryRequest?: GetExperimentSummaryRequestJson;

	/**
	 * @generated from field: abacus.v2.ListConversionRatesRequest list_conversion_rates_request = 5;
	 */
	listConversionRatesRequest?: ListConversionRatesRequestJson;

	/**
	 * @generated from field: abacus.v2.ListActivityRequest list_activity_request = 6;
	 */
	listActivityRequest?: ListActivityRequestJson;

	/**
	 * @generated from field: abacus.v2.ListContactsRequest list_contacts_request = 7;
	 */
	listContactsRequest?: ListContactsRequestJson;
};

/**
 * Describes the message abacus.v2.NamedCsvRequest.
 * Use `create(NamedCsvRequestSchema)` to create a new message.
 */
export const NamedCsvRequestSchema: GenMessage<NamedCsvRequest, { jsonType: NamedCsvRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 108);

/**
 * @generated from message abacus.v2.StreamZipFileRequest
 */
export type StreamZipFileRequest = Message<"abacus.v2.StreamZipFileRequest"> & {
	/**
	 * @generated from field: repeated abacus.v2.NamedCsvRequest named_csv_requests = 1;
	 */
	namedCsvRequests: NamedCsvRequest[];

	/**
	 * @generated from field: repeated abacus.v2.ChartRequest chart_requests = 2;
	 */
	chartRequests: ChartRequest[];

	/**
	 * @generated from field: string dashboard_id = 3;
	 */
	dashboardId: string;

	/**
	 * @generated from field: abacus.v2.DashboardFilter dashboard_filter = 4;
	 */
	dashboardFilter?: DashboardFilter | undefined;
};

/**
 * @generated from message abacus.v2.StreamZipFileRequest
 */
export type StreamZipFileRequestJson = {
	/**
	 * @generated from field: repeated abacus.v2.NamedCsvRequest named_csv_requests = 1;
	 */
	namedCsvRequests?: NamedCsvRequestJson[];

	/**
	 * @generated from field: repeated abacus.v2.ChartRequest chart_requests = 2;
	 */
	chartRequests?: ChartRequestJson[];

	/**
	 * @generated from field: string dashboard_id = 3;
	 */
	dashboardId?: string;

	/**
	 * @generated from field: abacus.v2.DashboardFilter dashboard_filter = 4;
	 */
	dashboardFilter?: DashboardFilterJson;
};

/**
 * Describes the message abacus.v2.StreamZipFileRequest.
 * Use `create(StreamZipFileRequestSchema)` to create a new message.
 */
export const StreamZipFileRequestSchema: GenMessage<StreamZipFileRequest, { jsonType: StreamZipFileRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 109);

/**
 * @generated from message abacus.v2.StreamZipFileResponse
 */
export type StreamZipFileResponse = Message<"abacus.v2.StreamZipFileResponse"> & {
	/**
	 * @generated from field: string s3_url = 1;
	 */
	s3Url: string;
};

/**
 * @generated from message abacus.v2.StreamZipFileResponse
 */
export type StreamZipFileResponseJson = {
	/**
	 * @generated from field: string s3_url = 1;
	 */
	s3Url?: string;
};

/**
 * Describes the message abacus.v2.StreamZipFileResponse.
 * Use `create(StreamZipFileResponseSchema)` to create a new message.
 */
export const StreamZipFileResponseSchema: GenMessage<StreamZipFileResponse, { jsonType: StreamZipFileResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 110);

/**
 * ExportZipFileRequest exports a set of csv files as a zip file.
 *
 * @generated from message abacus.v2.ExportZipFileRequest
 */
export type ExportZipFileRequest = Message<"abacus.v2.ExportZipFileRequest"> & {
	/**
	 * @generated from field: repeated abacus.v2.ChartRequest chart_requests = 1;
	 */
	chartRequests: ChartRequest[];

	/**
	 * @generated from field: string dashboard_id = 2;
	 */
	dashboardId: string;

	/**
	 * @generated from field: abacus.v2.DashboardFilter dashboard_filter = 3;
	 */
	dashboardFilter?: DashboardFilter | undefined;

	/**
	 * @generated from field: repeated string email_recipients = 4;
	 */
	emailRecipients: string[];

	/**
	 * @generated from field: common.v1.Creator creator = 5;
	 */
	creator?: Creator | undefined;

	/**
	 * @generated from field: abacus.v2.ExportSource source = 6;
	 */
	source: ExportSource;
};

/**
 * ExportZipFileRequest exports a set of csv files as a zip file.
 *
 * @generated from message abacus.v2.ExportZipFileRequest
 */
export type ExportZipFileRequestJson = {
	/**
	 * @generated from field: repeated abacus.v2.ChartRequest chart_requests = 1;
	 */
	chartRequests?: ChartRequestJson[];

	/**
	 * @generated from field: string dashboard_id = 2;
	 */
	dashboardId?: string;

	/**
	 * @generated from field: abacus.v2.DashboardFilter dashboard_filter = 3;
	 */
	dashboardFilter?: DashboardFilterJson;

	/**
	 * @generated from field: repeated string email_recipients = 4;
	 */
	emailRecipients?: string[];

	/**
	 * @generated from field: common.v1.Creator creator = 5;
	 */
	creator?: CreatorJson;

	/**
	 * @generated from field: abacus.v2.ExportSource source = 6;
	 */
	source?: ExportSourceJson;
};

/**
 * Describes the message abacus.v2.ExportZipFileRequest.
 * Use `create(ExportZipFileRequestSchema)` to create a new message.
 */
export const ExportZipFileRequestSchema: GenMessage<ExportZipFileRequest, { jsonType: ExportZipFileRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 111);

/**
 * @generated from message abacus.v2.ExportZipFileResponse
 */
export type ExportZipFileResponse = Message<"abacus.v2.ExportZipFileResponse"> & {
	/**
	 * @generated from field: string url = 1;
	 */
	url: string;
};

/**
 * @generated from message abacus.v2.ExportZipFileResponse
 */
export type ExportZipFileResponseJson = {
	/**
	 * @generated from field: string url = 1;
	 */
	url?: string;
};

/**
 * Describes the message abacus.v2.ExportZipFileResponse.
 * Use `create(ExportZipFileResponseSchema)` to create a new message.
 */
export const ExportZipFileResponseSchema: GenMessage<ExportZipFileResponse, { jsonType: ExportZipFileResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 112);

/**
 * GetExportDownloadUrlRequest requests a presigned download link for a
 * previously exported zip file.
 *
 * @generated from message abacus.v2.GetExportDownloadUrlRequest
 */
export type GetExportDownloadUrlRequest = Message<"abacus.v2.GetExportDownloadUrlRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string export_id = 3;
	 */
	exportId: string;
};

/**
 * GetExportDownloadUrlRequest requests a presigned download link for a
 * previously exported zip file.
 *
 * @generated from message abacus.v2.GetExportDownloadUrlRequest
 */
export type GetExportDownloadUrlRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string export_id = 3;
	 */
	exportId?: string;
};

/**
 * Describes the message abacus.v2.GetExportDownloadUrlRequest.
 * Use `create(GetExportDownloadUrlRequestSchema)` to create a new message.
 */
export const GetExportDownloadUrlRequestSchema: GenMessage<GetExportDownloadUrlRequest, { jsonType: GetExportDownloadUrlRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 113);

/**
 * @generated from message abacus.v2.GetExportDownloadUrlResponse
 */
export type GetExportDownloadUrlResponse = Message<"abacus.v2.GetExportDownloadUrlResponse"> & {
	/**
	 * @generated from field: string url = 1;
	 */
	url: string;
};

/**
 * @generated from message abacus.v2.GetExportDownloadUrlResponse
 */
export type GetExportDownloadUrlResponseJson = {
	/**
	 * @generated from field: string url = 1;
	 */
	url?: string;
};

/**
 * Describes the message abacus.v2.GetExportDownloadUrlResponse.
 * Use `create(GetExportDownloadUrlResponseSchema)` to create a new message.
 */
export const GetExportDownloadUrlResponseSchema: GenMessage<GetExportDownloadUrlResponse, { jsonType: GetExportDownloadUrlResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 114);

/**
 * @generated from message abacus.v2.ChartTheme
 */
export type ChartTheme = Message<"abacus.v2.ChartTheme"> & {
	/**
	 * @generated from field: repeated string colors = 1;
	 */
	colors: string[];
};

/**
 * @generated from message abacus.v2.ChartTheme
 */
export type ChartThemeJson = {
	/**
	 * @generated from field: repeated string colors = 1;
	 */
	colors?: string[];
};

/**
 * Describes the message abacus.v2.ChartTheme.
 * Use `create(ChartThemeSchema)` to create a new message.
 */
export const ChartThemeSchema: GenMessage<ChartTheme, { jsonType: ChartThemeJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 115);

/**
 * @generated from message abacus.v2.LegendConfiguration
 */
export type LegendConfiguration = Message<"abacus.v2.LegendConfiguration"> & {
	/**
	 * @generated from field: bool show = 1;
	 */
	show: boolean;

	/**
	 * @generated from field: string position = 2;
	 */
	position: string;

	/**
	 * @generated from field: string horizontal_align = 3;
	 */
	horizontalAlign: string;
};

/**
 * @generated from message abacus.v2.LegendConfiguration
 */
export type LegendConfigurationJson = {
	/**
	 * @generated from field: bool show = 1;
	 */
	show?: boolean;

	/**
	 * @generated from field: string position = 2;
	 */
	position?: string;

	/**
	 * @generated from field: string horizontal_align = 3;
	 */
	horizontalAlign?: string;
};

/**
 * Describes the message abacus.v2.LegendConfiguration.
 * Use `create(LegendConfigurationSchema)` to create a new message.
 */
export const LegendConfigurationSchema: GenMessage<LegendConfiguration, { jsonType: LegendConfigurationJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 116);

/**
 * @generated from message abacus.v2.BarLineOptions
 */
export type BarLineOptions = Message<"abacus.v2.BarLineOptions"> & {
	/**
	 * @generated from field: abacus.v2.ChartTheme theme = 1;
	 */
	theme?: ChartTheme | undefined;

	/**
	 * @generated from field: abacus.v2.LegendConfiguration legend_config = 2;
	 */
	legendConfig?: LegendConfiguration | undefined;

	/**
	 * @generated from field: optional bool show_labels = 3;
	 */
	showLabels?: boolean | undefined;
};

/**
 * @generated from message abacus.v2.BarLineOptions
 */
export type BarLineOptionsJson = {
	/**
	 * @generated from field: abacus.v2.ChartTheme theme = 1;
	 */
	theme?: ChartThemeJson;

	/**
	 * @generated from field: abacus.v2.LegendConfiguration legend_config = 2;
	 */
	legendConfig?: LegendConfigurationJson;

	/**
	 * @generated from field: optional bool show_labels = 3;
	 */
	showLabels?: boolean;
};

/**
 * Describes the message abacus.v2.BarLineOptions.
 * Use `create(BarLineOptionsSchema)` to create a new message.
 */
export const BarLineOptionsSchema: GenMessage<BarLineOptions, { jsonType: BarLineOptionsJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 117);

/**
 * @generated from message abacus.v2.HeaderOptions
 */
export type HeaderOptions = Message<"abacus.v2.HeaderOptions"> & {};

/**
 * @generated from message abacus.v2.HeaderOptions
 */
export type HeaderOptionsJson = {};

/**
 * Describes the message abacus.v2.HeaderOptions.
 * Use `create(HeaderOptionsSchema)` to create a new message.
 */
export const HeaderOptionsSchema: GenMessage<HeaderOptions, { jsonType: HeaderOptionsJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 118);

/**
 * @generated from message abacus.v2.HeatmapOptions
 */
export type HeatmapOptions = Message<"abacus.v2.HeatmapOptions"> & {
	/**
	 * @generated from field: abacus.v2.ChartTheme theme = 1;
	 */
	theme?: ChartTheme | undefined;

	/**
	 * @generated from field: optional bool show_labels = 2;
	 */
	showLabels?: boolean | undefined;
};

/**
 * @generated from message abacus.v2.HeatmapOptions
 */
export type HeatmapOptionsJson = {
	/**
	 * @generated from field: abacus.v2.ChartTheme theme = 1;
	 */
	theme?: ChartThemeJson;

	/**
	 * @generated from field: optional bool show_labels = 2;
	 */
	showLabels?: boolean;
};

/**
 * Describes the message abacus.v2.HeatmapOptions.
 * Use `create(HeatmapOptionsSchema)` to create a new message.
 */
export const HeatmapOptionsSchema: GenMessage<HeatmapOptions, { jsonType: HeatmapOptionsJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 119);

/**
 * @generated from message abacus.v2.TotalOptions
 */
export type TotalOptions = Message<"abacus.v2.TotalOptions"> & {
	/**
	 * @generated from field: abacus.v2.ChartTheme theme = 1;
	 */
	theme?: ChartTheme | undefined;
};

/**
 * @generated from message abacus.v2.TotalOptions
 */
export type TotalOptionsJson = {
	/**
	 * @generated from field: abacus.v2.ChartTheme theme = 1;
	 */
	theme?: ChartThemeJson;
};

/**
 * Describes the message abacus.v2.TotalOptions.
 * Use `create(TotalOptionsSchema)` to create a new message.
 */
export const TotalOptionsSchema: GenMessage<TotalOptions, { jsonType: TotalOptionsJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 120);

/**
 * @generated from message abacus.v2.PieDonutOptions
 */
export type PieDonutOptions = Message<"abacus.v2.PieDonutOptions"> & {
	/**
	 * @generated from field: abacus.v2.ChartTheme theme = 1;
	 */
	theme?: ChartTheme | undefined;

	/**
	 * @generated from field: abacus.v2.LegendConfiguration legend_config = 3;
	 */
	legendConfig?: LegendConfiguration | undefined;

	/**
	 * @generated from field: optional bool show_labels = 2;
	 */
	showLabels?: boolean | undefined;
};

/**
 * @generated from message abacus.v2.PieDonutOptions
 */
export type PieDonutOptionsJson = {
	/**
	 * @generated from field: abacus.v2.ChartTheme theme = 1;
	 */
	theme?: ChartThemeJson;

	/**
	 * @generated from field: abacus.v2.LegendConfiguration legend_config = 3;
	 */
	legendConfig?: LegendConfigurationJson;

	/**
	 * @generated from field: optional bool show_labels = 2;
	 */
	showLabels?: boolean;
};

/**
 * Describes the message abacus.v2.PieDonutOptions.
 * Use `create(PieDonutOptionsSchema)` to create a new message.
 */
export const PieDonutOptionsSchema: GenMessage<PieDonutOptions, { jsonType: PieDonutOptionsJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 121);

/**
 * @generated from message abacus.v2.TableOptions
 */
export type TableOptions = Message<"abacus.v2.TableOptions"> & {};

/**
 * @generated from message abacus.v2.TableOptions
 */
export type TableOptionsJson = {};

/**
 * Describes the message abacus.v2.TableOptions.
 * Use `create(TableOptionsSchema)` to create a new message.
 */
export const TableOptionsSchema: GenMessage<TableOptions, { jsonType: TableOptionsJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 122);

/**
 * @generated from message abacus.v2.GeoMapOptions
 */
export type GeoMapOptions = Message<"abacus.v2.GeoMapOptions"> & {
	/**
	 * @generated from field: repeated bundles.v1.GeoLocationSource sources = 1;
	 */
	sources: GeoLocationSource[];
};

/**
 * @generated from message abacus.v2.GeoMapOptions
 */
export type GeoMapOptionsJson = {
	/**
	 * @generated from field: repeated bundles.v1.GeoLocationSource sources = 1;
	 */
	sources?: GeoLocationSourceJson[];
};

/**
 * Describes the message abacus.v2.GeoMapOptions.
 * Use `create(GeoMapOptionsSchema)` to create a new message.
 */
export const GeoMapOptionsSchema: GenMessage<GeoMapOptions, { jsonType: GeoMapOptionsJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 123);

/**
 * @generated from message abacus.v2.ChartOptions
 */
export type ChartOptions = Message<"abacus.v2.ChartOptions"> & {
	/**
	 * @generated from oneof abacus.v2.ChartOptions.options
	 */
	options:
		| {
				/**
				 * @generated from field: abacus.v2.BarLineOptions bar_line = 1;
				 */
				value: BarLineOptions;
				case: "barLine";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.HeaderOptions header = 2;
				 */
				value: HeaderOptions;
				case: "header";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.HeatmapOptions heatmap = 3;
				 */
				value: HeatmapOptions;
				case: "heatmap";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.TotalOptions total = 4;
				 */
				value: TotalOptions;
				case: "total";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.PieDonutOptions pie_donut = 5;
				 */
				value: PieDonutOptions;
				case: "pieDonut";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.TableOptions table = 6;
				 */
				value: TableOptions;
				case: "table";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.GeoMapOptions geo_map = 7;
				 */
				value: GeoMapOptions;
				case: "geoMap";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message abacus.v2.ChartOptions
 */
export type ChartOptionsJson = {
	/**
	 * @generated from field: abacus.v2.BarLineOptions bar_line = 1;
	 */
	barLine?: BarLineOptionsJson;

	/**
	 * @generated from field: abacus.v2.HeaderOptions header = 2;
	 */
	header?: HeaderOptionsJson;

	/**
	 * @generated from field: abacus.v2.HeatmapOptions heatmap = 3;
	 */
	heatmap?: HeatmapOptionsJson;

	/**
	 * @generated from field: abacus.v2.TotalOptions total = 4;
	 */
	total?: TotalOptionsJson;

	/**
	 * @generated from field: abacus.v2.PieDonutOptions pie_donut = 5;
	 */
	pieDonut?: PieDonutOptionsJson;

	/**
	 * @generated from field: abacus.v2.TableOptions table = 6;
	 */
	table?: TableOptionsJson;

	/**
	 * @generated from field: abacus.v2.GeoMapOptions geo_map = 7;
	 */
	geoMap?: GeoMapOptionsJson;
};

/**
 * Describes the message abacus.v2.ChartOptions.
 * Use `create(ChartOptionsSchema)` to create a new message.
 */
export const ChartOptionsSchema: GenMessage<ChartOptions, { jsonType: ChartOptionsJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 124);

/**
 * @generated from message abacus.v2.ContactField
 */
export type ContactField = Message<"abacus.v2.ContactField"> & {
	/**
	 * @generated from oneof abacus.v2.ContactField.field
	 */
	field:
		| {
				/**
				 * @generated from field: abacus.v2.ExportField export_field = 1;
				 */
				value: ExportField;
				case: "exportField";
		  }
		| {
				/**
				 * @generated from field: string contact_property_key = 2;
				 */
				value: string;
				case: "contactPropertyKey";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.SchemaPropertyRef property_ref = 3;
				 */
				value: SchemaPropertyRef;
				case: "propertyRef";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message abacus.v2.ContactField
 */
export type ContactFieldJson = {
	/**
	 * @generated from field: abacus.v2.ExportField export_field = 1;
	 */
	exportField?: ExportFieldJson;

	/**
	 * @generated from field: string contact_property_key = 2;
	 */
	contactPropertyKey?: string;

	/**
	 * @generated from field: abacus.v2.SchemaPropertyRef property_ref = 3;
	 */
	propertyRef?: SchemaPropertyRefJson;
};

/**
 * Describes the message abacus.v2.ContactField.
 * Use `create(ContactFieldSchema)` to create a new message.
 */
export const ContactFieldSchema: GenMessage<ContactField, { jsonType: ContactFieldJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 125);

/**
 * @generated from message abacus.v2.CsvConfig
 */
export type CsvConfig = Message<"abacus.v2.CsvConfig"> & {
	/**
	 * @generated from field: string file_name = 1;
	 */
	fileName: string;

	/**
	 * @generated from field: repeated abacus.v2.FormField form_fields = 2;
	 */
	formFields: FormField[];

	/**
	 * @generated from field: repeated string metrics = 3;
	 */
	metrics: string[];

	/**
	 * @generated from field: repeated abacus.v2.ExportField export_fields = 4;
	 */
	exportFields: ExportField[];

	/**
	 * @generated from field: repeated abacus.v2.ContactField contact_fields = 5;
	 */
	contactFields: ContactField[];
};

/**
 * @generated from message abacus.v2.CsvConfig
 */
export type CsvConfigJson = {
	/**
	 * @generated from field: string file_name = 1;
	 */
	fileName?: string;

	/**
	 * @generated from field: repeated abacus.v2.FormField form_fields = 2;
	 */
	formFields?: FormFieldJson[];

	/**
	 * @generated from field: repeated string metrics = 3;
	 */
	metrics?: string[];

	/**
	 * @generated from field: repeated abacus.v2.ExportField export_fields = 4;
	 */
	exportFields?: ExportFieldJson[];

	/**
	 * @generated from field: repeated abacus.v2.ContactField contact_fields = 5;
	 */
	contactFields?: ContactFieldJson[];
};

/**
 * Describes the message abacus.v2.CsvConfig.
 * Use `create(CsvConfigSchema)` to create a new message.
 */
export const CsvConfigSchema: GenMessage<CsvConfig, { jsonType: CsvConfigJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 126);

/**
 * @generated from message abacus.v2.Chart
 */
export type Chart = Message<"abacus.v2.Chart"> & {
	/**
	 * @generated from field: string name = 1;
	 */
	name: string;

	/**
	 * @generated from field: abacus.v2.ChartType type = 2;
	 */
	type: ChartType;

	/**
	 * @generated from field: repeated string metrics = 3;
	 */
	metrics: string[];

	/**
	 * @generated from field: repeated abacus.v2.ExportField export_fields = 8;
	 */
	exportFields: ExportField[];

	/**
	 * @generated from field: int32 rows = 4;
	 */
	rows: number;

	/**
	 * @generated from field: int32 columns = 5;
	 */
	columns: number;

	/**
	 * @generated from field: abacus.v2.ChartOptions chart_options = 9;
	 */
	chartOptions?: ChartOptions | undefined;

	/**
	 * @generated from field: bool is_custom = 6;
	 */
	isCustom: boolean;

	/**
	 * @generated from field: string creator_email = 7;
	 */
	creatorEmail: string;
};

/**
 * @generated from message abacus.v2.Chart
 */
export type ChartJson = {
	/**
	 * @generated from field: string name = 1;
	 */
	name?: string;

	/**
	 * @generated from field: abacus.v2.ChartType type = 2;
	 */
	type?: ChartTypeJson;

	/**
	 * @generated from field: repeated string metrics = 3;
	 */
	metrics?: string[];

	/**
	 * @generated from field: repeated abacus.v2.ExportField export_fields = 8;
	 */
	exportFields?: ExportFieldJson[];

	/**
	 * @generated from field: int32 rows = 4;
	 */
	rows?: number;

	/**
	 * @generated from field: int32 columns = 5;
	 */
	columns?: number;

	/**
	 * @generated from field: abacus.v2.ChartOptions chart_options = 9;
	 */
	chartOptions?: ChartOptionsJson;

	/**
	 * @generated from field: bool is_custom = 6;
	 */
	isCustom?: boolean;

	/**
	 * @generated from field: string creator_email = 7;
	 */
	creatorEmail?: string;
};

/**
 * Describes the message abacus.v2.Chart.
 * Use `create(ChartSchema)` to create a new message.
 */
export const ChartSchema: GenMessage<Chart, { jsonType: ChartJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 127);

/**
 * @generated from message abacus.v2.ChartRequest
 */
export type ChartRequest = Message<"abacus.v2.ChartRequest"> & {
	/**
	 * @generated from field: repeated abacus.v2.Chart charts = 1;
	 */
	charts: Chart[];

	/**
	 * @generated from field: abacus.v2.CsvConfig csv_config = 10;
	 */
	csvConfig?: CsvConfig | undefined;

	/**
	 * @generated from oneof abacus.v2.ChartRequest.request
	 */
	request:
		| {
				/**
				 * @generated from field: abacus.v2.GetConversionRateSummaryRequest get_conversion_rate_summary_request = 2;
				 */
				value: GetConversionRateSummaryRequest;
				case: "getConversionRateSummaryRequest";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.ListConversionRatesRequest list_conversion_rates_request = 3;
				 */
				value: ListConversionRatesRequest;
				case: "listConversionRatesRequest";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.GetContactsSummaryRequest get_contacts_summary_request = 4;
				 */
				value: GetContactsSummaryRequest;
				case: "getContactsSummaryRequest";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.GetExperimentSummaryRequest get_experiment_summary_request = 5;
				 */
				value: GetExperimentSummaryRequest;
				case: "getExperimentSummaryRequest";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.GetConversionTypeSummaryRequest get_conversion_type_summary_request = 6;
				 */
				value: GetConversionTypeSummaryRequest;
				case: "getConversionTypeSummaryRequest";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.GetRevenueSummaryRequest get_revenue_summary_request = 7;
				 */
				value: GetRevenueSummaryRequest;
				case: "getRevenueSummaryRequest";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.ListActivityRequest list_activity_request = 8;
				 */
				value: ListActivityRequest;
				case: "listActivityRequest";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.ListContactsRequest list_contacts_request = 9;
				 */
				value: ListContactsRequest;
				case: "listContactsRequest";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.GetGeoSummaryRequest get_geo_summary_request = 11;
				 */
				value: GetGeoSummaryRequest;
				case: "getGeoSummaryRequest";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.ListUserSegmentsRequest list_user_segments_request = 12;
				 */
				value: ListUserSegmentsRequest;
				case: "listUserSegmentsRequest";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message abacus.v2.ChartRequest
 */
export type ChartRequestJson = {
	/**
	 * @generated from field: repeated abacus.v2.Chart charts = 1;
	 */
	charts?: ChartJson[];

	/**
	 * @generated from field: abacus.v2.CsvConfig csv_config = 10;
	 */
	csvConfig?: CsvConfigJson;

	/**
	 * @generated from field: abacus.v2.GetConversionRateSummaryRequest get_conversion_rate_summary_request = 2;
	 */
	getConversionRateSummaryRequest?: GetConversionRateSummaryRequestJson;

	/**
	 * @generated from field: abacus.v2.ListConversionRatesRequest list_conversion_rates_request = 3;
	 */
	listConversionRatesRequest?: ListConversionRatesRequestJson;

	/**
	 * @generated from field: abacus.v2.GetContactsSummaryRequest get_contacts_summary_request = 4;
	 */
	getContactsSummaryRequest?: GetContactsSummaryRequestJson;

	/**
	 * @generated from field: abacus.v2.GetExperimentSummaryRequest get_experiment_summary_request = 5;
	 */
	getExperimentSummaryRequest?: GetExperimentSummaryRequestJson;

	/**
	 * @generated from field: abacus.v2.GetConversionTypeSummaryRequest get_conversion_type_summary_request = 6;
	 */
	getConversionTypeSummaryRequest?: GetConversionTypeSummaryRequestJson;

	/**
	 * @generated from field: abacus.v2.GetRevenueSummaryRequest get_revenue_summary_request = 7;
	 */
	getRevenueSummaryRequest?: GetRevenueSummaryRequestJson;

	/**
	 * @generated from field: abacus.v2.ListActivityRequest list_activity_request = 8;
	 */
	listActivityRequest?: ListActivityRequestJson;

	/**
	 * @generated from field: abacus.v2.ListContactsRequest list_contacts_request = 9;
	 */
	listContactsRequest?: ListContactsRequestJson;

	/**
	 * @generated from field: abacus.v2.GetGeoSummaryRequest get_geo_summary_request = 11;
	 */
	getGeoSummaryRequest?: GetGeoSummaryRequestJson;

	/**
	 * @generated from field: abacus.v2.ListUserSegmentsRequest list_user_segments_request = 12;
	 */
	listUserSegmentsRequest?: ListUserSegmentsRequestJson;
};

/**
 * Describes the message abacus.v2.ChartRequest.
 * Use `create(ChartRequestSchema)` to create a new message.
 */
export const ChartRequestSchema: GenMessage<ChartRequest, { jsonType: ChartRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 128);

/**
 * @generated from message abacus.v2.StreamPdfFileRequest
 */
export type StreamPdfFileRequest = Message<"abacus.v2.StreamPdfFileRequest"> & {
	/**
	 * @generated from field: repeated abacus.v2.ChartRequest chart_requests = 1;
	 */
	chartRequests: ChartRequest[];

	/**
	 * @generated from field: int32 total_rows = 2;
	 */
	totalRows: number;

	/**
	 * @generated from field: int32 total_columns = 3;
	 */
	totalColumns: number;

	/**
	 * @generated from field: string description = 4;
	 */
	description: string;

	/**
	 * @generated from field: string dashboard_id = 5;
	 */
	dashboardId: string;

	/**
	 * @generated from field: abacus.v2.DashboardFilter dashboard_filter = 6;
	 */
	dashboardFilter?: DashboardFilter | undefined;
};

/**
 * @generated from message abacus.v2.StreamPdfFileRequest
 */
export type StreamPdfFileRequestJson = {
	/**
	 * @generated from field: repeated abacus.v2.ChartRequest chart_requests = 1;
	 */
	chartRequests?: ChartRequestJson[];

	/**
	 * @generated from field: int32 total_rows = 2;
	 */
	totalRows?: number;

	/**
	 * @generated from field: int32 total_columns = 3;
	 */
	totalColumns?: number;

	/**
	 * @generated from field: string description = 4;
	 */
	description?: string;

	/**
	 * @generated from field: string dashboard_id = 5;
	 */
	dashboardId?: string;

	/**
	 * @generated from field: abacus.v2.DashboardFilter dashboard_filter = 6;
	 */
	dashboardFilter?: DashboardFilterJson;
};

/**
 * Describes the message abacus.v2.StreamPdfFileRequest.
 * Use `create(StreamPdfFileRequestSchema)` to create a new message.
 */
export const StreamPdfFileRequestSchema: GenMessage<StreamPdfFileRequest, { jsonType: StreamPdfFileRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 129);

/**
 * @generated from message abacus.v2.StreamPdfFileResponse
 */
export type StreamPdfFileResponse = Message<"abacus.v2.StreamPdfFileResponse"> & {
	/**
	 * @generated from field: string s3_url = 1;
	 */
	s3Url: string;
};

/**
 * @generated from message abacus.v2.StreamPdfFileResponse
 */
export type StreamPdfFileResponseJson = {
	/**
	 * @generated from field: string s3_url = 1;
	 */
	s3Url?: string;
};

/**
 * Describes the message abacus.v2.StreamPdfFileResponse.
 * Use `create(StreamPdfFileResponseSchema)` to create a new message.
 */
export const StreamPdfFileResponseSchema: GenMessage<StreamPdfFileResponse, { jsonType: StreamPdfFileResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 130);

/**
 * @generated from message abacus.v2.DeleteEventsRequest
 */
export type DeleteEventsRequest = Message<"abacus.v2.DeleteEventsRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: bool is_demo = 3;
	 */
	isDemo: boolean;
};

/**
 * @generated from message abacus.v2.DeleteEventsRequest
 */
export type DeleteEventsRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: bool is_demo = 3;
	 */
	isDemo?: boolean;
};

/**
 * Describes the message abacus.v2.DeleteEventsRequest.
 * Use `create(DeleteEventsRequestSchema)` to create a new message.
 */
export const DeleteEventsRequestSchema: GenMessage<DeleteEventsRequest, { jsonType: DeleteEventsRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 131);

/**
 * @generated from message abacus.v2.DeleteEventsResponse
 */
export type DeleteEventsResponse = Message<"abacus.v2.DeleteEventsResponse"> & {};

/**
 * @generated from message abacus.v2.DeleteEventsResponse
 */
export type DeleteEventsResponseJson = {};

/**
 * Describes the message abacus.v2.DeleteEventsResponse.
 * Use `create(DeleteEventsResponseSchema)` to create a new message.
 */
export const DeleteEventsResponseSchema: GenMessage<DeleteEventsResponse, { jsonType: DeleteEventsResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 132);

/**
 * @generated from message abacus.v2.SchemaProperty
 */
export type SchemaProperty = Message<"abacus.v2.SchemaProperty"> & {
	/**
	 * org id to which the properties belong, ignored on writes.
	 *
	 * @generated from field: string org_id = 5;
	 */
	orgId: string;

	/**
	 * workspace id to which the properties belong, ignored on writes.
	 *
	 * @generated from field: string workspace_id = 6;
	 */
	workspaceId: string;

	/**
	 * key identifier for the property, must be unique to the workspace.
	 *
	 * @generated from field: string key = 1;
	 */
	key: string;

	/**
	 * label for the property for display purposes
	 *
	 * @generated from field: string label = 2;
	 */
	label: string;

	/**
	 * the type for the property
	 *
	 * @generated from field: abacus.v2.SchemaPropertyType type = 3;
	 */
	type: SchemaPropertyType;

	/**
	 * presence for the property within its schema
	 *
	 * @generated from field: abacus.v2.SchemaPropertyPresence presence = 9;
	 */
	presence: SchemaPropertyPresence;

	/**
	 * scope of the property's presence -- workspace or globally scoped
	 *
	 * @generated from field: abacus.v2.SchemaPropertyScope scope = 10;
	 */
	scope: SchemaPropertyScope;

	/**
	 * flag to denote if the property is an identifier
	 *
	 * @generated from field: bool is_identifier = 11;
	 */
	isIdentifier: boolean;

	/**
	 * flag to denote if the property is the primary identifier
	 *
	 * @generated from field: bool is_primary_identifier = 12;
	 */
	isPrimaryIdentifier: boolean;

	/**
	 * timestamp when the property was created
	 *
	 * @generated from field: google.protobuf.Timestamp created_at = 7;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * timestamp when the property was updated
	 *
	 * @generated from field: google.protobuf.Timestamp updated_at = 8;
	 */
	updatedAt?: Timestamp | undefined;
};

/**
 * @generated from message abacus.v2.SchemaProperty
 */
export type SchemaPropertyJson = {
	/**
	 * org id to which the properties belong, ignored on writes.
	 *
	 * @generated from field: string org_id = 5;
	 */
	orgId?: string;

	/**
	 * workspace id to which the properties belong, ignored on writes.
	 *
	 * @generated from field: string workspace_id = 6;
	 */
	workspaceId?: string;

	/**
	 * key identifier for the property, must be unique to the workspace.
	 *
	 * @generated from field: string key = 1;
	 */
	key?: string;

	/**
	 * label for the property for display purposes
	 *
	 * @generated from field: string label = 2;
	 */
	label?: string;

	/**
	 * the type for the property
	 *
	 * @generated from field: abacus.v2.SchemaPropertyType type = 3;
	 */
	type?: SchemaPropertyTypeJson;

	/**
	 * presence for the property within its schema
	 *
	 * @generated from field: abacus.v2.SchemaPropertyPresence presence = 9;
	 */
	presence?: SchemaPropertyPresenceJson;

	/**
	 * scope of the property's presence -- workspace or globally scoped
	 *
	 * @generated from field: abacus.v2.SchemaPropertyScope scope = 10;
	 */
	scope?: SchemaPropertyScopeJson;

	/**
	 * flag to denote if the property is an identifier
	 *
	 * @generated from field: bool is_identifier = 11;
	 */
	isIdentifier?: boolean;

	/**
	 * flag to denote if the property is the primary identifier
	 *
	 * @generated from field: bool is_primary_identifier = 12;
	 */
	isPrimaryIdentifier?: boolean;

	/**
	 * timestamp when the property was created
	 *
	 * @generated from field: google.protobuf.Timestamp created_at = 7;
	 */
	createdAt?: TimestampJson;

	/**
	 * timestamp when the property was updated
	 *
	 * @generated from field: google.protobuf.Timestamp updated_at = 8;
	 */
	updatedAt?: TimestampJson;
};

/**
 * Describes the message abacus.v2.SchemaProperty.
 * Use `create(SchemaPropertySchema)` to create a new message.
 */
export const SchemaPropertySchema: GenMessage<SchemaProperty, { jsonType: SchemaPropertyJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 133);

/**
 * @generated from message abacus.v2.SchemaPropertyRef
 */
export type SchemaPropertyRef = Message<"abacus.v2.SchemaPropertyRef"> & {
	/**
	 * @generated from field: string key = 1;
	 */
	key: string;

	/**
	 * @generated from field: abacus.v2.SchemaPropertyType type = 2;
	 */
	type: SchemaPropertyType;
};

/**
 * @generated from message abacus.v2.SchemaPropertyRef
 */
export type SchemaPropertyRefJson = {
	/**
	 * @generated from field: string key = 1;
	 */
	key?: string;

	/**
	 * @generated from field: abacus.v2.SchemaPropertyType type = 2;
	 */
	type?: SchemaPropertyTypeJson;
};

/**
 * Describes the message abacus.v2.SchemaPropertyRef.
 * Use `create(SchemaPropertyRefSchema)` to create a new message.
 */
export const SchemaPropertyRefSchema: GenMessage<SchemaPropertyRef, { jsonType: SchemaPropertyRefJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 134);

/**
 * Represents information about the submission to
 * the contact property including the value that was
 * submitted.
 *
 * @generated from message abacus.v2.ContactPropertySubmission
 */
export type ContactPropertySubmission = Message<"abacus.v2.ContactPropertySubmission"> & {
	/**
	 * the value submitted by the contact.
	 *
	 * @generated from field: google.protobuf.Value value = 1;
	 */
	value?: Value | undefined;
};

/**
 * Represents information about the submission to
 * the contact property including the value that was
 * submitted.
 *
 * @generated from message abacus.v2.ContactPropertySubmission
 */
export type ContactPropertySubmissionJson = {
	/**
	 * the value submitted by the contact.
	 *
	 * @generated from field: google.protobuf.Value value = 1;
	 */
	value?: ValueJson;
};

/**
 * Describes the message abacus.v2.ContactPropertySubmission.
 * Use `create(ContactPropertySubmissionSchema)` to create a new message.
 */
export const ContactPropertySubmissionSchema: GenMessage<ContactPropertySubmission, { jsonType: ContactPropertySubmissionJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 135);

/**
 * Represents schema and instance information
 * that a contact has submitted to a bound
 * contact schema field scoped to an org/workspace.
 *
 * @generated from message abacus.v2.ScopedContactProperty
 */
export type ScopedContactProperty = Message<"abacus.v2.ScopedContactProperty"> & {
	/**
	 * the property to which the value was submitted.
	 *
	 * @generated from field: abacus.v2.SchemaProperty schema_definition = 1;
	 */
	schemaDefinition?: SchemaProperty | undefined;

	/**
	 * information about the submission to this property including the value.
	 *
	 * @generated from field: abacus.v2.ContactPropertySubmission submission = 2;
	 */
	submission?: ContactPropertySubmission | undefined;
};

/**
 * Represents schema and instance information
 * that a contact has submitted to a bound
 * contact schema field scoped to an org/workspace.
 *
 * @generated from message abacus.v2.ScopedContactProperty
 */
export type ScopedContactPropertyJson = {
	/**
	 * the property to which the value was submitted.
	 *
	 * @generated from field: abacus.v2.SchemaProperty schema_definition = 1;
	 */
	schemaDefinition?: SchemaPropertyJson;

	/**
	 * information about the submission to this property including the value.
	 *
	 * @generated from field: abacus.v2.ContactPropertySubmission submission = 2;
	 */
	submission?: ContactPropertySubmissionJson;
};

/**
 * Describes the message abacus.v2.ScopedContactProperty.
 * Use `create(ScopedContactPropertySchema)` to create a new message.
 */
export const ScopedContactPropertySchema: GenMessage<ScopedContactProperty, { jsonType: ScopedContactPropertyJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 136);

/**
 * Represents a global contact property that is available to
 * all contacts
 *
 * @generated from message abacus.v2.GlobalContactProperty
 */
export type GlobalContactProperty = Message<"abacus.v2.GlobalContactProperty"> & {
	/**
	 * the key associated with the global contact property
	 *
	 * @generated from field: string key = 3;
	 */
	key: string;

	/**
	 * the type of the global property.
	 *
	 * @generated from field: abacus.v2.SchemaPropertyType type = 1;
	 */
	type: SchemaPropertyType;

	/**
	 * information about the submission to this property including the value.
	 *
	 * @generated from field: abacus.v2.ContactPropertySubmission submission = 2;
	 */
	submission?: ContactPropertySubmission | undefined;
};

/**
 * Represents a global contact property that is available to
 * all contacts
 *
 * @generated from message abacus.v2.GlobalContactProperty
 */
export type GlobalContactPropertyJson = {
	/**
	 * the key associated with the global contact property
	 *
	 * @generated from field: string key = 3;
	 */
	key?: string;

	/**
	 * the type of the global property.
	 *
	 * @generated from field: abacus.v2.SchemaPropertyType type = 1;
	 */
	type?: SchemaPropertyTypeJson;

	/**
	 * information about the submission to this property including the value.
	 *
	 * @generated from field: abacus.v2.ContactPropertySubmission submission = 2;
	 */
	submission?: ContactPropertySubmissionJson;
};

/**
 * Describes the message abacus.v2.GlobalContactProperty.
 * Use `create(GlobalContactPropertySchema)` to create a new message.
 */
export const GlobalContactPropertySchema: GenMessage<GlobalContactProperty, { jsonType: GlobalContactPropertyJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 137);

/**
 * @generated from message abacus.v2.ContactProperties
 */
export type ContactProperties = Message<"abacus.v2.ContactProperties"> & {
	/**
	 * org id associated with the contact properties.
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * workspace id associated with the contact properties.
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * global email property.
	 *
	 * @generated from field: abacus.v2.GlobalContactProperty email = 3;
	 */
	email?: GlobalContactProperty | undefined;

	/**
	 * global name property.
	 *
	 * @generated from field: abacus.v2.GlobalContactProperty name = 4;
	 */
	name?: GlobalContactProperty | undefined;

	/**
	 * global phone property.
	 *
	 * @generated from field: abacus.v2.GlobalContactProperty phone = 5;
	 */
	phone?: GlobalContactProperty | undefined;

	/**
	 * most recently submitted set of values that the contact
	 * submitted to the specified schema property scoped to the org/workspace.
	 *
	 * @generated from field: repeated abacus.v2.ScopedContactProperty scoped = 6;
	 */
	scoped: ScopedContactProperty[];
};

/**
 * @generated from message abacus.v2.ContactProperties
 */
export type ContactPropertiesJson = {
	/**
	 * org id associated with the contact properties.
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * workspace id associated with the contact properties.
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * global email property.
	 *
	 * @generated from field: abacus.v2.GlobalContactProperty email = 3;
	 */
	email?: GlobalContactPropertyJson;

	/**
	 * global name property.
	 *
	 * @generated from field: abacus.v2.GlobalContactProperty name = 4;
	 */
	name?: GlobalContactPropertyJson;

	/**
	 * global phone property.
	 *
	 * @generated from field: abacus.v2.GlobalContactProperty phone = 5;
	 */
	phone?: GlobalContactPropertyJson;

	/**
	 * most recently submitted set of values that the contact
	 * submitted to the specified schema property scoped to the org/workspace.
	 *
	 * @generated from field: repeated abacus.v2.ScopedContactProperty scoped = 6;
	 */
	scoped?: ScopedContactPropertyJson[];
};

/**
 * Describes the message abacus.v2.ContactProperties.
 * Use `create(ContactPropertiesSchema)` to create a new message.
 */
export const ContactPropertiesSchema: GenMessage<ContactProperties, { jsonType: ContactPropertiesJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 138);

/**
 * GetContactFromSessionRequest request to retrieve a contact
 * for a given org, workspace, and session
 *
 * @generated from message abacus.v2.GetContactPropertiesFromSessionRequest
 */
export type GetContactPropertiesFromSessionRequest = Message<"abacus.v2.GetContactPropertiesFromSessionRequest"> & {
	/**
	 * org id to which the contact is linked.
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * workspace id to which the contact is linked.
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * cookie from consumer session.
	 *
	 * @generated from field: string cookie = 3;
	 */
	cookie: string;

	/**
	 * user to be associated with the cookie.
	 *
	 * @generated from field: bundles.v1.User user = 4;
	 */
	user?: User | undefined;
};

/**
 * GetContactFromSessionRequest request to retrieve a contact
 * for a given org, workspace, and session
 *
 * @generated from message abacus.v2.GetContactPropertiesFromSessionRequest
 */
export type GetContactPropertiesFromSessionRequestJson = {
	/**
	 * org id to which the contact is linked.
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * workspace id to which the contact is linked.
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * cookie from consumer session.
	 *
	 * @generated from field: string cookie = 3;
	 */
	cookie?: string;

	/**
	 * user to be associated with the cookie.
	 *
	 * @generated from field: bundles.v1.User user = 4;
	 */
	user?: UserJson;
};

/**
 * Describes the message abacus.v2.GetContactPropertiesFromSessionRequest.
 * Use `create(GetContactPropertiesFromSessionRequestSchema)` to create a new message.
 */
export const GetContactPropertiesFromSessionRequestSchema: GenMessage<GetContactPropertiesFromSessionRequest, { jsonType: GetContactPropertiesFromSessionRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 139);

/**
 * GetContactPropertiesFromSessionResponse contains the
 * properties associated with the given contact input.
 *
 * @generated from message abacus.v2.GetContactPropertiesFromSessionResponse
 */
export type GetContactPropertiesFromSessionResponse = Message<"abacus.v2.GetContactPropertiesFromSessionResponse"> & {
	/**
	 * global and scoped properties associated with the contact.
	 *
	 * @generated from field: abacus.v2.ContactProperties properties = 1;
	 */
	properties?: ContactProperties | undefined;
};

/**
 * GetContactPropertiesFromSessionResponse contains the
 * properties associated with the given contact input.
 *
 * @generated from message abacus.v2.GetContactPropertiesFromSessionResponse
 */
export type GetContactPropertiesFromSessionResponseJson = {
	/**
	 * global and scoped properties associated with the contact.
	 *
	 * @generated from field: abacus.v2.ContactProperties properties = 1;
	 */
	properties?: ContactPropertiesJson;
};

/**
 * Describes the message abacus.v2.GetContactPropertiesFromSessionResponse.
 * Use `create(GetContactPropertiesFromSessionResponseSchema)` to create a new message.
 */
export const GetContactPropertiesFromSessionResponseSchema: GenMessage<GetContactPropertiesFromSessionResponse, { jsonType: GetContactPropertiesFromSessionResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 140);

/**
 * @generated from message abacus.v2.GetContactPropertiesFromSessionsRequest
 */
export type GetContactPropertiesFromSessionsRequest = Message<"abacus.v2.GetContactPropertiesFromSessionsRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: bool include_shared_workspaces = 4;
	 */
	includeSharedWorkspaces: boolean;

	/**
	 * @generated from field: repeated string cookies = 3;
	 */
	cookies: string[];
};

/**
 * @generated from message abacus.v2.GetContactPropertiesFromSessionsRequest
 */
export type GetContactPropertiesFromSessionsRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: bool include_shared_workspaces = 4;
	 */
	includeSharedWorkspaces?: boolean;

	/**
	 * @generated from field: repeated string cookies = 3;
	 */
	cookies?: string[];
};

/**
 * Describes the message abacus.v2.GetContactPropertiesFromSessionsRequest.
 * Use `create(GetContactPropertiesFromSessionsRequestSchema)` to create a new message.
 */
export const GetContactPropertiesFromSessionsRequestSchema: GenMessage<GetContactPropertiesFromSessionsRequest, { jsonType: GetContactPropertiesFromSessionsRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 141);

/**
 * @generated from message abacus.v2.GetContactPropertiesFromSessionsResponse
 */
export type GetContactPropertiesFromSessionsResponse = Message<"abacus.v2.GetContactPropertiesFromSessionsResponse"> & {
	/**
	 * @generated from field: map<string, abacus.v2.ContactProperties> properties = 1;
	 */
	properties: { [key: string]: ContactProperties };

	/**
	 * @generated from field: map<string, bundles.v1.User> users = 2;
	 */
	users: { [key: string]: User };
};

/**
 * @generated from message abacus.v2.GetContactPropertiesFromSessionsResponse
 */
export type GetContactPropertiesFromSessionsResponseJson = {
	/**
	 * @generated from field: map<string, abacus.v2.ContactProperties> properties = 1;
	 */
	properties?: { [key: string]: ContactPropertiesJson };

	/**
	 * @generated from field: map<string, bundles.v1.User> users = 2;
	 */
	users?: { [key: string]: UserJson };
};

/**
 * Describes the message abacus.v2.GetContactPropertiesFromSessionsResponse.
 * Use `create(GetContactPropertiesFromSessionsResponseSchema)` to create a new message.
 */
export const GetContactPropertiesFromSessionsResponseSchema: GenMessage<GetContactPropertiesFromSessionsResponse, { jsonType: GetContactPropertiesFromSessionsResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 142);

/**
 * A collection of property definitions that describe a contact model
 *
 * @generated from message abacus.v2.ContactSchema
 */
export type ContactSchema = Message<"abacus.v2.ContactSchema"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: repeated abacus.v2.SchemaProperty properties = 3;
	 */
	properties: SchemaProperty[];
};

/**
 * A collection of property definitions that describe a contact model
 *
 * @generated from message abacus.v2.ContactSchema
 */
export type ContactSchemaJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: repeated abacus.v2.SchemaProperty properties = 3;
	 */
	properties?: SchemaPropertyJson[];
};

/**
 * Describes the message abacus.v2.ContactSchema.
 * Use `create(ContactSchemaSchema)` to create a new message.
 */
export const ContactSchemaSchema: GenMessage<ContactSchema, { jsonType: ContactSchemaJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 143);

/**
 * @generated from message abacus.v2.CreateContactSchemaRequest
 */
export type CreateContactSchemaRequest = Message<"abacus.v2.CreateContactSchemaRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: repeated abacus.v2.SchemaProperty properties = 3;
	 */
	properties: SchemaProperty[];
};

/**
 * @generated from message abacus.v2.CreateContactSchemaRequest
 */
export type CreateContactSchemaRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: repeated abacus.v2.SchemaProperty properties = 3;
	 */
	properties?: SchemaPropertyJson[];
};

/**
 * Describes the message abacus.v2.CreateContactSchemaRequest.
 * Use `create(CreateContactSchemaRequestSchema)` to create a new message.
 */
export const CreateContactSchemaRequestSchema: GenMessage<CreateContactSchemaRequest, { jsonType: CreateContactSchemaRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 144);

/**
 * @generated from message abacus.v2.CreateContactSchemaResponse
 */
export type CreateContactSchemaResponse = Message<"abacus.v2.CreateContactSchemaResponse"> & {
	/**
	 * @generated from field: abacus.v2.ContactSchema schema = 1;
	 */
	schema?: ContactSchema | undefined;
};

/**
 * @generated from message abacus.v2.CreateContactSchemaResponse
 */
export type CreateContactSchemaResponseJson = {
	/**
	 * @generated from field: abacus.v2.ContactSchema schema = 1;
	 */
	schema?: ContactSchemaJson;
};

/**
 * Describes the message abacus.v2.CreateContactSchemaResponse.
 * Use `create(CreateContactSchemaResponseSchema)` to create a new message.
 */
export const CreateContactSchemaResponseSchema: GenMessage<CreateContactSchemaResponse, { jsonType: CreateContactSchemaResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 145);

/**
 * Filters for contact schema properties
 *
 * @generated from message abacus.v2.ContactSchemaPropertyFilter
 */
export type ContactSchemaPropertyFilter = Message<"abacus.v2.ContactSchemaPropertyFilter"> & {
	/**
	 * optional match key prefix
	 *
	 * @generated from field: optional string key_prefix = 1;
	 */
	keyPrefix?: string | undefined;

	/**
	 * optional match for label prefix
	 *
	 * @generated from field: optional string label_prefix = 2;
	 */
	labelPrefix?: string | undefined;

	/**
	 * optional exact match for property type
	 *
	 * @generated from field: optional abacus.v2.SchemaPropertyType type = 3;
	 */
	type?: SchemaPropertyType | undefined;

	/**
	 * optional match identifiers
	 *
	 * @generated from field: optional bool is_identifier = 4;
	 */
	isIdentifier?: boolean | undefined;

	/**
	 * optional match primary identifier
	 *
	 * @generated from field: optional bool is_primary_identifier = 5;
	 */
	isPrimaryIdentifier?: boolean | undefined;

	/**
	 * optional multi type filter for properties
	 *
	 * @generated from field: repeated abacus.v2.SchemaPropertyType types = 6;
	 */
	types: SchemaPropertyType[];

	/**
	 * optional property ref filter
	 *
	 * @generated from field: repeated abacus.v2.SchemaPropertyRef property_refs = 7;
	 */
	propertyRefs: SchemaPropertyRef[];
};

/**
 * Filters for contact schema properties
 *
 * @generated from message abacus.v2.ContactSchemaPropertyFilter
 */
export type ContactSchemaPropertyFilterJson = {
	/**
	 * optional match key prefix
	 *
	 * @generated from field: optional string key_prefix = 1;
	 */
	keyPrefix?: string;

	/**
	 * optional match for label prefix
	 *
	 * @generated from field: optional string label_prefix = 2;
	 */
	labelPrefix?: string;

	/**
	 * optional exact match for property type
	 *
	 * @generated from field: optional abacus.v2.SchemaPropertyType type = 3;
	 */
	type?: SchemaPropertyTypeJson;

	/**
	 * optional match identifiers
	 *
	 * @generated from field: optional bool is_identifier = 4;
	 */
	isIdentifier?: boolean;

	/**
	 * optional match primary identifier
	 *
	 * @generated from field: optional bool is_primary_identifier = 5;
	 */
	isPrimaryIdentifier?: boolean;

	/**
	 * optional multi type filter for properties
	 *
	 * @generated from field: repeated abacus.v2.SchemaPropertyType types = 6;
	 */
	types?: SchemaPropertyTypeJson[];

	/**
	 * optional property ref filter
	 *
	 * @generated from field: repeated abacus.v2.SchemaPropertyRef property_refs = 7;
	 */
	propertyRefs?: SchemaPropertyRefJson[];
};

/**
 * Describes the message abacus.v2.ContactSchemaPropertyFilter.
 * Use `create(ContactSchemaPropertyFilterSchema)` to create a new message.
 */
export const ContactSchemaPropertyFilterSchema: GenMessage<ContactSchemaPropertyFilter, { jsonType: ContactSchemaPropertyFilterJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 146);

/**
 * @generated from message abacus.v2.GetContactSchemaRequest
 */
export type GetContactSchemaRequest = Message<"abacus.v2.GetContactSchemaRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: bool include_shared_workspaces = 5;
	 */
	includeSharedWorkspaces: boolean;

	/**
	 * @generated from field: optional abacus.v2.ContactSchemaPropertyFilter filter = 3;
	 */
	filter?: ContactSchemaPropertyFilter | undefined;

	/**
	 * @generated from field: optional common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArguments | undefined;
};

/**
 * @generated from message abacus.v2.GetContactSchemaRequest
 */
export type GetContactSchemaRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: bool include_shared_workspaces = 5;
	 */
	includeSharedWorkspaces?: boolean;

	/**
	 * @generated from field: optional abacus.v2.ContactSchemaPropertyFilter filter = 3;
	 */
	filter?: ContactSchemaPropertyFilterJson;

	/**
	 * @generated from field: optional common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message abacus.v2.GetContactSchemaRequest.
 * Use `create(GetContactSchemaRequestSchema)` to create a new message.
 */
export const GetContactSchemaRequestSchema: GenMessage<GetContactSchemaRequest, { jsonType: GetContactSchemaRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 147);

/**
 * @generated from message abacus.v2.GetContactSchemaResponse
 */
export type GetContactSchemaResponse = Message<"abacus.v2.GetContactSchemaResponse"> & {
	/**
	 * @generated from field: abacus.v2.ContactSchema schema = 1;
	 */
	schema?: ContactSchema | undefined;

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message abacus.v2.GetContactSchemaResponse
 */
export type GetContactSchemaResponseJson = {
	/**
	 * @generated from field: abacus.v2.ContactSchema schema = 1;
	 */
	schema?: ContactSchemaJson;

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message abacus.v2.GetContactSchemaResponse.
 * Use `create(GetContactSchemaResponseSchema)` to create a new message.
 */
export const GetContactSchemaResponseSchema: GenMessage<GetContactSchemaResponse, { jsonType: GetContactSchemaResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 148);

/**
 * @generated from message abacus.v2.UpdateContactSchemaRequest
 */
export type UpdateContactSchemaRequest = Message<"abacus.v2.UpdateContactSchemaRequest"> & {
	/**
	 * @generated from field: abacus.v2.ContactSchema schema = 1;
	 */
	schema?: ContactSchema | undefined;

	/**
	 * @generated from field: repeated string recipients = 2;
	 */
	recipients: string[];
};

/**
 * @generated from message abacus.v2.UpdateContactSchemaRequest
 */
export type UpdateContactSchemaRequestJson = {
	/**
	 * @generated from field: abacus.v2.ContactSchema schema = 1;
	 */
	schema?: ContactSchemaJson;

	/**
	 * @generated from field: repeated string recipients = 2;
	 */
	recipients?: string[];
};

/**
 * Describes the message abacus.v2.UpdateContactSchemaRequest.
 * Use `create(UpdateContactSchemaRequestSchema)` to create a new message.
 */
export const UpdateContactSchemaRequestSchema: GenMessage<UpdateContactSchemaRequest, { jsonType: UpdateContactSchemaRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 149);

/**
 * @generated from message abacus.v2.UpdateContactSchemaResponse
 */
export type UpdateContactSchemaResponse = Message<"abacus.v2.UpdateContactSchemaResponse"> & {
	/**
	 * @generated from field: abacus.v2.ContactSchema schema = 1;
	 */
	schema?: ContactSchema | undefined;
};

/**
 * @generated from message abacus.v2.UpdateContactSchemaResponse
 */
export type UpdateContactSchemaResponseJson = {
	/**
	 * @generated from field: abacus.v2.ContactSchema schema = 1;
	 */
	schema?: ContactSchemaJson;
};

/**
 * Describes the message abacus.v2.UpdateContactSchemaResponse.
 * Use `create(UpdateContactSchemaResponseSchema)` to create a new message.
 */
export const UpdateContactSchemaResponseSchema: GenMessage<UpdateContactSchemaResponse, { jsonType: UpdateContactSchemaResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 150);

/**
 * @generated from message abacus.v2.GetPrimaryIdentifierCountsRequest
 */
export type GetPrimaryIdentifierCountsRequest = Message<"abacus.v2.GetPrimaryIdentifierCountsRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: repeated abacus.v2.SchemaProperty properties = 3;
	 */
	properties: SchemaProperty[];
};

/**
 * @generated from message abacus.v2.GetPrimaryIdentifierCountsRequest
 */
export type GetPrimaryIdentifierCountsRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: repeated abacus.v2.SchemaProperty properties = 3;
	 */
	properties?: SchemaPropertyJson[];
};

/**
 * Describes the message abacus.v2.GetPrimaryIdentifierCountsRequest.
 * Use `create(GetPrimaryIdentifierCountsRequestSchema)` to create a new message.
 */
export const GetPrimaryIdentifierCountsRequestSchema: GenMessage<GetPrimaryIdentifierCountsRequest, { jsonType: GetPrimaryIdentifierCountsRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 151);

/**
 * @generated from message abacus.v2.GetPrimaryIdentifierCountsResponse
 */
export type GetPrimaryIdentifierCountsResponse = Message<"abacus.v2.GetPrimaryIdentifierCountsResponse"> & {
	/**
	 * @generated from field: map<string, int64> counts = 1;
	 */
	counts: { [key: string]: bigint };
};

/**
 * @generated from message abacus.v2.GetPrimaryIdentifierCountsResponse
 */
export type GetPrimaryIdentifierCountsResponseJson = {
	/**
	 * @generated from field: map<string, int64> counts = 1;
	 */
	counts?: { [key: string]: string };
};

/**
 * Describes the message abacus.v2.GetPrimaryIdentifierCountsResponse.
 * Use `create(GetPrimaryIdentifierCountsResponseSchema)` to create a new message.
 */
export const GetPrimaryIdentifierCountsResponseSchema: GenMessage<GetPrimaryIdentifierCountsResponse, { jsonType: GetPrimaryIdentifierCountsResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 152);

/**
 * @generated from message abacus.v2.CreateContactRequest
 */
export type CreateContactRequest = Message<"abacus.v2.CreateContactRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string origin_id = 3;
	 */
	originId: string;

	/**
	 * @generated from field: string origin_name = 4;
	 */
	originName: string;

	/**
	 * @generated from field: google.protobuf.Struct properties = 5;
	 */
	properties?: JsonObject | undefined;

	/**
	 * @generated from field: string audience_id = 6;
	 */
	audienceId: string;
};

/**
 * @generated from message abacus.v2.CreateContactRequest
 */
export type CreateContactRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string origin_id = 3;
	 */
	originId?: string;

	/**
	 * @generated from field: string origin_name = 4;
	 */
	originName?: string;

	/**
	 * @generated from field: google.protobuf.Struct properties = 5;
	 */
	properties?: StructJson;

	/**
	 * @generated from field: string audience_id = 6;
	 */
	audienceId?: string;
};

/**
 * Describes the message abacus.v2.CreateContactRequest.
 * Use `create(CreateContactRequestSchema)` to create a new message.
 */
export const CreateContactRequestSchema: GenMessage<CreateContactRequest, { jsonType: CreateContactRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 153);

/**
 * @generated from message abacus.v2.CreateContactResponse
 */
export type CreateContactResponse = Message<"abacus.v2.CreateContactResponse"> & {};

/**
 * @generated from message abacus.v2.CreateContactResponse
 */
export type CreateContactResponseJson = {};

/**
 * Describes the message abacus.v2.CreateContactResponse.
 * Use `create(CreateContactResponseSchema)` to create a new message.
 */
export const CreateContactResponseSchema: GenMessage<CreateContactResponse, { jsonType: CreateContactResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 154);

/**
 * @generated from message abacus.v2.BulkImportContactsRequest
 */
export type BulkImportContactsRequest = Message<"abacus.v2.BulkImportContactsRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string file_url = 3;
	 */
	fileUrl: string;

	/**
	 * @generated from field: map<string, workflows.v1.MappedValue> mapping = 4;
	 */
	mapping: { [key: string]: MappedValue };

	/**
	 * @generated from field: bool has_header = 5;
	 */
	hasHeader: boolean;

	/**
	 * @generated from field: repeated string header = 6;
	 */
	header: string[];

	/**
	 * @generated from field: bool create_audience = 7;
	 */
	createAudience: boolean;

	/**
	 * @generated from field: string audience_name = 8;
	 */
	audienceName: string;
};

/**
 * @generated from message abacus.v2.BulkImportContactsRequest
 */
export type BulkImportContactsRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string file_url = 3;
	 */
	fileUrl?: string;

	/**
	 * @generated from field: map<string, workflows.v1.MappedValue> mapping = 4;
	 */
	mapping?: { [key: string]: MappedValueJson };

	/**
	 * @generated from field: bool has_header = 5;
	 */
	hasHeader?: boolean;

	/**
	 * @generated from field: repeated string header = 6;
	 */
	header?: string[];

	/**
	 * @generated from field: bool create_audience = 7;
	 */
	createAudience?: boolean;

	/**
	 * @generated from field: string audience_name = 8;
	 */
	audienceName?: string;
};

/**
 * Describes the message abacus.v2.BulkImportContactsRequest.
 * Use `create(BulkImportContactsRequestSchema)` to create a new message.
 */
export const BulkImportContactsRequestSchema: GenMessage<BulkImportContactsRequest, { jsonType: BulkImportContactsRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 155);

/**
 * @generated from message abacus.v2.BulkImportContactsResponse
 */
export type BulkImportContactsResponse = Message<"abacus.v2.BulkImportContactsResponse"> & {};

/**
 * @generated from message abacus.v2.BulkImportContactsResponse
 */
export type BulkImportContactsResponseJson = {};

/**
 * Describes the message abacus.v2.BulkImportContactsResponse.
 * Use `create(BulkImportContactsResponseSchema)` to create a new message.
 */
export const BulkImportContactsResponseSchema: GenMessage<BulkImportContactsResponse, { jsonType: BulkImportContactsResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 156);

/**
 * @generated from message abacus.v2.VerifyContactsRequest
 */
export type VerifyContactsRequest = Message<"abacus.v2.VerifyContactsRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: repeated abacus.v2.Contact contacts = 3;
	 */
	contacts: Contact[];

	/**
	 * @generated from field: abacus.v2.ListContactsRequest list_contacts_request = 4;
	 */
	listContactsRequest?: ListContactsRequest | undefined;
};

/**
 * @generated from message abacus.v2.VerifyContactsRequest
 */
export type VerifyContactsRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: repeated abacus.v2.Contact contacts = 3;
	 */
	contacts?: ContactJson[];

	/**
	 * @generated from field: abacus.v2.ListContactsRequest list_contacts_request = 4;
	 */
	listContactsRequest?: ListContactsRequestJson;
};

/**
 * Describes the message abacus.v2.VerifyContactsRequest.
 * Use `create(VerifyContactsRequestSchema)` to create a new message.
 */
export const VerifyContactsRequestSchema: GenMessage<VerifyContactsRequest, { jsonType: VerifyContactsRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 157);

/**
 * @generated from message abacus.v2.VerifyContactsResponse
 */
export type VerifyContactsResponse = Message<"abacus.v2.VerifyContactsResponse"> & {};

/**
 * @generated from message abacus.v2.VerifyContactsResponse
 */
export type VerifyContactsResponseJson = {};

/**
 * Describes the message abacus.v2.VerifyContactsResponse.
 * Use `create(VerifyContactsResponseSchema)` to create a new message.
 */
export const VerifyContactsResponseSchema: GenMessage<VerifyContactsResponse, { jsonType: VerifyContactsResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 158);

/**
 * @generated from message abacus.v2.HideContactsRequest
 */
export type HideContactsRequest = Message<"abacus.v2.HideContactsRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: repeated abacus.v2.Contact contacts = 3;
	 */
	contacts: Contact[];

	/**
	 * @generated from field: abacus.v2.ListContactsRequest list_contacts_request = 4;
	 */
	listContactsRequest?: ListContactsRequest | undefined;
};

/**
 * @generated from message abacus.v2.HideContactsRequest
 */
export type HideContactsRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: repeated abacus.v2.Contact contacts = 3;
	 */
	contacts?: ContactJson[];

	/**
	 * @generated from field: abacus.v2.ListContactsRequest list_contacts_request = 4;
	 */
	listContactsRequest?: ListContactsRequestJson;
};

/**
 * Describes the message abacus.v2.HideContactsRequest.
 * Use `create(HideContactsRequestSchema)` to create a new message.
 */
export const HideContactsRequestSchema: GenMessage<HideContactsRequest, { jsonType: HideContactsRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 159);

/**
 * @generated from message abacus.v2.HideContactsResponse
 */
export type HideContactsResponse = Message<"abacus.v2.HideContactsResponse"> & {};

/**
 * @generated from message abacus.v2.HideContactsResponse
 */
export type HideContactsResponseJson = {};

/**
 * Describes the message abacus.v2.HideContactsResponse.
 * Use `create(HideContactsResponseSchema)` to create a new message.
 */
export const HideContactsResponseSchema: GenMessage<HideContactsResponse, { jsonType: HideContactsResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 160);

/**
 * @generated from message abacus.v2.AudienceMember
 */
export type AudienceMember = Message<"abacus.v2.AudienceMember"> & {
	/**
	 * @generated from field: string audience_id = 6;
	 */
	audienceId: string;

	/**
	 * @generated from field: string run_id = 7;
	 */
	runId: string;

	/**
	 * @generated from field: string flow_id = 3;
	 */
	flowId: string;

	/**
	 * @generated from field: string primary_key = 4;
	 */
	primaryKey: string;

	/**
	 * @generated from field: string member_id = 1;
	 */
	memberId: string;

	/**
	 * @generated from field: abacus.v2.AudienceType member_type = 2;
	 */
	memberType: AudienceType;

	/**
	 * @generated from field: bool is_static = 5;
	 */
	isStatic: boolean;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 8;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 9;
	 */
	updatedAt?: Timestamp | undefined;
};

/**
 * @generated from message abacus.v2.AudienceMember
 */
export type AudienceMemberJson = {
	/**
	 * @generated from field: string audience_id = 6;
	 */
	audienceId?: string;

	/**
	 * @generated from field: string run_id = 7;
	 */
	runId?: string;

	/**
	 * @generated from field: string flow_id = 3;
	 */
	flowId?: string;

	/**
	 * @generated from field: string primary_key = 4;
	 */
	primaryKey?: string;

	/**
	 * @generated from field: string member_id = 1;
	 */
	memberId?: string;

	/**
	 * @generated from field: abacus.v2.AudienceType member_type = 2;
	 */
	memberType?: AudienceTypeJson;

	/**
	 * @generated from field: bool is_static = 5;
	 */
	isStatic?: boolean;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 8;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 9;
	 */
	updatedAt?: TimestampJson;
};

/**
 * Describes the message abacus.v2.AudienceMember.
 * Use `create(AudienceMemberSchema)` to create a new message.
 */
export const AudienceMemberSchema: GenMessage<AudienceMember, { jsonType: AudienceMemberJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 161);

/**
 * @generated from message abacus.v2.CreateAudienceRequest
 */
export type CreateAudienceRequest = Message<"abacus.v2.CreateAudienceRequest"> & {
	/**
	 * @generated from field: abacus.v2.Audience audience = 1;
	 */
	audience?: Audience | undefined;
};

/**
 * @generated from message abacus.v2.CreateAudienceRequest
 */
export type CreateAudienceRequestJson = {
	/**
	 * @generated from field: abacus.v2.Audience audience = 1;
	 */
	audience?: AudienceJson;
};

/**
 * Describes the message abacus.v2.CreateAudienceRequest.
 * Use `create(CreateAudienceRequestSchema)` to create a new message.
 */
export const CreateAudienceRequestSchema: GenMessage<CreateAudienceRequest, { jsonType: CreateAudienceRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 162);

/**
 * @generated from message abacus.v2.CreateAudienceResponse
 */
export type CreateAudienceResponse = Message<"abacus.v2.CreateAudienceResponse"> & {
	/**
	 * @generated from field: abacus.v2.Audience audience = 1;
	 */
	audience?: Audience | undefined;
};

/**
 * @generated from message abacus.v2.CreateAudienceResponse
 */
export type CreateAudienceResponseJson = {
	/**
	 * @generated from field: abacus.v2.Audience audience = 1;
	 */
	audience?: AudienceJson;
};

/**
 * Describes the message abacus.v2.CreateAudienceResponse.
 * Use `create(CreateAudienceResponseSchema)` to create a new message.
 */
export const CreateAudienceResponseSchema: GenMessage<CreateAudienceResponse, { jsonType: CreateAudienceResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 163);

/**
 * @generated from message abacus.v2.DuplicateAudienceRequest
 */
export type DuplicateAudienceRequest = Message<"abacus.v2.DuplicateAudienceRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message abacus.v2.DuplicateAudienceRequest
 */
export type DuplicateAudienceRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message abacus.v2.DuplicateAudienceRequest.
 * Use `create(DuplicateAudienceRequestSchema)` to create a new message.
 */
export const DuplicateAudienceRequestSchema: GenMessage<DuplicateAudienceRequest, { jsonType: DuplicateAudienceRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 164);

/**
 * @generated from message abacus.v2.DuplicateAudienceResponse
 */
export type DuplicateAudienceResponse = Message<"abacus.v2.DuplicateAudienceResponse"> & {
	/**
	 * @generated from field: abacus.v2.Audience audience = 1;
	 */
	audience?: Audience | undefined;
};

/**
 * @generated from message abacus.v2.DuplicateAudienceResponse
 */
export type DuplicateAudienceResponseJson = {
	/**
	 * @generated from field: abacus.v2.Audience audience = 1;
	 */
	audience?: AudienceJson;
};

/**
 * Describes the message abacus.v2.DuplicateAudienceResponse.
 * Use `create(DuplicateAudienceResponseSchema)` to create a new message.
 */
export const DuplicateAudienceResponseSchema: GenMessage<DuplicateAudienceResponse, { jsonType: DuplicateAudienceResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 165);

/**
 * @generated from message abacus.v2.GetAudienceRequest
 */
export type GetAudienceRequest = Message<"abacus.v2.GetAudienceRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message abacus.v2.GetAudienceRequest
 */
export type GetAudienceRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message abacus.v2.GetAudienceRequest.
 * Use `create(GetAudienceRequestSchema)` to create a new message.
 */
export const GetAudienceRequestSchema: GenMessage<GetAudienceRequest, { jsonType: GetAudienceRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 166);

/**
 * @generated from message abacus.v2.GetAudienceResponse
 */
export type GetAudienceResponse = Message<"abacus.v2.GetAudienceResponse"> & {
	/**
	 * @generated from field: abacus.v2.Audience audience = 1;
	 */
	audience?: Audience | undefined;
};

/**
 * @generated from message abacus.v2.GetAudienceResponse
 */
export type GetAudienceResponseJson = {
	/**
	 * @generated from field: abacus.v2.Audience audience = 1;
	 */
	audience?: AudienceJson;
};

/**
 * Describes the message abacus.v2.GetAudienceResponse.
 * Use `create(GetAudienceResponseSchema)` to create a new message.
 */
export const GetAudienceResponseSchema: GenMessage<GetAudienceResponse, { jsonType: GetAudienceResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 167);

/**
 * @generated from message abacus.v2.ListAudiencesRequest
 */
export type ListAudiencesRequest = Message<"abacus.v2.ListAudiencesRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string name = 3;
	 */
	name: string;

	/**
	 * @generated from field: string user_id = 4;
	 */
	userId: string;

	/**
	 * @generated from field: string creator_email = 5;
	 */
	creatorEmail: string;

	/**
	 * @generated from field: abacus.v2.AudienceType type = 7;
	 */
	type: AudienceType;

	/**
	 * @generated from field: optional common.v1.PaginationArguments pagination = 6;
	 */
	pagination?: PaginationArguments | undefined;
};

/**
 * @generated from message abacus.v2.ListAudiencesRequest
 */
export type ListAudiencesRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string name = 3;
	 */
	name?: string;

	/**
	 * @generated from field: string user_id = 4;
	 */
	userId?: string;

	/**
	 * @generated from field: string creator_email = 5;
	 */
	creatorEmail?: string;

	/**
	 * @generated from field: abacus.v2.AudienceType type = 7;
	 */
	type?: AudienceTypeJson;

	/**
	 * @generated from field: optional common.v1.PaginationArguments pagination = 6;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message abacus.v2.ListAudiencesRequest.
 * Use `create(ListAudiencesRequestSchema)` to create a new message.
 */
export const ListAudiencesRequestSchema: GenMessage<ListAudiencesRequest, { jsonType: ListAudiencesRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 168);

/**
 * @generated from message abacus.v2.ListAudiencesResponse
 */
export type ListAudiencesResponse = Message<"abacus.v2.ListAudiencesResponse"> & {
	/**
	 * @generated from field: repeated abacus.v2.Audience audiences = 1;
	 */
	audiences: Audience[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message abacus.v2.ListAudiencesResponse
 */
export type ListAudiencesResponseJson = {
	/**
	 * @generated from field: repeated abacus.v2.Audience audiences = 1;
	 */
	audiences?: AudienceJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message abacus.v2.ListAudiencesResponse.
 * Use `create(ListAudiencesResponseSchema)` to create a new message.
 */
export const ListAudiencesResponseSchema: GenMessage<ListAudiencesResponse, { jsonType: ListAudiencesResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 169);

/**
 * @generated from message abacus.v2.UpdateAudienceRequest
 */
export type UpdateAudienceRequest = Message<"abacus.v2.UpdateAudienceRequest"> & {
	/**
	 * @generated from field: abacus.v2.Audience audience = 1;
	 */
	audience?: Audience | undefined;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMask | undefined;
};

/**
 * @generated from message abacus.v2.UpdateAudienceRequest
 */
export type UpdateAudienceRequestJson = {
	/**
	 * @generated from field: abacus.v2.Audience audience = 1;
	 */
	audience?: AudienceJson;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMaskJson;
};

/**
 * Describes the message abacus.v2.UpdateAudienceRequest.
 * Use `create(UpdateAudienceRequestSchema)` to create a new message.
 */
export const UpdateAudienceRequestSchema: GenMessage<UpdateAudienceRequest, { jsonType: UpdateAudienceRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 170);

/**
 * @generated from message abacus.v2.UpdateAudienceResponse
 */
export type UpdateAudienceResponse = Message<"abacus.v2.UpdateAudienceResponse"> & {
	/**
	 * @generated from field: abacus.v2.Audience audience = 1;
	 */
	audience?: Audience | undefined;
};

/**
 * @generated from message abacus.v2.UpdateAudienceResponse
 */
export type UpdateAudienceResponseJson = {
	/**
	 * @generated from field: abacus.v2.Audience audience = 1;
	 */
	audience?: AudienceJson;
};

/**
 * Describes the message abacus.v2.UpdateAudienceResponse.
 * Use `create(UpdateAudienceResponseSchema)` to create a new message.
 */
export const UpdateAudienceResponseSchema: GenMessage<UpdateAudienceResponse, { jsonType: UpdateAudienceResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 171);

/**
 * @generated from message abacus.v2.DeleteAudienceRequest
 */
export type DeleteAudienceRequest = Message<"abacus.v2.DeleteAudienceRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message abacus.v2.DeleteAudienceRequest
 */
export type DeleteAudienceRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message abacus.v2.DeleteAudienceRequest.
 * Use `create(DeleteAudienceRequestSchema)` to create a new message.
 */
export const DeleteAudienceRequestSchema: GenMessage<DeleteAudienceRequest, { jsonType: DeleteAudienceRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 172);

/**
 * @generated from message abacus.v2.DeleteAudienceResponse
 */
export type DeleteAudienceResponse = Message<"abacus.v2.DeleteAudienceResponse"> & {};

/**
 * @generated from message abacus.v2.DeleteAudienceResponse
 */
export type DeleteAudienceResponseJson = {};

/**
 * Describes the message abacus.v2.DeleteAudienceResponse.
 * Use `create(DeleteAudienceResponseSchema)` to create a new message.
 */
export const DeleteAudienceResponseSchema: GenMessage<DeleteAudienceResponse, { jsonType: DeleteAudienceResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 173);

/**
 * @generated from message abacus.v2.CalculateAudienceRequest
 */
export type CalculateAudienceRequest = Message<"abacus.v2.CalculateAudienceRequest"> & {
	/**
	 * @generated from oneof abacus.v2.CalculateAudienceRequest.calulator
	 */
	calulator:
		| {
				/**
				 * @generated from field: string id = 1;
				 */
				value: string;
				case: "id";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.Calculable calculable = 2;
				 */
				value: Calculable;
				case: "calculable";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message abacus.v2.CalculateAudienceRequest
 */
export type CalculateAudienceRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: abacus.v2.Calculable calculable = 2;
	 */
	calculable?: CalculableJson;
};

/**
 * Describes the message abacus.v2.CalculateAudienceRequest.
 * Use `create(CalculateAudienceRequestSchema)` to create a new message.
 */
export const CalculateAudienceRequestSchema: GenMessage<CalculateAudienceRequest, { jsonType: CalculateAudienceRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 174);

/**
 * @generated from message abacus.v2.CalculateAudienceResponse
 */
export type CalculateAudienceResponse = Message<"abacus.v2.CalculateAudienceResponse"> & {
	/**
	 * @generated from field: abacus.v2.Audience audience = 1;
	 */
	audience?: Audience | undefined;
};

/**
 * @generated from message abacus.v2.CalculateAudienceResponse
 */
export type CalculateAudienceResponseJson = {
	/**
	 * @generated from field: abacus.v2.Audience audience = 1;
	 */
	audience?: AudienceJson;
};

/**
 * Describes the message abacus.v2.CalculateAudienceResponse.
 * Use `create(CalculateAudienceResponseSchema)` to create a new message.
 */
export const CalculateAudienceResponseSchema: GenMessage<CalculateAudienceResponse, { jsonType: CalculateAudienceResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 175);

/**
 * @generated from message abacus.v2.RunAudienceRequest
 */
export type RunAudienceRequest = Message<"abacus.v2.RunAudienceRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message abacus.v2.RunAudienceRequest
 */
export type RunAudienceRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message abacus.v2.RunAudienceRequest.
 * Use `create(RunAudienceRequestSchema)` to create a new message.
 */
export const RunAudienceRequestSchema: GenMessage<RunAudienceRequest, { jsonType: RunAudienceRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 176);

/**
 * @generated from message abacus.v2.RunAudienceResponse
 */
export type RunAudienceResponse = Message<"abacus.v2.RunAudienceResponse"> & {
	/**
	 * @generated from field: string run_id = 1;
	 */
	runId: string;
};

/**
 * @generated from message abacus.v2.RunAudienceResponse
 */
export type RunAudienceResponseJson = {
	/**
	 * @generated from field: string run_id = 1;
	 */
	runId?: string;
};

/**
 * Describes the message abacus.v2.RunAudienceResponse.
 * Use `create(RunAudienceResponseSchema)` to create a new message.
 */
export const RunAudienceResponseSchema: GenMessage<RunAudienceResponse, { jsonType: RunAudienceResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 177);

/**
 * @generated from message abacus.v2.ListAudienceMembersRequest
 */
export type ListAudienceMembersRequest = Message<"abacus.v2.ListAudienceMembersRequest"> & {
	/**
	 * @generated from field: string audience_id = 1;
	 */
	audienceId: string;

	/**
	 * @generated from field: string run_id = 2;
	 */
	runId: string;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 3;
	 */
	pagination?: PaginationArguments | undefined;
};

/**
 * @generated from message abacus.v2.ListAudienceMembersRequest
 */
export type ListAudienceMembersRequestJson = {
	/**
	 * @generated from field: string audience_id = 1;
	 */
	audienceId?: string;

	/**
	 * @generated from field: string run_id = 2;
	 */
	runId?: string;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 3;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message abacus.v2.ListAudienceMembersRequest.
 * Use `create(ListAudienceMembersRequestSchema)` to create a new message.
 */
export const ListAudienceMembersRequestSchema: GenMessage<ListAudienceMembersRequest, { jsonType: ListAudienceMembersRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 178);

/**
 * @generated from message abacus.v2.ListAudienceMembersResponse
 */
export type ListAudienceMembersResponse = Message<"abacus.v2.ListAudienceMembersResponse"> & {
	/**
	 * @generated from field: repeated abacus.v2.AudienceMember members = 1;
	 */
	members: AudienceMember[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message abacus.v2.ListAudienceMembersResponse
 */
export type ListAudienceMembersResponseJson = {
	/**
	 * @generated from field: repeated abacus.v2.AudienceMember members = 1;
	 */
	members?: AudienceMemberJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message abacus.v2.ListAudienceMembersResponse.
 * Use `create(ListAudienceMembersResponseSchema)` to create a new message.
 */
export const ListAudienceMembersResponseSchema: GenMessage<ListAudienceMembersResponse, { jsonType: ListAudienceMembersResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 179);

/**
 * @generated from message abacus.v2.GetAudienceMembershipRequest
 */
export type GetAudienceMembershipRequest = Message<"abacus.v2.GetAudienceMembershipRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string cookie = 3;
	 */
	cookie: string;
};

/**
 * @generated from message abacus.v2.GetAudienceMembershipRequest
 */
export type GetAudienceMembershipRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string cookie = 3;
	 */
	cookie?: string;
};

/**
 * Describes the message abacus.v2.GetAudienceMembershipRequest.
 * Use `create(GetAudienceMembershipRequestSchema)` to create a new message.
 */
export const GetAudienceMembershipRequestSchema: GenMessage<GetAudienceMembershipRequest, { jsonType: GetAudienceMembershipRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 180);

/**
 * @generated from message abacus.v2.GetAudienceMembershipResponse
 */
export type GetAudienceMembershipResponse = Message<"abacus.v2.GetAudienceMembershipResponse"> & {
	/**
	 * @generated from field: repeated string audience_ids = 1;
	 */
	audienceIds: string[];
};

/**
 * @generated from message abacus.v2.GetAudienceMembershipResponse
 */
export type GetAudienceMembershipResponseJson = {
	/**
	 * @generated from field: repeated string audience_ids = 1;
	 */
	audienceIds?: string[];
};

/**
 * Describes the message abacus.v2.GetAudienceMembershipResponse.
 * Use `create(GetAudienceMembershipResponseSchema)` to create a new message.
 */
export const GetAudienceMembershipResponseSchema: GenMessage<GetAudienceMembershipResponse, { jsonType: GetAudienceMembershipResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_abacus, 181);

/**
 * Time interval
 *
 * @generated from enum abacus.v2.Interval
 */
export enum Interval {
	/**
	 * @generated from enum value: INTERVAL_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * All-time lookback.
	 *
	 * @generated from enum value: INTERVAL_ALL_TIME = 1;
	 */
	ALL_TIME = 1,

	/**
	 * Events from today.
	 *
	 * @generated from enum value: INTERVAL_TODAY = 2;
	 */
	TODAY = 2,

	/**
	 * Events from yesterday.
	 *
	 * @generated from enum value: INTERVAL_YESTERDAY = 3;
	 */
	YESTERDAY = 3,

	/**
	 * Events from last week.
	 *
	 * @generated from enum value: INTERVAL_LAST_WEEK = 4;
	 */
	LAST_WEEK = 4,

	/**
	 * Events from last month.
	 *
	 * @generated from enum value: INTERVAL_LAST_MONTH = 10;
	 */
	LAST_MONTH = 10,

	/**
	 * Events from the last 7 days.
	 *
	 * @generated from enum value: INTERVAL_LAST_7_DAYS = 5;
	 */
	LAST_7_DAYS = 5,

	/**
	 * Events from the last 30 days.
	 *
	 * @generated from enum value: INTERVAL_LAST_30_DAYS = 6;
	 */
	LAST_30_DAYS = 6,

	/**
	 * Events from the last 90 days.
	 *
	 * @generated from enum value: INTERVAL_LAST_90_DAYS = 7;
	 */
	LAST_90_DAYS = 7,

	/**
	 * Events from the last 365 days.
	 *
	 * @generated from enum value: INTERVAL_LAST_365_DAYS = 9;
	 */
	LAST_365_DAYS = 9,

	/**
	 * Custom event interval.
	 *
	 * @generated from enum value: INTERVAL_CUSTOM = 8;
	 */
	CUSTOM = 8,
}

/**
 * Time interval
 *
 * @generated from enum abacus.v2.Interval
 */
export type IntervalJson = "INTERVAL_UNSPECIFIED" | "INTERVAL_ALL_TIME" | "INTERVAL_TODAY" | "INTERVAL_YESTERDAY" | "INTERVAL_LAST_WEEK" | "INTERVAL_LAST_MONTH" | "INTERVAL_LAST_7_DAYS" | "INTERVAL_LAST_30_DAYS" | "INTERVAL_LAST_90_DAYS" | "INTERVAL_LAST_365_DAYS" | "INTERVAL_CUSTOM";

/**
 * Describes the enum abacus.v2.Interval.
 */
export const IntervalSchema: GenEnum<Interval, IntervalJson> = /*@__PURE__*/ enumDesc(file_abacus_v2_abacus, 0);

/**
 * Period from which event data is queried.
 *
 * @generated from enum abacus.v2.Period
 */
export enum Period {
	/**
	 * Period not specified.
	 *
	 * @generated from enum value: PERIOD_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * Events grouped per hour.
	 *
	 * @generated from enum value: PERIOD_HOUR = 1;
	 */
	HOUR = 1,

	/**
	 * Events grouped per day.
	 *
	 * @generated from enum value: PERIOD_DAY = 2;
	 */
	DAY = 2,

	/**
	 * Events grouped per week.
	 *
	 * @generated from enum value: PERIOD_WEEK = 3;
	 */
	WEEK = 3,

	/**
	 * Events grouped per month.
	 *
	 * @generated from enum value: PERIOD_MONTH = 4;
	 */
	MONTH = 4,

	/**
	 * Events grouped per year.
	 *
	 * @generated from enum value: PERIOD_YEAR = 5;
	 */
	YEAR = 5,
}

/**
 * Period from which event data is queried.
 *
 * @generated from enum abacus.v2.Period
 */
export type PeriodJson = "PERIOD_UNSPECIFIED" | "PERIOD_HOUR" | "PERIOD_DAY" | "PERIOD_WEEK" | "PERIOD_MONTH" | "PERIOD_YEAR";

/**
 * Describes the enum abacus.v2.Period.
 */
export const PeriodSchema: GenEnum<Period, PeriodJson> = /*@__PURE__*/ enumDesc(file_abacus_v2_abacus, 1);

/**
 * GeoAdminLevel specifies the level of granularity
 * for geolocation data.
 *
 * @generated from enum abacus.v2.GeoAdminLevel
 */
export enum GeoAdminLevel {
	/**
	 * GeoAdminLevel unspecified.
	 *
	 * @generated from enum value: GEO_ADMIN_LEVEL_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * GeoAdminLevel state.
	 *
	 * @generated from enum value: GEO_ADMIN_LEVEL_ADMINISTRATIVE_AREA = 1;
	 */
	ADMINISTRATIVE_AREA = 1,

	/**
	 * GeoAdminLevel postal code.
	 *
	 * @generated from enum value: GEO_ADMIN_LEVEL_POSTAL_CODE = 2;
	 */
	POSTAL_CODE = 2,
}

/**
 * GeoAdminLevel specifies the level of granularity
 * for geolocation data.
 *
 * @generated from enum abacus.v2.GeoAdminLevel
 */
export type GeoAdminLevelJson = "GEO_ADMIN_LEVEL_UNSPECIFIED" | "GEO_ADMIN_LEVEL_ADMINISTRATIVE_AREA" | "GEO_ADMIN_LEVEL_POSTAL_CODE";

/**
 * Describes the enum abacus.v2.GeoAdminLevel.
 */
export const GeoAdminLevelSchema: GenEnum<GeoAdminLevel, GeoAdminLevelJson> = /*@__PURE__*/ enumDesc(file_abacus_v2_abacus, 2);

/**
 * UserSegmentType specifies the level of granularity
 * for user segments.
 *
 * @generated from enum abacus.v2.UserSegmentType
 */
export enum UserSegmentType {
	/**
	 * UserSegmentType unspecified.
	 *
	 * @generated from enum value: USER_SEGMENT_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * UserSegmentType identified users.
	 *
	 * @generated from enum value: USER_SEGMENT_TYPE_IDENTIFIED = 1;
	 */
	IDENTIFIED = 1,

	/**
	 * UserSegementType engagementLevel segment
	 * by level of engagement.
	 *
	 * @generated from enum value: USER_SEGMENT_TYPE_ENGAGEMENT_LEVEL = 2;
	 */
	ENGAGEMENT_LEVEL = 2,

	/**
	 * UserSegmentType conversionType segment
	 * by conversion type.
	 *
	 * @generated from enum value: USER_SEGMENT_TYPE_CONVERSION_TYPE = 3;
	 */
	CONVERSION_TYPE = 3,

	/**
	 * UserSegmentType age segment by age
	 *
	 * @generated from enum value: USER_SEGMENT_TYPE_AGE = 4;
	 */
	AGE = 4,

	/**
	 * UserSegmentType householdIncome segment
	 * by household income
	 *
	 * @generated from enum value: USER_SEGMENT_TYPE_HOUSEHOLD_INCOME = 5;
	 */
	HOUSEHOLD_INCOME = 5,

	/**
	 * UserSegmentType ethnicity segment by
	 * ethnicity
	 *
	 * @generated from enum value: USER_SEGMENT_TYPE_ETHNICITY = 6;
	 */
	ETHNICITY = 6,

	/**
	 * UserSegmentType occupationGroup segment
	 * by occupation group
	 *
	 * @generated from enum value: USER_SEGMENT_TYPE_OCCUPATION_GROUP = 7;
	 */
	OCCUPATION_GROUP = 7,

	/**
	 * UserSegmentType language segment by language
	 *
	 * @generated from enum value: USER_SEGMENT_TYPE_LANGUAGE = 8;
	 */
	LANGUAGE = 8,

	/**
	 * UserSegmentType gender segment by gender
	 *
	 * @generated from enum value: USER_SEGMENT_TYPE_GENDER = 9;
	 */
	GENDER = 9,

	/**
	 * UserSegmentType highestEducation segment by
	 * highest education
	 *
	 * @generated from enum value: USER_SEGMENT_TYPE_HIGHEST_EDUCATION = 10;
	 */
	HIGHEST_EDUCATION = 10,

	/**
	 * UserSegmentType homeOwnership segment by
	 * home ownership
	 *
	 * @generated from enum value: USER_SEGMENT_TYPE_HOME_OWNERSHIP = 11;
	 */
	HOME_OWNERSHIP = 11,

	/**
	 * UserSegmentType childrenPresence segment by
	 * presence of children
	 *
	 * @generated from enum value: USER_SEGMENT_TYPE_CHILDREN_PRESENCE = 12;
	 */
	CHILDREN_PRESENCE = 12,

	/**
	 * UserSegmentType petOwnership segment by
	 * pet ownership
	 *
	 * @generated from enum value: USER_SEGMENT_TYPE_PET_OWNERSHIP = 13;
	 */
	PET_OWNERSHIP = 13,

	/**
	 * UserSegmentType flowId segment by cookie presence.
	 *
	 * @generated from enum value: USER_SEGMENT_TYPE_FLOW_ID = 14;
	 */
	FLOW_ID = 14,
}

/**
 * UserSegmentType specifies the level of granularity
 * for user segments.
 *
 * @generated from enum abacus.v2.UserSegmentType
 */
export type UserSegmentTypeJson =
	| "USER_SEGMENT_TYPE_UNSPECIFIED"
	| "USER_SEGMENT_TYPE_IDENTIFIED"
	| "USER_SEGMENT_TYPE_ENGAGEMENT_LEVEL"
	| "USER_SEGMENT_TYPE_CONVERSION_TYPE"
	| "USER_SEGMENT_TYPE_AGE"
	| "USER_SEGMENT_TYPE_HOUSEHOLD_INCOME"
	| "USER_SEGMENT_TYPE_ETHNICITY"
	| "USER_SEGMENT_TYPE_OCCUPATION_GROUP"
	| "USER_SEGMENT_TYPE_LANGUAGE"
	| "USER_SEGMENT_TYPE_GENDER"
	| "USER_SEGMENT_TYPE_HIGHEST_EDUCATION"
	| "USER_SEGMENT_TYPE_HOME_OWNERSHIP"
	| "USER_SEGMENT_TYPE_CHILDREN_PRESENCE"
	| "USER_SEGMENT_TYPE_PET_OWNERSHIP"
	| "USER_SEGMENT_TYPE_FLOW_ID";

/**
 * Describes the enum abacus.v2.UserSegmentType.
 */
export const UserSegmentTypeSchema: GenEnum<UserSegmentType, UserSegmentTypeJson> = /*@__PURE__*/ enumDesc(file_abacus_v2_abacus, 3);

/**
 * @generated from enum abacus.v2.UserSegmentFormat
 */
export enum UserSegmentFormat {
	/**
	 * @generated from enum value: USER_SEGMENT_FORMAT_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: USER_SEGMENT_FORMAT_PERCENT = 1;
	 */
	PERCENT = 1,

	/**
	 * @generated from enum value: USER_SEGMENT_FORMAT_COUNT = 2;
	 */
	COUNT = 2,
}

/**
 * @generated from enum abacus.v2.UserSegmentFormat
 */
export type UserSegmentFormatJson = "USER_SEGMENT_FORMAT_UNSPECIFIED" | "USER_SEGMENT_FORMAT_PERCENT" | "USER_SEGMENT_FORMAT_COUNT";

/**
 * Describes the enum abacus.v2.UserSegmentFormat.
 */
export const UserSegmentFormatSchema: GenEnum<UserSegmentFormat, UserSegmentFormatJson> = /*@__PURE__*/ enumDesc(file_abacus_v2_abacus, 4);

/**
 * ContactsFilterType specifies filter types for audiences.
 *
 * @generated from enum abacus.v2.ContactsFilterType
 */
export enum ContactsFilterType {
	/**
	 * Unspecified, or no filter.
	 *
	 * @generated from enum value: CONTACTS_FILTER_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * Filter by suite.
	 *
	 * @generated from enum value: CONTACTS_FILTER_TYPE_SUITE = 1;
	 */
	SUITE = 1,

	/**
	 * Filter by conversionType.
	 *
	 * @generated from enum value: CONTACTS_FILTER_TYPE_CONVERSION_TYPE = 2;
	 */
	CONVERSION_TYPE = 2,

	/**
	 * Filter by interactionType.
	 *
	 * @generated from enum value: CONTACTS_FILTER_TYPE_INTERACTION_TYPE = 3;
	 */
	INTERACTION_TYPE = 3,

	/**
	 * Filter by city.
	 *
	 * @generated from enum value: CONTACTS_FILTER_TYPE_CITY = 4;
	 */
	CITY = 4,

	/**
	 * Filter by state.
	 *
	 * @generated from enum value: CONTACTS_FILTER_TYPE_STATE = 5;
	 */
	STATE = 5,

	/**
	 * Filter by postal code.
	 *
	 * @generated from enum value: CONTACTS_FILTER_TYPE_POSTAL_CODE = 6;
	 */
	POSTAL_CODE = 6,

	/**
	 * Filter by engagement level.
	 *
	 * @generated from enum value: CONTACTS_FILTER_TYPE_ENGAGEMENT_LEVEL = 7;
	 */
	ENGAGEMENT_LEVEL = 7,

	/**
	 * Filter by entrypoint.
	 *
	 * @generated from enum value: CONTACTS_FILTER_TYPE_ENTRYPOINT = 8;
	 */
	ENTRYPOINT = 8,

	/**
	 * Filter by module.
	 *
	 * @generated from enum value: CONTACTS_FILTER_TYPE_MODULE = 9;
	 */
	MODULE = 9,

	/**
	 * Filter by contact property
	 *
	 * @generated from enum value: CONTACTS_FILTER_TYPE_CONTACT_PROPERTY = 10;
	 */
	CONTACT_PROPERTY = 10,

	/**
	 * Filter by integration
	 *
	 * @generated from enum value: CONTACTS_FILTER_TYPE_INTEGRATION = 11;
	 */
	INTEGRATION = 11,

	/**
	 * Filter by currency
	 *
	 * @generated from enum value: CONTACTS_FILTER_TYPE_CURRENCY = 12;
	 */
	CURRENCY = 12,

	/**
	 * Filter by event attendance
	 *
	 * @generated from enum value: CONTACTS_FILTER_TYPE_ATTENDANCE = 13;
	 */
	ATTENDANCE = 13,

	/**
	 * Filter by calendar attendance
	 *
	 * @generated from enum value: CONTACTS_FILTER_TYPE_ATTENDANCE_CALENDAR = 14;
	 */
	ATTENDANCE_CALENDAR = 14,
}

/**
 * ContactsFilterType specifies filter types for audiences.
 *
 * @generated from enum abacus.v2.ContactsFilterType
 */
export type ContactsFilterTypeJson =
	| "CONTACTS_FILTER_TYPE_UNSPECIFIED"
	| "CONTACTS_FILTER_TYPE_SUITE"
	| "CONTACTS_FILTER_TYPE_CONVERSION_TYPE"
	| "CONTACTS_FILTER_TYPE_INTERACTION_TYPE"
	| "CONTACTS_FILTER_TYPE_CITY"
	| "CONTACTS_FILTER_TYPE_STATE"
	| "CONTACTS_FILTER_TYPE_POSTAL_CODE"
	| "CONTACTS_FILTER_TYPE_ENGAGEMENT_LEVEL"
	| "CONTACTS_FILTER_TYPE_ENTRYPOINT"
	| "CONTACTS_FILTER_TYPE_MODULE"
	| "CONTACTS_FILTER_TYPE_CONTACT_PROPERTY"
	| "CONTACTS_FILTER_TYPE_INTEGRATION"
	| "CONTACTS_FILTER_TYPE_CURRENCY"
	| "CONTACTS_FILTER_TYPE_ATTENDANCE"
	| "CONTACTS_FILTER_TYPE_ATTENDANCE_CALENDAR";

/**
 * Describes the enum abacus.v2.ContactsFilterType.
 */
export const ContactsFilterTypeSchema: GenEnum<ContactsFilterType, ContactsFilterTypeJson> = /*@__PURE__*/ enumDesc(file_abacus_v2_abacus, 5);

/**
 * Level 1 should be used to represent lowest or least favorable segment.
 *
 * @generated from enum abacus.v2.SegmentLevel
 */
export enum SegmentLevel {
	/**
	 * Unspecified or no segment filter.
	 *
	 * @generated from enum value: SEGMENT_LEVEL_UNSPECIFIED = 0;
	 */
	SEGMENT_LEVEL_UNSPECIFIED = 0,

	/**
	 * Lowest or least favorable segment.
	 *
	 * @generated from enum value: SEGMENT_LEVEL_1 = 1;
	 */
	SEGMENT_LEVEL_1 = 1,

	/**
	 * Medium segment.
	 *
	 * @generated from enum value: SEGMENT_LEVEL_2 = 2;
	 */
	SEGMENT_LEVEL_2 = 2,

	/**
	 * Highest segment.
	 *
	 * @generated from enum value: SEGMENT_LEVEL_3 = 3;
	 */
	SEGMENT_LEVEL_3 = 3,
}

/**
 * Level 1 should be used to represent lowest or least favorable segment.
 *
 * @generated from enum abacus.v2.SegmentLevel
 */
export type SegmentLevelJson = "SEGMENT_LEVEL_UNSPECIFIED" | "SEGMENT_LEVEL_1" | "SEGMENT_LEVEL_2" | "SEGMENT_LEVEL_3";

/**
 * Describes the enum abacus.v2.SegmentLevel.
 */
export const SegmentLevelSchema: GenEnum<SegmentLevel, SegmentLevelJson> = /*@__PURE__*/ enumDesc(file_abacus_v2_abacus, 6);

/**
 * Operator is used for boolean expressions.
 *
 * @generated from enum abacus.v2.Operator
 */
export enum Operator {
	/**
	 * No operator.
	 *
	 * @generated from enum value: OPERATOR_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * AND operator.
	 *
	 * @generated from enum value: OPERATOR_AND = 1;
	 */
	AND = 1,

	/**
	 * OR operator.
	 *
	 * @generated from enum value: OPERATOR_OR = 2;
	 */
	OR = 2,
}

/**
 * Operator is used for boolean expressions.
 *
 * @generated from enum abacus.v2.Operator
 */
export type OperatorJson = "OPERATOR_UNSPECIFIED" | "OPERATOR_AND" | "OPERATOR_OR";

/**
 * Describes the enum abacus.v2.Operator.
 */
export const OperatorSchema: GenEnum<Operator, OperatorJson> = /*@__PURE__*/ enumDesc(file_abacus_v2_abacus, 7);

/**
 * @generated from enum abacus.v2.AudienceType
 */
export enum AudienceType {
	/**
	 * @generated from enum value: AUDIENCE_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: AUDIENCE_TYPE_CONTACTS = 1;
	 */
	CONTACTS = 1,
}

/**
 * @generated from enum abacus.v2.AudienceType
 */
export type AudienceTypeJson = "AUDIENCE_TYPE_UNSPECIFIED" | "AUDIENCE_TYPE_CONTACTS";

/**
 * Describes the enum abacus.v2.AudienceType.
 */
export const AudienceTypeSchema: GenEnum<AudienceType, AudienceTypeJson> = /*@__PURE__*/ enumDesc(file_abacus_v2_abacus, 8);

/**
 * VerifiedSource records why an event's is_verified flag holds its current value.
 *
 * @generated from enum abacus.v2.VerifiedSource
 */
export enum VerifiedSource {
	/**
	 * Written before provenance was tracked.
	 *
	 * @generated from enum value: VERIFIED_SOURCE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * Asserted by the producer on the incoming event.
	 *
	 * @generated from enum value: VERIFIED_SOURCE_PRODUCER = 1;
	 */
	PRODUCER = 1,

	/**
	 * The contact was explicitly verified.
	 *
	 * @generated from enum value: VERIFIED_SOURCE_CONTACT = 2;
	 */
	CONTACT = 2,

	/**
	 * Aged out by the unverified-event TTL.
	 *
	 * @generated from enum value: VERIFIED_SOURCE_TTL = 3;
	 */
	TTL = 3,
}

/**
 * VerifiedSource records why an event's is_verified flag holds its current value.
 *
 * @generated from enum abacus.v2.VerifiedSource
 */
export type VerifiedSourceJson = "VERIFIED_SOURCE_UNSPECIFIED" | "VERIFIED_SOURCE_PRODUCER" | "VERIFIED_SOURCE_CONTACT" | "VERIFIED_SOURCE_TTL";

/**
 * Describes the enum abacus.v2.VerifiedSource.
 */
export const VerifiedSourceSchema: GenEnum<VerifiedSource, VerifiedSourceJson> = /*@__PURE__*/ enumDesc(file_abacus_v2_abacus, 9);

/**
 * ExportSource is the source an export was run from
 *
 * @generated from enum abacus.v2.ExportSource
 */
export enum ExportSource {
	/**
	 * @generated from enum value: EXPORT_SOURCE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: EXPORT_SOURCE_DASHBOARD = 1;
	 */
	DASHBOARD = 1,

	/**
	 * @generated from enum value: EXPORT_SOURCE_FLOW_RESULTS = 2;
	 */
	FLOW_RESULTS = 2,

	/**
	 * @generated from enum value: EXPORT_SOURCE_TABLE = 3;
	 */
	TABLE = 3,

	/**
	 * @generated from enum value: EXPORT_SOURCE_CONTACTS = 4;
	 */
	CONTACTS = 4,

	/**
	 * @generated from enum value: EXPORT_SOURCE_ANALYTICS = 5;
	 */
	ANALYTICS = 5,

	/**
	 * @generated from enum value: EXPORT_SOURCE_FLOW_ANALYTICS = 6;
	 */
	FLOW_ANALYTICS = 6,

	/**
	 * @generated from enum value: EXPORT_SOURCE_ORG_ANALYTICS = 7;
	 */
	ORG_ANALYTICS = 7,

	/**
	 * @generated from enum value: EXPORT_SOURCE_ORG_CONTACTS = 8;
	 */
	ORG_CONTACTS = 8,
}

/**
 * ExportSource is the source an export was run from
 *
 * @generated from enum abacus.v2.ExportSource
 */
export type ExportSourceJson = "EXPORT_SOURCE_UNSPECIFIED" | "EXPORT_SOURCE_DASHBOARD" | "EXPORT_SOURCE_FLOW_RESULTS" | "EXPORT_SOURCE_TABLE" | "EXPORT_SOURCE_CONTACTS" | "EXPORT_SOURCE_ANALYTICS" | "EXPORT_SOURCE_FLOW_ANALYTICS" | "EXPORT_SOURCE_ORG_ANALYTICS" | "EXPORT_SOURCE_ORG_CONTACTS";

/**
 * Describes the enum abacus.v2.ExportSource.
 */
export const ExportSourceSchema: GenEnum<ExportSource, ExportSourceJson> = /*@__PURE__*/ enumDesc(file_abacus_v2_abacus, 10);

/**
 * @generated from enum abacus.v2.ChartType
 */
export enum ChartType {
	/**
	 * @generated from enum value: CHART_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: CHART_TYPE_BAR = 1;
	 */
	BAR = 1,

	/**
	 * @generated from enum value: CHART_TYPE_LINE = 2;
	 */
	LINE = 2,

	/**
	 * @generated from enum value: CHART_TYPE_PIE = 3;
	 */
	PIE = 3,

	/**
	 * @generated from enum value: CHART_TYPE_DONUT = 8;
	 */
	DONUT = 8,

	/**
	 * @generated from enum value: CHART_TYPE_TABLE = 4;
	 */
	TABLE = 4,

	/**
	 * @generated from enum value: CHART_TYPE_TOTAL = 5;
	 */
	TOTAL = 5,

	/**
	 * @generated from enum value: CHART_TYPE_HEATMAP = 6;
	 */
	HEATMAP = 6,

	/**
	 * @generated from enum value: CHART_TYPE_GEO_MAP = 7;
	 */
	GEO_MAP = 7,

	/**
	 * @generated from enum value: CHART_TYPE_DEMOGRAPHICS = 9;
	 */
	DEMOGRAPHICS = 9,
}

/**
 * @generated from enum abacus.v2.ChartType
 */
export type ChartTypeJson = "CHART_TYPE_UNSPECIFIED" | "CHART_TYPE_BAR" | "CHART_TYPE_LINE" | "CHART_TYPE_PIE" | "CHART_TYPE_DONUT" | "CHART_TYPE_TABLE" | "CHART_TYPE_TOTAL" | "CHART_TYPE_HEATMAP" | "CHART_TYPE_GEO_MAP" | "CHART_TYPE_DEMOGRAPHICS";

/**
 * Describes the enum abacus.v2.ChartType.
 */
export const ChartTypeSchema: GenEnum<ChartType, ChartTypeJson> = /*@__PURE__*/ enumDesc(file_abacus_v2_abacus, 11);

/**
 * @generated from enum abacus.v2.SchemaPropertyType
 */
export enum SchemaPropertyType {
	/**
	 * @generated from enum value: SCHEMA_PROPERTY_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: SCHEMA_PROPERTY_TYPE_NUMBER = 1;
	 */
	NUMBER = 1,

	/**
	 * @generated from enum value: SCHEMA_PROPERTY_TYPE_STRING = 2;
	 */
	STRING = 2,

	/**
	 * @generated from enum value: SCHEMA_PROPERTY_TYPE_BOOL = 3;
	 */
	BOOL = 3,

	/**
	 * @generated from enum value: SCHEMA_PROPERTY_TYPE_STRUCT = 4 [deprecated = true];
	 * @deprecated
	 */
	STRUCT = 4,

	/**
	 * @generated from enum value: SCHEMA_PROPERTY_TYPE_LIST = 5 [deprecated = true];
	 * @deprecated
	 */
	LIST = 5,

	/**
	 * @generated from enum value: SCHEMA_PROPERTY_TYPE_EMAIL = 6;
	 */
	EMAIL = 6,

	/**
	 * @generated from enum value: SCHEMA_PROPERTY_TYPE_PHONE = 7;
	 */
	PHONE = 7,

	/**
	 * @generated from enum value: SCHEMA_PROPERTY_TYPE_ADDRESS = 8;
	 */
	ADDRESS = 8,

	/**
	 * @generated from enum value: SCHEMA_PROPERTY_TYPE_URL = 9;
	 */
	URL = 9,

	/**
	 * @generated from enum value: SCHEMA_PROPERTY_TYPE_DATE = 10;
	 */
	DATE = 10,

	/**
	 * @generated from enum value: SCHEMA_PROPERTY_TYPE_OBJECT = 11;
	 */
	OBJECT = 11,

	/**
	 * @generated from enum value: SCHEMA_PROPERTY_TYPE_ARRAY = 12;
	 */
	ARRAY = 12,

	/**
	 * @generated from enum value: SCHEMA_PROPERTY_TYPE_NAME_FULL = 13;
	 */
	NAME_FULL = 13,
}

/**
 * @generated from enum abacus.v2.SchemaPropertyType
 */
export type SchemaPropertyTypeJson =
	| "SCHEMA_PROPERTY_TYPE_UNSPECIFIED"
	| "SCHEMA_PROPERTY_TYPE_NUMBER"
	| "SCHEMA_PROPERTY_TYPE_STRING"
	| "SCHEMA_PROPERTY_TYPE_BOOL"
	| "SCHEMA_PROPERTY_TYPE_STRUCT"
	| "SCHEMA_PROPERTY_TYPE_LIST"
	| "SCHEMA_PROPERTY_TYPE_EMAIL"
	| "SCHEMA_PROPERTY_TYPE_PHONE"
	| "SCHEMA_PROPERTY_TYPE_ADDRESS"
	| "SCHEMA_PROPERTY_TYPE_URL"
	| "SCHEMA_PROPERTY_TYPE_DATE"
	| "SCHEMA_PROPERTY_TYPE_OBJECT"
	| "SCHEMA_PROPERTY_TYPE_ARRAY"
	| "SCHEMA_PROPERTY_TYPE_NAME_FULL";

/**
 * Describes the enum abacus.v2.SchemaPropertyType.
 */
export const SchemaPropertyTypeSchema: GenEnum<SchemaPropertyType, SchemaPropertyTypeJson> = /*@__PURE__*/ enumDesc(file_abacus_v2_abacus, 12);

/**
 * Describes the presence of the property within a given schema
 *
 * @generated from enum abacus.v2.SchemaPropertyPresence
 */
export enum SchemaPropertyPresence {
	/**
	 * @generated from enum value: SCHEMA_PROPERTY_PRESENCE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * Optional -- consumers can add/remove the property within its given schema
	 *
	 * @generated from enum value: SCHEMA_PROPERTY_PRESENCE_OPTIONAL = 1;
	 */
	OPTIONAL = 1,

	/**
	 * Locked -- the property is locked in its schema and cannot be removed
	 *
	 * @generated from enum value: SCHEMA_PROPERTY_PRESENCE_DEFAULT_LOCKED = 2;
	 */
	DEFAULT_LOCKED = 2,
}

/**
 * Describes the presence of the property within a given schema
 *
 * @generated from enum abacus.v2.SchemaPropertyPresence
 */
export type SchemaPropertyPresenceJson = "SCHEMA_PROPERTY_PRESENCE_UNSPECIFIED" | "SCHEMA_PROPERTY_PRESENCE_OPTIONAL" | "SCHEMA_PROPERTY_PRESENCE_DEFAULT_LOCKED";

/**
 * Describes the enum abacus.v2.SchemaPropertyPresence.
 */
export const SchemaPropertyPresenceSchema: GenEnum<SchemaPropertyPresence, SchemaPropertyPresenceJson> = /*@__PURE__*/ enumDesc(file_abacus_v2_abacus, 13);

/**
 * Scope describes the scope of the property within its schema
 *
 * @generated from enum abacus.v2.SchemaPropertyScope
 */
export enum SchemaPropertyScope {
	/**
	 * @generated from enum value: SCHEMA_PROPERTY_SCOPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * Workspace-scoped -- its presence and attributes are managed by workspace members
	 *
	 * @generated from enum value: SCHEMA_PROPERTY_SCOPE_WORKSPACE = 1;
	 */
	WORKSPACE = 1,

	/**
	 * Global-scoped -- its presence and attributes are determined by the system
	 *
	 * @generated from enum value: SCHEMA_PROPERTY_SCOPE_GLOBAL = 2;
	 */
	GLOBAL = 2,
}

/**
 * Scope describes the scope of the property within its schema
 *
 * @generated from enum abacus.v2.SchemaPropertyScope
 */
export type SchemaPropertyScopeJson = "SCHEMA_PROPERTY_SCOPE_UNSPECIFIED" | "SCHEMA_PROPERTY_SCOPE_WORKSPACE" | "SCHEMA_PROPERTY_SCOPE_GLOBAL";

/**
 * Describes the enum abacus.v2.SchemaPropertyScope.
 */
export const SchemaPropertyScopeSchema: GenEnum<SchemaPropertyScope, SchemaPropertyScopeJson> = /*@__PURE__*/ enumDesc(file_abacus_v2_abacus, 14);

/**
 * @generated from service abacus.v2.AbacusService
 */
export const AbacusService: GenService<{
	/**
	 * @generated from rpc abacus.v2.AbacusService.ListContacts
	 */
	listContacts: {
		methodKind: "unary";
		input: typeof ListContactsRequestSchema;
		output: typeof ListContactsResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.ListActivity
	 */
	listActivity: {
		methodKind: "unary";
		input: typeof ListActivityRequestSchema;
		output: typeof ListActivityResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.ListConversionRates
	 */
	listConversionRates: {
		methodKind: "unary";
		input: typeof ListConversionRatesRequestSchema;
		output: typeof ListConversionRatesResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.ListConversionsByConsumer
	 */
	listConversionsByConsumer: {
		methodKind: "unary";
		input: typeof ListConversionsByConsumerRequestSchema;
		output: typeof ListConversionsByConsumerResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.ListFormFields
	 */
	listFormFields: {
		methodKind: "unary";
		input: typeof ListFormFieldsRequestSchema;
		output: typeof ListFormFieldsResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.ListForms
	 */
	listForms: {
		methodKind: "unary";
		input: typeof ListFormsRequestSchema;
		output: typeof ListFormsResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.ListProducts
	 */
	listProducts: {
		methodKind: "unary";
		input: typeof ListProductsRequestSchema;
		output: typeof ListProductsResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.ListMetadataKeys
	 */
	listMetadataKeys: {
		methodKind: "unary";
		input: typeof ListMetadataKeysRequestSchema;
		output: typeof ListMetadataKeysResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.ListUserSegments
	 */
	listUserSegments: {
		methodKind: "unary";
		input: typeof ListUserSegmentsRequestSchema;
		output: typeof ListUserSegmentsResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.GetContact
	 */
	getContact: {
		methodKind: "unary";
		input: typeof GetContactRequestSchema;
		output: typeof GetContactResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.GetContactPropertiesFromSessions
	 */
	getContactPropertiesFromSessions: {
		methodKind: "unary";
		input: typeof GetContactPropertiesFromSessionsRequestSchema;
		output: typeof GetContactPropertiesFromSessionsResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.GetConversionRateTotals
	 */
	getConversionRateTotals: {
		methodKind: "unary";
		input: typeof GetConversionRateTotalsRequestSchema;
		output: typeof GetConversionRateTotalsResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.GetContactsSummary
	 */
	getContactsSummary: {
		methodKind: "unary";
		input: typeof GetContactsSummaryRequestSchema;
		output: typeof GetContactsSummaryResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.GetConversionRateSummary
	 */
	getConversionRateSummary: {
		methodKind: "unary";
		input: typeof GetConversionRateSummaryRequestSchema;
		output: typeof GetConversionRateSummaryResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.GetConversionTypeSummary
	 */
	getConversionTypeSummary: {
		methodKind: "unary";
		input: typeof GetConversionTypeSummaryRequestSchema;
		output: typeof GetConversionTypeSummaryResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.GetRevenueSummary
	 */
	getRevenueSummary: {
		methodKind: "unary";
		input: typeof GetRevenueSummaryRequestSchema;
		output: typeof GetRevenueSummaryResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.GetGeoSummary
	 */
	getGeoSummary: {
		methodKind: "unary";
		input: typeof GetGeoSummaryRequestSchema;
		output: typeof GetGeoSummaryResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.GetAudienceSummary
	 */
	getAudienceSummary: {
		methodKind: "unary";
		input: typeof GetAudienceSummaryRequestSchema;
		output: typeof GetAudienceSummaryResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.GetExperimentSummary
	 */
	getExperimentSummary: {
		methodKind: "unary";
		input: typeof GetExperimentSummaryRequestSchema;
		output: typeof GetExperimentSummaryResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.GetContactsFilterOptions
	 */
	getContactsFilterOptions: {
		methodKind: "unary";
		input: typeof GetContactsFilterOptionsRequestSchema;
		output: typeof GetContactsFilterOptionsResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.GetRowCount
	 */
	getRowCount: {
		methodKind: "unary";
		input: typeof GetRowCountRequestSchema;
		output: typeof GetRowCountResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.StreamCsvFile
	 */
	streamCsvFile: {
		methodKind: "server_streaming";
		input: typeof StreamCsvFileRequestSchema;
		output: typeof StreamCsvFileResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.StreamZipFile
	 */
	streamZipFile: {
		methodKind: "unary";
		input: typeof StreamZipFileRequestSchema;
		output: typeof StreamZipFileResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.ExportZipFile
	 */
	exportZipFile: {
		methodKind: "unary";
		input: typeof ExportZipFileRequestSchema;
		output: typeof ExportZipFileResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.GetExportDownloadUrl
	 */
	getExportDownloadUrl: {
		methodKind: "unary";
		input: typeof GetExportDownloadUrlRequestSchema;
		output: typeof GetExportDownloadUrlResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.StreamPdfFile
	 */
	streamPdfFile: {
		methodKind: "unary";
		input: typeof StreamPdfFileRequestSchema;
		output: typeof StreamPdfFileResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.DeleteEvents
	 */
	deleteEvents: {
		methodKind: "unary";
		input: typeof DeleteEventsRequestSchema;
		output: typeof DeleteEventsResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.GetContactSchema
	 */
	getContactSchema: {
		methodKind: "unary";
		input: typeof GetContactSchemaRequestSchema;
		output: typeof GetContactSchemaResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.CreateContactSchema
	 */
	createContactSchema: {
		methodKind: "unary";
		input: typeof CreateContactSchemaRequestSchema;
		output: typeof CreateContactSchemaResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.UpdateContactSchema
	 */
	updateContactSchema: {
		methodKind: "unary";
		input: typeof UpdateContactSchemaRequestSchema;
		output: typeof UpdateContactSchemaResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.GetPrimaryIdentifierCounts
	 */
	getPrimaryIdentifierCounts: {
		methodKind: "unary";
		input: typeof GetPrimaryIdentifierCountsRequestSchema;
		output: typeof GetPrimaryIdentifierCountsResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.CreateContact
	 */
	createContact: {
		methodKind: "unary";
		input: typeof CreateContactRequestSchema;
		output: typeof CreateContactResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.BulkImportContacts
	 */
	bulkImportContacts: {
		methodKind: "unary";
		input: typeof BulkImportContactsRequestSchema;
		output: typeof BulkImportContactsResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.VerifyContacts
	 */
	verifyContacts: {
		methodKind: "unary";
		input: typeof VerifyContactsRequestSchema;
		output: typeof VerifyContactsResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.HideContacts
	 */
	hideContacts: {
		methodKind: "unary";
		input: typeof HideContactsRequestSchema;
		output: typeof HideContactsResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.CreateAudience
	 */
	createAudience: {
		methodKind: "unary";
		input: typeof CreateAudienceRequestSchema;
		output: typeof CreateAudienceResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.DuplicateAudience
	 */
	duplicateAudience: {
		methodKind: "unary";
		input: typeof DuplicateAudienceRequestSchema;
		output: typeof DuplicateAudienceResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.GetAudience
	 */
	getAudience: {
		methodKind: "unary";
		input: typeof GetAudienceRequestSchema;
		output: typeof GetAudienceResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.ListAudiences
	 */
	listAudiences: {
		methodKind: "unary";
		input: typeof ListAudiencesRequestSchema;
		output: typeof ListAudiencesResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.UpdateAudience
	 */
	updateAudience: {
		methodKind: "unary";
		input: typeof UpdateAudienceRequestSchema;
		output: typeof UpdateAudienceResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.DeleteAudience
	 */
	deleteAudience: {
		methodKind: "unary";
		input: typeof DeleteAudienceRequestSchema;
		output: typeof DeleteAudienceResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.CalculateAudience
	 */
	calculateAudience: {
		methodKind: "unary";
		input: typeof CalculateAudienceRequestSchema;
		output: typeof CalculateAudienceResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.RunAudience
	 */
	runAudience: {
		methodKind: "unary";
		input: typeof RunAudienceRequestSchema;
		output: typeof RunAudienceResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.AbacusService.ListAudienceMembers
	 */
	listAudienceMembers: {
		methodKind: "unary";
		input: typeof ListAudienceMembersRequestSchema;
		output: typeof ListAudienceMembersResponseSchema;
	};
}> = /*@__PURE__*/ serviceDesc(file_abacus_v2_abacus, 0);
